import {
  Component,
  OnInit,
  ElementRef,
  Input,
  ViewChild,
  Renderer2,
  ChangeDetectorRef,
  ViewEncapsulation,
  OnDestroy,
} from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import {
  interval,
  map,
  Observable,
  of,
  startWith,
  Subject,
  Subscription,
  switchMap,
  takeUntil,
} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CollectionPopupComponent } from '../collections/collection-popup/collection-popup.component';
import { MatRadioChange } from '@angular/material/radio';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import * as moment from 'moment';
import { AuthService } from 'src/app/services/auth.service';
import { CountrycheckComponent } from '../taskcost/countrycheck/countrycheck.component';
import { ConfirmDialog } from '../taskcost/confirmdialog';
import { ThemeService } from 'src/app/services/theme.service';
import { DatePipe } from '@angular/common';
import { UtilsService } from 'src/app/services/utils.service';
import { PopupService } from 'src/app/services/popup.service';
import { WarningPopup } from '../taskcost/warning-popup/warning-popup';
import * as JSZip from 'jszip';
import * as toGeoJSON from 'togeojson';
import { OpenconfirmwarningComponent } from '../newtask/openconfirmwarning/openconfirmwarning.component';
var turf = require('@turf/turf');
var geoParse = require('wellknown');
import { baseLayers, overlays } from '../../config/baseLayer.js';
import * as L from 'leaflet';
import 'leaflet-draw';
import 'leaflet-arrowheads';
import 'leaflet-geometryutil';
import 'leaflet-polylinedecorator';
import { MatExpansionPanel } from '@angular/material/expansion';
import { NgxMaterialTimepickerComponent } from 'ngx-material-timepicker';
import { BudgetpopupComponent } from '../newtask/budgetpopup/budgetpopup.component';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import { UserService } from 'src/app/services/user.service';
import { OperatorPopupComponent } from '../taskcost/operator-popup/operator-popup.component';
import {
  MAX_RF_COLLECTION,
  MIN_RF_COLLECTION,
  OPERATORS,
  RF_RADIUS,
  TIP_CUE_WORKFLOW,
  USER,
} from 'src/app/services/constants';
import { TaskcostSensorPreviewComponent } from '../newtask/taskcost-sensor-preview/taskcost-sensor-preview.component';
import { TaskcostComponent } from '../taskcost/taskcost.component';
import { FilterPopupComponent } from '../collections/filter-popup/filter-popup.component';
import { ConfirmPopupComponent } from '../my-task/confirm-popup/confirm-popup.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { HelperService } from 'src/app/services/helper.service';
import { STRINGCONSTANTS } from 'src/app/shared/constants/app-strings.constants';
import { SENSOR_RESOLUTION_WARNING_MESSAGES } from 'src/app/shared/constants/sensor-resolution-warning-messages';
import { WARNING_MESSAGES } from 'src/app/shared/constants/warning-popup-message';
import {calculateArea} from 'src/app/services/geo-area.helper';
import { SharedDataService } from '../shared/shared-data-service';
import { MatSelect } from '@angular/material/select';
import { MatCheckboxChange } from '@angular/material/checkbox';
export interface ProjectModel {
  project: string;
  _id: number;
  customerid: any;
}

@Component({
  selector: 'app-leaflet-task',
  templateUrl: './leaflet-task.component.html',
  styleUrls: ['./leaflet-task.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class LeafletTaskComponent implements OnInit, OnDestroy {
  private map: L.Map;

  @Input() target: any = { geoJSON: '', area: 0 };
  @Input() accept = '.topojson, .geojson, .kml';
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('llInput') llInput: ElementRef;
  @ViewChild('cloudPanel') cloudPanel: MatExpansionPanel;
  @ViewChild('timepicker', { static: true })
  timepicker: NgxMaterialTimepickerComponent;
  @ViewChild('sensorPanel') sensorPanel!: MatExpansionPanel;
  @ViewChild('sensorList') sensorList!: TaskcostComponent;
  @ViewChild('tqSensorList') tqSensorList!: TaskcostComponent;
  @ViewChild('signalSelect') signalSelect: MatSelect;
  private originalClose: (() => void) | null = null;
  isBroRFSelected: boolean;
  drawingMode = '';
  mapSnap: any;
  defaultLL: any[] = [82.9739, 25.3176];
  roll: any = 0;
  jumpLocation: any;
  locationInvalid = true;
  keyIn = false;
  dateFlag = false;
  tleRangeError = false;
  tleStartRangeError = false;
  tleToiError = false;
  isFirst = true;
  accuracy = 15;
  jsonData = '';
  fileAttr = 'Choose File';
  acceptFile = '.topojson, .geojson, .kml';
  MYENTITY;
  drawingOn = false; // AT21 = false; satllogic = false;
  viewer: any;
  scene: any = null;
  longLatStr: string = '';
  latlonOverlay = document.createElement('div');
  satEntity;
  datafile: any;
  imgUrls: any;
  dataForm: FormGroup | any;
  options: any;
  compassOverlay: any;
  currentUser: any;
  projName: any;
  taskName: any;
  mapLoading: boolean = false;
  taskTarget: any;
  frequency: any;
  taskArea: 0;
  formGroup: any = FormGroup;
  tleSensor: {
    resolution: { key: string; name: string }[];
    sensor: { sensorName: string; obfuscateName: string; sensorId: string }[];
  } = {
    resolution: [],
    sensor: [],
  };
  tleSensorForm: any = FormGroup;
  showtleClick: boolean = false;
  showtleDisabled: boolean = false;
  taskparams: any;
  date: any;
  proceed = false;
  frequencyOption = [
    { id: 0, name: 'Specific Date', selected: true },
    { id: 1, name: 'Recurrent', selected: false },
    { id: 2, name: 'Period', selected: false },
  ];
  selectedOption = 0;
  freqOption = 'Daily';
  showResults = false;
  DateFilter: any;
  DateRange = 30;
  monthRange = 13;
  minDate: Date | null;
  maxDate: Date | null;
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  defaultWindow = 30; //30 days
  sensors: any = this.apiService.selectSensors;
  TASKFREQUENCY: any;
  purposeOption: any;
  intentOption: any;
  useCaseOption: any;
  strategyOptions: any;
  selectedSensorTypes: any;
  allComplete: boolean = false;
  state: any;
  showSensors = false;
  tasking: FormGroup;
  panelOpenState = true;
  isExpanded = true;
  taskid: any;
  coordinates: string;
  ph: string;
  title = 'Confirmation';
  cancelBtn = 'Cancel Task';
  btnParams = 'CANCEL';
  successMsg: any;
  taskMap: any;
  chkNum = 0;
  dailyCount: any;
  todayDate: Date;
  clickFrequency: boolean = false;
  others: boolean = false;
  description: any;
  purposeTask: any;
  projectData: ProjectModel[] = [];
  filteredProjects: Observable<ProjectModel[]>;
  buttonDisable: boolean = false;
  callCounter: any = 0;
  satellites: any[] = [];
  satelliteEntity: any;
  entityValues: any;
  orbitalPath: any;
  randomColor: string;
  subDaily: boolean = false;
  taskStrategy: any;
  tipAndCueBasedOn: string;
  observationSection: boolean = false;
  observationOptions: any;
  rulesOptions: any;
  observations: any;
  ruleBased: any;
  parentVal: any;
  observation: any;
  rule: any;
  observationData: any;
  pointArray: any[] = [];
  pointEntities: any[] = [];
  isDrawingEnabled: boolean = false;
  retask: boolean;
  selectedTasks: any;
  polygons: number[][][] = [];
  weatherData: any = [];
  cloudclicked: boolean;
  outComeForm: any = FormGroup;
  SensorsTypes: any = [];
  demoView: boolean = false;
  outComesensor: any;
  outComeError: boolean = true;
  expectedAge: any;
  filteredSensorTypes: any[];
  outComeSubmit: boolean = false;
  darkTheme: boolean;
  tooltipImagePath: string;
  isInIframe: boolean;
  isChecked: boolean = false;
  hourly: boolean = true;
  timeError: number;
  isPast: boolean = false;
  measurmentTooltipEntities: any[] = [];
  measurmentEntities: any[] = [];
  entityId = '';
  drawStarted = false;
  drawCompleted = false;
  isSearched = false;
  pinDisable: boolean = false;
  handler: any;
  restrictedUser: boolean = false;
  shapeSelected: boolean = false;
  lattitude = 41.2;
  longitude = 74.66;
  marker: any;
  isEndPast: boolean = false;
  budget: boolean;
  selectedSensorObfuscatedName: any;
  budgetForm: any = FormGroup;
  budgetInputs: any = {
    resolutionArr: [],
    cloudCoverKeys: [],
    holdbackArr: [],
    tierArr: [],
    rfSignals:[], rawIQData: false
  };
  showResolution: boolean = true;
  selectedCategory: string;
  cloudCoverOptions: string[] = [];
  resolutionOptions: string[] = [];
  taskingTierOptions: string[] = [];
  rfSignalOptions: any[] = [];
  rfCollectionOptions: any[] = [];
  holdBackOptions: string[] = [];
  budgetSensorType: any;
  selectedFrequencyID: number;
  currentLocalTime: string;
  tleSubmit: boolean = false;
  updateFrequencyOption: boolean = false;
  signalOfInterest:boolean = false;
  rfSelectedSignals: any[] = [];
  audioSelections: any[] = [];
  taskableGroup = L.featureGroup();
  satTrackingClicked : boolean = false;
  userDetails: any;
  private timeSubscription: Subscription;
  private satelliteDataSubscription: Subscription | null = null;
  private satLayer: L.LayerGroup | null = null;
  private markersAndDivs: Array<{ div: HTMLDivElement; layer: L.Marker }> = [];
  private numberBadgeMarkers: L.Marker[] = [];
  private numberPaneCreated = false;
  private satRenderer?: L.SVG;
  private destroy$ = new Subject<void>();

  taskPoint: number = 0;
  totalTaskNumber: number = 0;
  layerData: any;
  subStrategyOptions: any[] = [
    {
      name: 'Tip and cue with user-picked sensors',

      value: 'Tip-and-Cue',

      description:
        'Users configure two sensor types in sequenced tasking and make the required sensor choices. ',
    },

    {
      name: 'Tip and cue automated',

      value: 'Tip-and-Cue-Outcome',

      description:
        'Users configure two sensor types in sequenced tasking, and the platform chooses the sensors. ',
    },
  ];

  subStrategy: any;

  sensorTypesTipnCue: any[] = [
    {
      name: 'MSI',

      value: 'MSI',
    },

    {
      name: 'SAR',

      value: 'SAR',
    },

    {
      name: 'AIS',

      value: 'AIS',
    },
  ];
  tipCueWorkflow = TIP_CUE_WORKFLOW;
  subUser = USER;
  isDrawControlClicked = false;
  updateFrequencies: any[] = this.apiService.updateFrequencies;
  outcomePopUpData: any = {};
  rfCircleLayer: any[] = [];
  invalidForm: boolean = true;

  cueingSensorResolution: any;

  tippingSensorResolution: any;

  cueingSensorCloudCover: any;

  tippingSensorCloudCover: any;

  feeds: any;

  feedList: any;
  userTimezone: string;
  userid: any;
  updatedIntentOption = false;
  duplicateDetected: boolean = false;
  imagingSensor: string = 'imagingSensor';
  nonImagingSensor = 'nonImagingSensor';

  @ViewChild('map', { static: true }) mapContainer!: ElementRef;

  @ViewChild('fullscreenDiv', { static: false }) fullscreenDiv!: ElementRef;

  fullscreenIncon = '../../../assets/images/download.svg';

  toggleFullscreen() {
    const elem = this.mapContainer.nativeElement;

    if (!document.fullscreenElement) {
      this.fullscreenIncon = '../../../assets/images/download-3.svg';
      if (elem.requestFullscreen) {
        elem.requestFullscreen().then(() => {
          this.map.invalidateSize(); // Ensure map resizes correctly
        });
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen().then(() => {
          this.map.invalidateSize();
        });
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen().then(() => {
          this.map.invalidateSize();
        });
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen().then(() => {
          this.map.invalidateSize();
        });
      }
    } else {
      this.fullscreenIncon = '../../../assets/images/download.svg';
      if (document.exitFullscreen) {
        document.exitFullscreen().then(() => {
          this.map.invalidateSize(); // Resize map back to original size
        });
      }
    }
  }

  isFullscreen = false;
  onFullscreenChange() {
    this.isFullscreen = !!document.fullscreenElement;
    this.isFullscreen
      ? (this.fullscreenIncon = '../../../assets/images/download-3.svg')
      : (this.fullscreenIncon = '../../../assets/images/download.svg');
    this.map.invalidateSize(); // Ensure the map resizes correctly
  }

  private drawControl!: any;
  private drawnItems = new L.FeatureGroup();
  private drawTooltip: any = null;
  private isFirstVertexPlaced = false;

  private selectedDrawControl: any = '';

  private geoJsonLayer: any;
  private searchMarker: any = null;
  private satelliteLayerGroup: L.LayerGroup | null = null;
  private satelliteMarkers: L.Marker[] = [];
  private satelliteSegments: L.Polyline[] = [];

  isResetClicked = false;
  isDrawStarted = false;
  startPoint: any;
  zoomLevel = 3;
  mapDistance = 0;

  latLngDMS = '';
  position: any;

  eventLayers: any[] = [];
  controlOrder = [
    'target',
    'intent',
    'frequency',
    'date',
    'sensorType',
    'updateFrequency',
    'rfSignals',
    'rawIQData',
    'taskingTier',
    'start',
    'end',
    'endTime',
    'startTime'
  ];
  selectedSignals: any = [];
  selectedDisplay: any = '';
  aisType = 'AIS';
  rfType = 'RF';
  prevValue: any;
  minRFCollection: number = MIN_RF_COLLECTION;
  maxRFCollection: number = MAX_RF_COLLECTION;
  RFCollections: number[] = [];

  constructor(
    private el: ElementRef,
    private apiService: ApiService,
    public dialog: MatDialog,
    private http: HttpClient,
    private route: ActivatedRoute,
    private dataService: DataService,
    private renderer: Renderer2,
    private themeService: ThemeService,
    private authService: AuthService,
    private datePipe: DatePipe,
    private utilsService: UtilsService,
    private userService: UserService,
    private popupService: PopupService,
    private spinnerService: NgxSpinnerService,
    private changDetectionRef: ChangeDetectorRef,
    private router: Router,
    private helperService: HelperService,
    private sharedDataService: SharedDataService,
    private cdr: ChangeDetectorRef
  ) {
    this.isInIframe = this.themeService.isInIframe();
    this.dataService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;
      this.tooltipImagePath = this.darkTheme
        ? '../../../assets/images/union-dark.svg'
        : '../../../assets/images/union.svg';
    });
    if (environment.demoView === 'true') {
      this.demoView = true;
    } else {
      this.demoView = false;
    }
    this.retask = false;
    this.budget = false;
    if (this.route.snapshot.url.join('/').includes('retask')) {
      this.retask = true;
      const data = localStorage.getItem('rowData');
      if (data != null) {
        this.selectedTasks = JSON.parse(data);
      }
    } else {
      this.retask = false;
    }
    if (this.route.snapshot.url.join('/').includes('newbudget')) {
      this.budget = true;
    } else {
      this.budget = false;
    }

    if (!this.ph) {
      this.ph = 'init';
    }
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();

    this.date = new FormControl(new Date(year, month - 1, day + 1));

    this.range = new FormGroup({
      start: new FormControl(new Date(year, month - 1, day + 1)),
      end: new FormControl(new Date(year, month - 1, day + this.defaultWindow)),
    });

    this.formGroup = new FormGroup({
      project: new FormControl(this.projName, [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(25),
      ]),
      taskname: new FormControl(this.taskName, [
        Validators.required,
        Validators.minLength(5),
      ]),
      strategyRadio: new FormControl('', [Validators.required]),
      tipAndCueBasedOn: new FormControl(this.tipAndCueBasedOn),
      description: new FormControl(this.description, [
        Validators.maxLength(50),
      ]),
      target: new FormControl({ value: null, disabled: true }, [
        Validators.required,
      ]),
      feeds: new FormControl(this.feeds),
      observation: new FormControl(this.observation),
      observationData: new FormControl(this.observationData),
      rule: new FormControl(this.rule),
      purpose: new FormControl(this.purposeTask, [Validators.required]),
      frequency: new FormControl(this.frequency, [Validators.required]),
      jumplocation: new FormControl(this.jumpLocation),
      start: new FormControl(new Date(year, month - 1, day + 1)),
      end: new FormControl(new Date(year, month - 1, day + this.defaultWindow)),
      projectId: new FormControl(''),
      intent: new FormControl('', [Validators.required]),
      startTime: new FormControl('', [Validators.required]),
      endTime: new FormControl('', [Validators.required]),
      useCase: new FormControl(''),
      subStrategyRadio: new FormControl('', [Validators.required]),
      useCaseDescription: new FormControl('', [Validators.maxLength(50)]),
    });

    this.updateFormControls(this.taskStrategy);
    // Add the subscription to strategyRadio changes

    this.formGroup.get('strategyRadio').valueChanges.subscribe((strategy) => {
      if (strategy === 'Tip-and-Cue') {
        // Set Validators for subStrategyRadio if the strategy is 'Tip-and-Cue'

        this.formGroup
          .get('subStrategyRadio')
          .setValidators([Validators.required]);
      } else {
        // Clear Validators if the strategy is anything else

        this.formGroup.get('subStrategyRadio').clearValidators();
      }

      // Update the validity after changing validators

      this.formGroup.get('subStrategyRadio').updateValueAndValidity();
    });
    this.formGroup.get('strategyRadio')?.valueChanges.subscribe((strategy) => {
      const intentControl = this.formGroup.get('intent');
      if (strategy === 'Outcome By Platform') {
        intentControl.clearValidators();
        intentControl.updateValueAndValidity();
      }
      this.updateFormControls(strategy);
    });

    this.authService.user.subscribe((user) => (this.currentUser = user));
    this.userid = this.currentUser.id;
    this.loadUserDetails(this.userid);
    this.outComeForm = new FormGroup({
      tipAndCueBasedOn: new FormControl('Observation'),
      sensorType: new FormControl(),
      resolution: new FormControl(),
      intent: new FormControl(),
      cloudCover: new FormControl(),
      latency: new FormControl('', [
        Validators.required,
        Validators.min(24),
        Validators.pattern(/^[0-9]\d*$/),
      ]),
      budget: new FormControl('', [
        Validators.required,
        Validators.min(
          this.currentUser?.pointsEligible ? this.convertToPoints(150) : 150
        ),
        Validators.pattern(/^[0-9]\d*(\.\d+)?$/),
      ]),
      tippingSensorType: new FormControl(),

      cueingSensorType: new FormControl(),

      observation: new FormControl(),

      rule: new FormControl(),

      observationData: new FormControl(),

      tippingSensorResolution: new FormControl(),

      cueingSensorResolution: new FormControl(),
      updateFrequency: new FormControl(),
      tippingCloudCover: new FormControl(),

      cueingCloudCover: new FormControl(),
    });

    this.budgetForm = new FormGroup({
      target: new FormControl({ value: null, disabled: true }, [
        Validators.required,
      ]),
      frequency: new FormControl(this.frequency, [Validators.required]),
      start: new FormControl(new Date(year, month - 1, day + 1)),
      end: new FormControl(new Date(year, month - 1, day + this.defaultWindow)),
      startTime: new FormControl('', [Validators.required]),
      endTime: new FormControl('', [Validators.required]),
      resolution: new FormControl(''),
      taskingTier: new FormControl(''),
      cloudCover: new FormControl(''),
      holdBack: new FormControl(''),
      sensorType: new FormControl('', [Validators.required]),
      intent: new FormControl('', [Validators.required]),
      sensorCategory: new FormControl(this.imagingSensor, [
        Validators.required,
      ]),
      updateFrequency: new FormControl(),
      rawIQData: new FormControl(false),
    });
    this.tleSensorForm = new FormGroup({
      sensorType: new FormControl('', [Validators.required]),
      resolution: new FormControl('', [Validators.required]),
      sensor: new FormControl('', [Validators.required]),
    });

    this.selectedCategory = this.budgetForm.get('sensorCategory')?.value;
    this.outComeForm.valueChanges.subscribe(() => {
      if (this.isAnyFieldEmpty()) {
        this.outComeError = true;
      } else {
        this.outComeError = false;
      }
    });
    this.outComeForm.valueChanges.subscribe(() => {
      if (this.isAnyFieldNull()) {
        this.invalidForm = true;
      } else {
        this.invalidForm = false;
      }
    });

    this.getProjects();
    this.filteredProjects = this.formGroup.get('project').valueChanges.pipe(
      startWith(null),
      map((data: string) =>
        data ? this._filter(data) : this.projectData.slice()
      )
    );

    this.setUTCTodayDate();
  }

  getProjects() {
    this.apiService.getProjects().subscribe((res: any) => {
      this.projectData = res.result;
    });
  }

  private _filter(value: string): ProjectModel[] {
    const filterValue = value.toString().toLocaleLowerCase();
    return this.projectData.filter(
      (data) => data.project?.toLocaleLowerCase().indexOf(filterValue) === 0
    );
  }

  setProjectid(value) {
    this.formGroup.controls.projectId.setValue(value._id);
    this.target.projectId = value._id;
    this.projName = value.project;
    this.updateTarget(this.target, '0');
  }

  updateFormControls(taskStrategy: string): void {
    const useCaseControl = this.formGroup.get('useCase');
    if (taskStrategy === 'Help Select Sensor(s)') {
      useCaseControl?.setValidators(Validators.required);
    } else {
      useCaseControl?.clearValidators();
    }
    useCaseControl?.updateValueAndValidity();
  }

  mapFontColor = 'white';

  async ngOnInit() {
    this.TASKFREQUENCY = this.apiService.TASKFREQUENCY;
    this.purposeOption = this.apiService.purposeOption;
    this.apiService.getObservations().subscribe((res: any) => {
      this.observationOptions = res.observations;
      this.rulesOptions = res.ruleBased;
    });

    this.apiService.getPurpose().subscribe((res: any) => {
      this.purposeOption = this.utilsService.sortPurposeOptions(
        res?.purposeList
      );
    });

    this.apiService.intentOption().subscribe((response: any) => {
      this.intentOption = response;
    });
    const planTaskFeatureKeys =
      this.currentUser?.planDetails?.features.map((f) => f.key) || [];
    this.strategyOptions = this.apiService.strategyOptions.filter((option) =>
      planTaskFeatureKeys.includes(option.taskStrategyFeature)
    );
    this.dailyCount = this.apiService.dailyCount;

    if (this.retask) {
      this.selectRecord(this.selectedTasks);
    }

    this.filteredSensorTypes = this.SensorsTypes.filter(
      (item) => item.feasibility === true
    );
    this.timeSubscription = interval(30000).subscribe(() => {
      this.updateCurrentLocalTime();
    });

  this.sharedDataService.getData().subscribe(data => {
    if (data) {
      this.userDetails = data;
    }
  });
  }

  isDarkMode = false;

  ngAfterViewInit() {
    this.initializeMap();
    this.initializeDrawingTools();
    this.setupEventListeners();
    if (this.retask) {
      this.disableEnableDrawControls(false, '');
    }

    this.dataService.darkTheme.subscribe((res: any) => {
      this.isDarkMode = res;
    });
    delete (L.Icon.Default.prototype as any)._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
      iconUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
      shadowUrl:
        'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
    });
    this.initGeoSearchControl();
    this.handleSearchDisable();
  }
  ngAfterViewChecked(): void {
    if (this.taskStrategy === 'TLE Based Tasking') {
      this.tleSubmit = this.shouldEnableCancelButton(
        this.target,
        this.tleSensorForm
      );
    }
  }

    ngDoCheck() {
    if (this.selectedCategory === this.nonImagingSensor && ((this.target.geoJSON != null && this.target?.geoJSON !== this.prevValue ) || (this.target.geoJSON === ''))) {
      this.prevValue = this.target.geoJSON;
      this.resetControlsBelow('target');
    }
  }

  ngOnDestroy(): void {
    this.map.remove();
    if (this.timeSubscription) {
      this.timeSubscription.unsubscribe();
    }
    if (this.satelliteDataSubscription) {
      this.satelliteDataSubscription.unsubscribe();
    }

    this.destroy$.next();
    this.destroy$.complete();
  }

  private async initializeMap() {
    this.map = L.map(this.mapContainer.nativeElement, {
      zoom: this.zoomLevel,
      layers: [baseLayers.Sentinel], // Set the initial (default) layer
      attributionControl: false,
    });

    var myAttrControl = L.control.attribution().addTo(this.map);
    myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
    var sentinel2Layer = L.tileLayer(
      'https://tiles.maps.eox.at/wmts/1.0.0/s2cloudless-2020_3857/default/g/{z}/{y}/{x}.jpg',
      {
        attribution:
          '<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>',
        tileSize: 256,
      }
    ).addTo(this.map);

    setTimeout(() => {
      this.map.invalidateSize();
      this.changDetectionRef.detectChanges();
    }, 0);

    L.control
      .layers(baseLayers, overlays, {
        collapsed: false, // Optionally control whether the control is collapsed by default
        position: 'topright', // Optionally set the position of the control
      })
      .addTo(this.map);

    if (this.retask == false) {
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${this.currentUser.country}`;

      try {
        const response = await fetch(url);
        const data = await response.json();

        if (data && data.length > 0) {
          const lat = data[0].lat;
          const lon = data[0].lon;
          this.map.setView([lat, lon], 9);
        }
      } catch (error) {}
    }

    L.Icon.Default.mergeOptions({
      iconUrl: '../../../assets/map-icons/marker-icon.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowUrl: '../../../assets/map-icons/marker-shadow.png',
      shadowSize: [41, 41],
      shadowAnchor: [12, 41],
    });

    setTimeout(() => {
      const layersControlElement = document.querySelector(
        '.leaflet-control-layers'
      );
      if (layersControlElement) {
        const container = document.getElementsByClassName(
          'leaflet-control-layers-expanded'
        )[0];
        container?.classList.remove('leaflet-control-layers-expanded');
      }
    }, 0);

    this.map.on('baselayerchange', (event: any) => {
      let layerBtn: any = document.querySelector(
        '.leaflet-control-layers-toggle'
      );
      layerBtn.classList.remove('highlight-border');
      const container = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (container) {
        container.classList.remove('leaflet-control-layers-expanded');
        document
          .querySelector('.leaflet-control-layers-toggle')
          ?.setAttribute('style', 'top:0px !important');
      }
      const element = document.querySelector('#homeButton');
      if (element) {
        this.renderer.setStyle(element, 'z-index', '500');
      }
      if (event.name === 'Openstreetmap') {
        this.mapFontColor = 'black';
        myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
        myAttrControl.removeAttribution(
          '<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>'
        );
        myAttrControl.addAttribution(
          '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers'
        );
        const elements = document.querySelectorAll('[id^="custom-div"]');
        elements.forEach((element: any) => {
          element.style.color = this.mapFontColor;
        });
      } else {
        this.mapFontColor = 'white';
        myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
        myAttrControl.removeAttribution(
          '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers'
        );
        myAttrControl.addAttribution(
          '<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>'
        );
        const elements = document.querySelectorAll('[id^="custom-div"]');
        elements.forEach((element: any) => {
          element.style.color = this.mapFontColor;
        });
      }
    });

    this.map.createPane('left');
    this.map.createPane('right');
    this.map.on('baselayerchange', (e: any) => {
      this.map.off('layerremove');
      this.map.off('layeradd');
    });
    this.map.on('layeradd', (e: any) => {});
    this.map.on('layerremove', (e: any) => {
      this.map.off('layerremove');
    });

    document
      .querySelector('.leaflet-control-layers-toggle')
      ?.addEventListener('click', (e) => {
        this.removeHighlight();
        let layerBtn: any = document.querySelector(
          '.leaflet-control-layers-toggle'
        );
        layerBtn.classList.add('highlight-border');
        if (document.querySelector('.leaflet-control-layers-expanded')) {
          document
            .querySelector('.leaflet-control-layers-toggle')
            ?.setAttribute('style', 'top:-48px !important');
        }

        const searchBtnParentEl = document.querySelector(
          '.leaflet-geosearch-button'
        ) as HTMLElement;
        const searchInput = document.querySelector(
          '.leaflet-geosearch-button form input'
        ) as HTMLInputElement;
        if (!searchInput.value && !searchInput.classList.contains('active')) {
          searchBtnParentEl.classList.remove('active');
        }
      });

    this.map.on('click', function () {
      //clearing search input
      const searchInput: any = document.querySelector(
        '.leaflet-control-geocoder-form input'
      );
      if (searchInput?.value) {
        searchInput.value = '';
      }

      let links = document.querySelectorAll('.leaflet-draw-toolbar span a');
      links.forEach((s: any) => s.classList.remove('highlight-border'));
      let homeBtn: any = document.querySelector('#homeButton');
      homeBtn.classList.remove('highlight-border');
      let layerBtn: any = document.querySelector(
        '.leaflet-control-layers-toggle'
      );
      layerBtn.classList.remove('highlight-border');
      var controlContainer = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (
        controlContainer &&
        controlContainer.classList.contains('leaflet-control-layers-expanded')
      ) {
        controlContainer.classList.remove('leaflet-control-layers-expanded');
        document
          .querySelector('.leaflet-control-layers-toggle')
          ?.setAttribute('style', 'top:0px !important');
      }

      const searchBtnParentEl = document.querySelector(
        '.leaflet-geosearch-button'
      ) as HTMLElement;
      searchBtnParentEl.classList.remove('active');
    });

    const mapContainer: any = document.getElementById('map');
    const zoomDiv = document.getElementById('zoomDiv');
    mapContainer.appendChild(zoomDiv);
    this.map.removeControl(this.map.zoomControl);
    const zoomControl = new L.Control.Zoom({ position: 'bottomright' });
    zoomControl.addTo(this.map);
    this.authService.user.subscribe((user) => {
      this.currentUser = user;
      if (this.currentUser?.isTaskableAoi && !this.retask) {
        this.restrictedUser = true;
        let targetData = this.currentUser?.taskableAoi;
        let type: any, coordinates: any;
        const allTaskableAois = targetData.map(item => item.taskableAoi);
        allTaskableAois.forEach(item => {
          type = item?.type.toUpperCase();
          coordinates = item.coordinates;
          if (type === 'POLYGON') {
            this.drawTaskableAOI(coordinates);
          }
        });
        this.taskableGroup.addTo(this.map);
        this.map.fitBounds(this.taskableGroup.getBounds());
      } else this.restrictedUser = false;
    });
    this.calculateZoomLevel();
    this.changDetectionRef.detectChanges();
  }

  isPolygonClosed(polygonCoords: number[][]) {
    const first = polygonCoords[0];
    const last = polygonCoords[polygonCoords.length - 1];
    const isClosed = first[0] === last[0] && first[1] === last[1];
    return isClosed;
  }

  isCordinateBasedSearch = false;
  suppressNextGeo = false;
  /* Init geoSearchControl */
  private initGeoSearchControl(): void {
    /* Configure GeoSearchControl */
    const provider = new OpenStreetMapProvider();
    const searchControl = (GeoSearchControl as any)({
      provider: provider,
      style: 'button',
      position: 'topright',
      searchLabel: 'Enter an address or landmark...',
      showMarker: false,
      showPopup: false,
    });
    this.map.addControl(searchControl);
    const searchFormEl = document.querySelector(
      '.leaflet-geosearch-button form'
    ) as HTMLFormElement;
    const searchInputEl = searchFormEl.querySelector(
      'input'
    ) as HTMLInputElement;

    if (this.route.snapshot.url.join('/').includes('retask')) {
      document
        .querySelector('.leaflet-geosearch-button')
        ?.setAttribute('style', 'pointer-events: none !important');
    }

    const leafletBarElement = document.querySelector(
      '.leaflet-bar-part.leaflet-bar-part-single'
    );
    if (leafletBarElement) {
      leafletBarElement.removeAttribute('title');
    }
    let searchBtnParentEl: any;
    searchInputEl.addEventListener('keydown', (event: any) => {
      if (event.key === 'Enter') {
        const query = event.target.value;
        const inputStatus = this.isValidInput(query);
        const coordPairs = query
          .split(';')
          .map((pair) => pair.trim())
          .filter(Boolean);

        searchBtnParentEl = document.querySelector('.results');
        if (coordPairs.length === 1) {
          const coords = event.target.value
            .trim()
            .split(',')
            .map((coord) => coord.trim());
          if (
            (coords.length === 2 || coords.length === 3) &&
            !coords.includes('')
          ) {
            searchBtnParentEl = document.querySelector('.results');
            if (searchBtnParentEl) {
              searchBtnParentEl.style.display = 'none';
            }
            const lng = parseFloat(coords[0]);
            const lat = parseFloat(coords[1]);
            if (
              this.helperService.validateCoordinates(lng, lat) &&
              !isNaN(lng) &&
              !isNaN(lat)
            ) {
              this.isCordinateBasedSearch = true;
              const res: object = { location: { lng: lng, lat: lat } };
              this.triggerResetButtonClick();
              this.resultHandler(res);
            } else {
              const message = `Please enter the longitude followed by the latitude.`;
              this.popupService
                .openPopup(WarningPopup, message, '', '50%')
                .afterClosed()
                .subscribe((result) => {
                  if (result === 1) {
                    this.resetMap();
                    this.disableEnableDrawControls(true, '');
                  }
                });
              return;
            }
          } else {
            if (searchBtnParentEl) {
              searchBtnParentEl.style.display = 'block';
            }
            if (inputStatus === 'invalid' || coords.length !== 1) {         
              const message = `Please enter a valid coordinate Lng,Lat or multiple coordinate pairs separated by ';'.`;
              this.openPopupNoMapMove(WarningPopup, message, '', '50%');
              return;
            }
          }
        } else {
          if (
            coordPairs.length > 1 &&
            this.taskStrategy === 'TLE Based Tasking'
          ) {
            this.suppressNextGeo = true;
            const message =
              'TLE-based tasking supports only point of interest (POI) now.';
            this.popupService
              .openPopup(CollectionPopupComponent, message, '', '40%')
              .afterClosed()
              .subscribe((result) => {
                if (result === 1) {
                  this.resetMap();
                }
              });
            return;
          } else if (coordPairs.length == 2) {
            this.suppressNextGeo = true;
            const message = `Not enough coordinates to draw an AOI polygon. Three or more pairs are required for a polygon.`;
            this.openPopupNoMapMove(WarningPopup, message, '', '50%');
            return;
          } else if (coordPairs.length > 2) {
            // --- MULTIPLE COORDINATE PAIRS (POLYGON) ---
            if (searchBtnParentEl) searchBtnParentEl.style.display = 'none';

            const polygonCoords = coordPairs.map((pair) => {
              const [latStr, lngStr] = pair.split(',').map((s) => s.trim());
              const lat = parseFloat(latStr);
              const lng = parseFloat(lngStr);
              return [lng, lat]; // [lng, lat]
            });
            if (
              !this.isPolygonClosed(polygonCoords) ||
              polygonCoords.length < 4
            ) {
              const message =  'First and last coordinates must be the same to form a closed polygon.';
              this.openPopupNoMapMove(WarningPopup, message, '', '50%');
              return;
            }
            for (const [lng, lat] of polygonCoords) {
              if (!this.helperService.validateCoordinates(lat, lng)) {
                this.suppressNextGeo = true;
                const message =
                  "Please enter a valid coordinate Lng,Lat or multiple coordinate pairs separated by ';'.";
                  this.openPopupNoMapMove(WarningPopup, message, '', '50%');
                return;
              }
            }

            let firstPairKey: string | null = null;
            this.duplicateDetected = false;
            const accuracy = 15;
            const validCoords: number[][] = []; // store as numeric pairs

            for (const [lng, lat] of polygonCoords) {
              const formatted = `${lng} ${lat}`;
              if (!firstPairKey) {
                firstPairKey = formatted;
              } else if (formatted === firstPairKey) {
                validCoords.push([lng, lat]);
                this.duplicateDetected = true;
                break; // Stop processing further pairs
              }
              validCoords.push([lng, lat]);
            }
            this.isCordinateBasedSearch = true;

            if (
              this.duplicateDetected &&
              validCoords.length !== polygonCoords.length
            ) {
              const message =
                'All the subsequent coordinates are ignored when the polygon is complete.';
              this.popupService
                .openPopup(WarningPopup, message, 'duplicateDetected', '50%')
                .afterClosed()
                .subscribe((result) => {
                  if (result === 1) {
                    const turfPolygon = turf.polygon([validCoords]);
                    const areaSqM = turf.area(turfPolygon);
                    this.target.area = (areaSqM / 1e6).toFixed(2);
                    this.resultHandler(validCoords);
                  }
                });
              return;
            }

            this.triggerResetButtonClick();
            this.resultHandler(polygonCoords);
           
          }
        }
      }
    });

    var searchEventHandler = (e) => {
      if (this.suppressNextGeo) {
        this.suppressNextGeo = false;
        return;
      }
      this.resultHandler(e);
    };
    this.map.on('geosearch/showlocation', searchEventHandler);

    /* Custom reset button */
    const resetBtn = L.DomUtil.create('button');
    resetBtn.setAttribute('class', 'reset_btn');
    resetBtn.innerHTML = 'x';
    const formEl = document.querySelector(
      '.leaflet-geosearch-button form'
    ) as HTMLFormElement;
    formEl?.appendChild(resetBtn);

    resetBtn.addEventListener('click', (event: any) => {
      this.resetSearchInput();
    });

    this.initHoverOnSearchBox();

    /** Custom search button */
    const searchEl = document.querySelector(
      '.leaflet-control-geosearch'
    ) as HTMLFormElement;
    const searchBtnEl = L.DomUtil.create('button');
    searchBtnEl.setAttribute('class', 'searchBtn');
    searchEl.append(searchBtnEl);

    /** Search show when input focus */
    const searchInput = formEl.querySelector('input') as HTMLInputElement;
    searchInput.addEventListener('focus', (event: any) => {
      searchInput.classList.add('active');
      const resetBtn = formEl.querySelector('.reset_btn') as HTMLButtonElement;
      resetBtn.style.display = 'block';
    });

    /** Search reset when click on map */
    const mapContainer: any = document.getElementById('map');
    mapContainer.addEventListener('click', (event: any) => {
      this.resetSearchInput();
    });
  }

  private restoreMapMoveFns: null | (() => void) = null;

private freezeMapMove() {
  if (this.restoreMapMoveFns) return;

  const m: any = this.map;

  const original = {
    setView: m.setView,
    panTo: m.panTo,
    flyTo: m.flyTo,
    fitBounds: m.fitBounds,
    flyToBounds: m.flyToBounds,
    panInsideBounds: m.panInsideBounds,
  };

  const block = function () { return m; };

  m.setView = block;
  m.panTo = block;
  m.flyTo = block;
  m.fitBounds = block;
  m.flyToBounds = block;
  m.panInsideBounds = block;

  this.restoreMapMoveFns = () => {
    m.setView = original.setView;
    m.panTo = original.panTo;
    m.flyTo = original.flyTo;
    m.fitBounds = original.fitBounds;
    m.flyToBounds = original.flyToBounds;
    m.panInsideBounds = original.panInsideBounds;
    this.restoreMapMoveFns = null;
  };
}

private unfreezeMapMove() {
  this.restoreMapMoveFns?.();
}

private openPopupNoMapMove(component: any, message: string, tag = '', width = '50%') {
  this.freezeMapMove();
  return this.popupService.openPopup(component, message, tag, width)
    .afterClosed()
    .subscribe((result) => {
      this.unfreezeMapMove();
      if (result === 1) this.resetMap();
    });
}


  private resultHandler(e: any): void {
    // Clear previous layers and markers
    this.clearRFCircleLayers();
    this.layerData = null;
    this.zoomLevel = 14;
    this.removeHighlight();
    this.resetMap();
    if (this.geoJsonLayer) {
      this.map.removeLayer(this.geoJsonLayer);
      this.geoJsonLayer = null;
      this.eventLayers = [];
    }

    if (this.marker) {
      this.map.removeLayer(this.marker);
      this.marker = null;
    }

    if (this.drawnItems) {
      this.drawnItems.clearLayers();
    }

    this.pointArray = [];
    this.target.geoJSON = [];
    this.markersAndDivs.forEach((customDivs) => {
      customDivs.div.remove();
    });
    this.markersAndDivs = [];
     let isInside = false;
    // --- Handle POLYGON input ---
    if (Array.isArray(e)) {
      // e is polygonCoords [[lat, lng], ...]
      const wktCoords = e.map(([lat, lng]) => `${lng} ${lat}`).join(', ');
      const wkt = `POLYGON ((${wktCoords}))`;
      const polygon = L.polygon(e, {
        color: 'blue',
        weight: 2,
        fillOpacity: 0.3,
      }).addTo(this.map);
      this.geoJsonLayer = polygon;
      this.map.fitBounds(polygon.getBounds());
      this.target.geoJSON = wkt;
      const turfCoords: number[][] = e.map(([lat, lng]: [number, number]) => [lng, lat]);
      this.target.area = calculateArea(turfCoords);
      if (this.currentUser?.isTaskableAoi) {
        isInside = this.currentUser.taskableAoi.some((aoi) =>
        this.utilsService.polygonInsidePolygonAOI(
          turfCoords,
          aoi.taskableAoi.coordinates[0] // AOI polygon (already [lng,lat])
        )
      );
      if(!isInside){
        const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        this.resetMap();
        this.disableEnableDrawControls(true, '');
        let targetData = this.currentUser?.taskableAoi;
        let type: any, coordinates: any;
        const allTaskableAois = targetData.map(item => item.taskableAoi);
        allTaskableAois.forEach(item => {
          type = item?.type.toUpperCase();
          coordinates = item.coordinates;
          if (type === 'POLYGON') {
            this.drawTaskableAOI(coordinates);
          }
        });
        this.taskableGroup.addTo(this.map);
        this.map.fitBounds(this.taskableGroup.getBounds());
      }
      }
    } else if (e.location?.lat && e.location?.lng) {
      // --- Handle POINT input ---

      this.pointArray.push(`POINT (${e.location.lng} ${e.location.lat})`);
      this.lattitude = e.location.lat;
      this.longitude = e.location.lng;

     
      if (this.currentUser?.isTaskableAoi) {
        isInside =  this.currentUser.taskableAoi.some((aoi) =>this.utilsService.pointInPolygon(
          geoParse(this.pointArray[this.pointArray.length - 1]).coordinates,
          aoi.taskableAoi.coordinates[0]
        ));
      }

      if (!this.currentUser?.isTaskableAoi || isInside) {
        this.target.geoJSON = this.pointArray[0];
        this.disableEnableDrawControls(false, '');
        this.marker = L.marker([e.location.lat, e.location.lng]).addTo(
        this.map
        );
        this.getCountryAndPlace(e.location.lat, e.location.lng, 'search');
        this.map.flyTo([e.location.lat, e.location.lng], this.zoomLevel);
      } else {
        this.eventLayers.pop();
        this.pointArray.pop();
        const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        this.resetMap();
        this.disableEnableDrawControls(true, '');
      }
    } else if (e.location.raw.lon && e.location.raw.lat) {
      this.pointArray.push(
        `POINT (${e.location.raw.lon} ${e.location.raw.lat})`
      );
      this.lattitude = e.location.raw.lat;
      this.longitude = e.location.raw.lon;
      let isInside = false;
      if (this.currentUser?.isTaskableAoi) {
        isInside =  this.currentUser.taskableAoi.some((aoi) =>this.utilsService.pointInPolygon(
          geoParse(this.pointArray[this.pointArray.length - 1]).coordinates,
          aoi.taskableAoi.coordinates[0]
        ));
      }
      if (!this.currentUser?.isTaskableAoi || isInside) {
        this.target.geoJSON = this.pointArray[0];
        // 0
        this.disableEnableDrawControls(false, '');
        this.marker = L.marker([e.location.raw.lat, e.location.raw.lon]).addTo(
          this.map
        );
        this.getCountryAndPlace(
          e.location.raw.lat,
          e.location.raw.lon,
          'search'
        );
        this.map.flyTo(
          [e.location.raw.lat, e.location.raw.lon],
          this.zoomLevel
        );
      } else {
        this.eventLayers.pop();
        this.pointArray.pop();
        const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        this.resetMap();
        this.disableEnableDrawControls(true, '');
      }
    }
    this.updateTarget(this.target, '1');
    this.clearSatllite();
    this.isCordinateBasedSearch = false;
  }

  isValidInput(input: string): any {
    const trimmed = input.trim();
    // Disallow trailing semicolon
    if (trimmed.endsWith(';')) return 'invalid';

    const singleCoordRegex = /^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/;
    const multipleCoordsRegex =
      /^(-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?)(\s*;\s*-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?)*$/;
    const placeNameRegex = /^[a-zA-Z0-9\s.,'\-]+$/;

    // Just a number like "150.96" or "150.96,"
    const numberOnlyRegex = /^-?\d+(\.\d+)?$/;
    const endsWithCommaOnly = /^-?\d+(\.\d+)?,$/;

    if (singleCoordRegex.test(trimmed) || multipleCoordsRegex.test(trimmed))
      return 'valid';

    if (numberOnlyRegex.test(trimmed) || endsWithCommaOnly.test(trimmed))
      return 'invalid';
    if (placeNameRegex.test(trimmed)) return 'place';

    return 'invalid';
  }

  initHoverOnSearchBox() {
    const searchBtnParentEl = document.querySelector(
      '.leaflet-geosearch-button'
    ) as HTMLElement;
    searchBtnParentEl.addEventListener('mouseenter', (event: any) => {
      if (!searchBtnParentEl.classList.contains('active')) {
        this.showAndHideSearchInput(true);
      }
    });
    searchBtnParentEl.addEventListener('mouseleave', (event: any) => {
      if (searchBtnParentEl.classList.contains('active')) {
        this.showAndHideSearchInput(false);
      }
    });
  }

  showAndHideSearchInput(show: boolean): void {
    const searchBtnParentEl = document.querySelector(
      '.leaflet-geosearch-button'
    ) as HTMLElement;
    if (show) {
      var controlContainer = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (
        controlContainer &&
        controlContainer.classList.contains('leaflet-control-layers-expanded')
      ) {
        controlContainer.classList.remove('leaflet-control-layers-expanded');
        document
          .querySelector('.leaflet-control-layers-toggle')
          ?.setAttribute('style', 'top:0px !important');
      }
      searchBtnParentEl.classList.add('active');
      return;
    }
    const searchInput = document.querySelector(
      '.leaflet-geosearch-button form input'
    ) as HTMLInputElement;
    if (!searchInput.value && !searchInput.classList.contains('active')) {
      searchBtnParentEl.classList.remove('active');
    }
  }

  /* Reset search input field */
  private resetSearchInput(): void {
    const searchFormEL = document.querySelector(
      '.leaflet-geosearch-button form'
    ) as HTMLElement;
    const searchInput = searchFormEL.querySelector('input') as HTMLInputElement;
    const resultEl = searchFormEL.querySelector('.results') as HTMLElement;
    if (searchInput.value) {
      searchInput.value = '';
      resultEl.innerHTML = '';
      resultEl.classList.remove('active');
      searchInput.classList.remove('active');
      this.showAndHideSearchInput(false);
      const resetBtn = searchFormEL.querySelector(
        '.reset_btn'
      ) as HTMLButtonElement;
      resetBtn.style.display = 'none';
    }
    searchInput.classList.remove('active');
    resultEl.classList.remove('active');
  }

  fileName: any = '';
  private initializeDrawingTools(): void {
    this.drawControl = new (L as any).Control.Draw({
      draw: {
        marker: true,
        rectangle: { showArea: false, title: 'Draw AOI as rectangle' },
        circle: true,
        polygon: true,
        polyline: true,
        circlemarker: false,
      },
    });
    this.map.addControl(this.drawControl);
    this.customizeToolbar();
    this.map.addLayer(this.drawnItems);
    this.map.on('layeradd', (e: any) => {});
    this.map.on('layerremove', (e: any) => {});
  }

  resetButton: any;
  private addCustomButtons(): void {
    const toolbar = (this.drawControl as any)._toolbars.draw;
    const buttonContainer = toolbar._toolbarContainer;
    const uploadButton: any = L.DomUtil.create(
      'input',
      'leaflet-draw-draw-delete'
    );
    uploadButton.type = 'file';
    uploadButton.style.display = 'none';
    uploadButton.accept = '.topojson, .geojson, .kml';
    const filUploadButton: any = L.DomUtil.create(
      'a',
      'leaflet-draw-draw-delete'
    );
    filUploadButton.href = '#';
    filUploadButton.innerHTML =
      '<img src="../../../assets/map-icons/upload-file.svg">';
    filUploadButton.title = 'Upload kml/json file for AOI';
    filUploadButton.style.backgroundColor = 'white';
    filUploadButton.style.cursor = 'pointer';
    filUploadButton.style.display = 'flex';
    filUploadButton.style.justifyContent = 'center';
    filUploadButton.style.alignItems = 'center';
    const spanContainer: any = L.DomUtil.create('span');
    spanContainer.title = filUploadButton.title;
    spanContainer.style.position = 'relative';
    spanContainer.appendChild(filUploadButton);
    filUploadButton.addEventListener('click', (event: any) => {
      if (this.drawControl._toolbars.draw._activeMode) {
        this.drawControl._toolbars.draw._activeMode.handler.disable();
      }
      event.preventDefault();
      uploadButton.value = '';
      uploadButton.click();
    });
    uploadButton.addEventListener('change', (event: any) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = async (e: any) => {
          if (this.geoJsonLayer) {
            this.map.removeLayer(this.geoJsonLayer);
            this.geoJsonLayer = null;
            this.eventLayers = [];
          }
          const content = e.target.result as string;
          const extension = file.name.split('.').pop().toLowerCase();
          this.fileName = extension;
          const omnivore: any = await import('@mapbox/leaflet-omnivore');
          if (extension == 'kml') {
            const kmlContent = e.target.result as string;
            this.geoJsonLayer = omnivore.kml.parse(kmlContent);
            this.position = this.geoJsonLayer;
            this.layerData = this.geoJsonLayer;
            if (
              this.geoJsonLayer.getLayers()[0].feature.geometry.type ==
              'Polygon'
            ) {
              this.createCZML('polygon', this.geoJsonLayer.getLayers()[0]);
            } else if (
              this.geoJsonLayer.getLayers()[0].feature.geometry.type == 'Point'
            ) {
            }
            if (this.geoJsonLayer.getLayers().length > 1) {
              this.openDialog();
              this.geoJsonLayer = null;
              this.disableEnableDrawControls(true, '');
            } else {
              this.map.fitBounds(this.geoJsonLayer.getBounds());
              this.geoJsonLayer.addTo(this.map);
              this.disableEnableDrawControls(false, '');
            }
          } else if (extension === 'kmz') {
            const zip = new JSZip();
            const content = await zip.loadAsync(file);
            const kmlFile = content.file('doc.kml');
            if (kmlFile) {
              const kmlText = await kmlFile.async('string');
              const parser = new DOMParser();
              const kml = parser.parseFromString(kmlText, 'text/xml');
              this.geoJsonLayer = omnivore.kml.parse(kml);
              this.position = this.geoJsonLayer;
              this.layerData = this.geoJsonLayer;
              const geoJson1 = toGeoJSON.kml(kml);
              const totalLayers = geoJson1.features[0].geometry.geometries
                ? geoJson1.features[0].geometry.geometries.length
                : geoJson1.features[0].geometry.coordinates.length;
              if (totalLayers > 1) {
                this.openDialog();
                this.geoJsonLayer = null;
                this.setMapView(this.lattitude, this.longitude);
                this.disableEnableDrawControls(true, '');
              } else {
                if (
                  this.geoJsonLayer.getLayers()[0].feature.geometry.type ==
                  'Polygon'
                ) {
                  this.createCZML('polygon', this.geoJsonLayer.getLayers()[0]);
                }
                const geoJson = toGeoJSON.kml(kml);
                this.geoJsonLayer = L.geoJSON(geoJson);
                this.map.fitBounds(this.geoJsonLayer.getBounds());
                this.geoJsonLayer.addTo(this.map);
              }
            } else {
            }
          } else if (
            file.name.split('.').pop().toLowerCase() == 'json' ||
            file.name.split('.').pop().toLowerCase() == 'geojson'
          ) {
            this.geoJsonLayer = L.geoJSON(JSON.parse(content));
            this.position = this.geoJsonLayer;
            this.layerData = this.geoJsonLayer;
            if (
              this.geoJsonLayer.getLayers()[0].feature.geometry.type == 'Point'
            ) {
              this.createPoints(this.geoJsonLayer.getLayers());
            } else if (
              this.geoJsonLayer.getLayers()[0].feature.geometry.type ==
              'MultiPolygon'
            ) {
              this.createCZML('MultiPolygon', this.geoJsonLayer.getLayers()[0]);
            } else if (
              this.geoJsonLayer.getLayers()[0].feature.geometry.type ==
              'Polygon'
            ) {
              this.createCZML('polygon', this.geoJsonLayer.getLayers()[0]);
            }

            if (this.geoJsonLayer) {
              this.map.fitBounds(this.geoJsonLayer.getBounds());
              this.eventLayers = [];
              this.eventLayers.push(this.geoJsonLayer.getBounds());
              this.geoJsonLayer.addTo(this.map);
            }
          }
        };
        reader.readAsText(file);
        this.disableEnableDrawControls(true, 'fileupload');
      }
    });
    const spanContainer2: any = L.DomUtil.create('span');
    spanContainer.title = filUploadButton.title;
    spanContainer.style.position = 'relative';
    const resetButton: any = L.DomUtil.create('a', 'leaflet-draw-draw-delete');
    resetButton.href = '#';
    resetButton.innerHTML = '<img src="../../../assets/map-icons/reset.svg" >';
    resetButton.title = 'Clear';
    resetButton.style.backgroundColor = 'white';
    resetButton.style.cursor = 'pointer';
    resetButton.style.display = 'flex';
    resetButton.style.justifyContent = 'center';
    resetButton.style.alignItems = 'center';
    resetButton.classList.add('custom-button-leaflet');
    if (this.route.snapshot.url.join('/').includes('retask')) {
      resetButton.classList.add('disable-button');
    }
    resetButton.addEventListener('click', (event: any) => {
      const searchBtnParentEl = document.querySelector(
        '.leaflet-geosearch-button'
      ) as HTMLElement;
      searchBtnParentEl.classList.remove('active');
      this.isDrawControlClicked = false;
      this.selectedDrawControl = '';
      this.isResetClicked = true;
      this.eventLayers = [];
      this.pointArray = [];
      this.target.multiTarget = [];
      this.target.geoJSON = null;
      this.target.area = null;
      this.target.geotargets = null;
      this.callCounter = 0;
      this.shapeSelected = false;
      this.position = null;
      this.layerData = null;
      if (this.marker) {
        this.map.removeLayer(this.marker);
        this.marker = null;
      }
      if (this.geoJsonLayer) {
        this.map.removeLayer(this.geoJsonLayer);
        this.geoJsonLayer = null;
      }

      this.markersAndDivs.forEach((customDivs) => {
        customDivs.div.remove();
      });
      if (this.numberBadgeMarkers && this.numberBadgeMarkers.length > 0) {
        this.numberBadgeMarkers.forEach((badge) => {
          if (this.map && badge) {
            this.map.removeLayer(badge);
          }
        });
        this.numberBadgeMarkers = [];
      }

      this.markersAndDivs = [];
      this.map.off('mousemove', this.updateTooltipPosition);
      this.map.off('touchmove', this.updateTooltipPosition);
      this.map.off('click', this.setTooltip);
      if (this.drawControl._toolbars.draw._activeMode) {
        this.drawControl._toolbars.draw._activeMode.handler.disable();
      }
      event.preventDefault();
      if (this.taskStrategy === 'TLE Based Tasking') {
        this.disableEnableDrawControls(false, '', 'TLE');
      } else {
        this.disableEnableDrawControls(true, 'reset');
      }

      resetButton.className =
        'leaflet-draw-draw-delete leaflet-draw-toolbar-button-enabled custom-button-leaflet';
      if (this.drawnItems) {
        this.drawnItems.clearLayers();
      }
      if (this.drawTooltip) {
        this.map.removeLayer(this.drawTooltip);
        this.drawTooltip = null;
      }
      this.clearSearchResults();
      this.clearRFCircleLayers();
      this.polylines.forEach((polyline: any, i: any) => {
        if (polyline?.image) {
          this.map.removeLayer(polyline?.image);
        }
        if (polyline?.polyline) {
          this.map.removeLayer(polyline?.polyline);
        }
        if (polyline?.text) {
          this.map.removeLayer(polyline?.text);
        }
      });
      this.polylines = [];
      event.stopPropagation();
      if (this.selectedCategory === this.nonImagingSensor){
      this.updateFrequencyOption = false;
      this.budgetSensorType = [];
      const sensorCategoryControl = this.budgetForm.get('sensorCategory');
      this.resetForm();
      sensorCategoryControl?.setValue(this.selectedCategory);
      this.showResolution =
      this.selectedCategory !== STRINGCONSTANTS.NON_IMAGING_SENSOR;
      }
    });

    this.resetButton = resetButton;

    spanContainer2.appendChild(resetButton);
    buttonContainer.appendChild(spanContainer);
    buttonContainer.appendChild(spanContainer2);

    spanContainer2.parentNode.insertBefore(
      document.querySelector('#span4'),
      spanContainer2
    );
    const toolbar1: any = document.querySelector('.leaflet-draw-toolbar');
    const links: any[] = toolbar1.querySelectorAll('a');
    links.forEach((link: any, index: any) => {
      link.classList.add('custom-button-leaflet');
    });

    if (this.route.snapshot.url.join('/').includes('retask')) {
      this.disableEnableDrawControls(false, '');
    }
  }

  triggerResetButtonClick() {
    this.resetButton.click(); // This will simulate a click on the button
  }

  private createPoints(layer) {
    for (let markerLayer of layer) {
      this.pointArray.push(
        `POINT (${markerLayer.getLatLng().lng} ${markerLayer.getLatLng().lat})`
      );
    }
    this.target.multiTarget = this.pointArray;
    this.target.geoJSON = this.pointArray.join(',');
    const geoPoints = this.geoParsePoint(this.target.geoJSON);
    this.target.geotargets = JSON.stringify(geoPoints);
    this.disableEnableDrawControls(false, '');
    let isInside = false;
    if (this.currentUser?.isTaskableAoi) {
      isInside =  this.currentUser.taskableAoi.some((aoi) =>this.utilsService.pointInPolygon(
        geoParse(this.pointArray[this.pointArray.length - 1]).coordinates,
        aoi.taskableAoi.coordinates[0]
      ));
      if (!isInside) {
        this.eventLayers.pop();
        this.pointArray.pop();
        const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        this.resetMap();
        this.disableEnableDrawControls(true, '');
      } else {
        // this.disableEnableDrawControls(false, event.layerType)
      }
    }
  }

  private setupEventListeners(): void {
    this.map.on((L as any).Draw.Event.DRAWSTART, this.onDrawStart);
    this.map.on('draw:drawvertex', this.onDrawVertex);
    this.map.on((L as any).Draw.Event.CREATED, this.onDrawCreated);
    this.map.on('draw:drawstop', this.onDrawCancel);
    this.map.on('popupopen', this.handlePopupOpen);
    this.map.on('zoomend', this.HandleZoomEnd);
    this.map.on('geosearch/showlocation', this.handleGeoLocation);
    this.map.on('mousemove', this.handleMouseMove);
    this.map.on('move', this.handleMapMove);
    document.addEventListener(
      'fullscreenchange',
      this.onFullscreenChange.bind(this)
    );
    this.map.doubleClickZoom.disable();
  }

  customizeToolbar(): void {
    setTimeout(() => {
      const toolbar: any = document.querySelector('.leaflet-draw-toolbar');
      if (!toolbar) return;

      toolbar?.addEventListener('dblclick', (event) => {
        this.map.doubleClickZoom.disable();
      });

      const buttonDetails = [
        { className: 'leaflet-draw-draw-marker', title: 'Place POI as Point' },
        {
          className: 'leaflet-draw-draw-rectangle',
          title: 'Draw AOI as rectangle',
        },
        { className: 'leaflet-draw-draw-circle', title: 'Draw AOI as circle' },
        {
          className: 'leaflet-draw-draw-polygon',
          title: 'Draw AOI as polygon',
        },
        { className: 'leaflet-draw-draw-polyline', title: 'Measure distance' },
      ];

      const orderedButtons = buttonDetails
        .map((detail, i) => {
          const button = toolbar.querySelector(`.${detail.className}`);
          if (button) {
            this.renderer.setAttribute(button, 'title', detail.title);
            const span = document.createElement('span');
            // span.setAttribute('title', detail.title);
            span.setAttribute('id', 'span' + i);
            span.appendChild(button);
            return span;
          }
          return null;
        })
        .filter((span) => span !== null);
      while (toolbar.firstChild) {
        toolbar.removeChild(toolbar.firstChild);
      }
      orderedButtons.forEach((span: any) => toolbar.appendChild(span));
      this.addCustomButtons();
      const toolbarButtons = document.querySelectorAll(
        '.leaflet-draw-toolbar span a'
      );
      toolbarButtons.forEach((span: any) => {
        span.addEventListener('click', (event: any) => {
          this.removeHighlight();
          toolbarButtons.forEach((s: any) =>
            s.classList.remove('highlight-border')
          );
          event.currentTarget.classList.add('highlight-border');
          let layerList: any = document.querySelector(
            '.leaflet-control-layers-expanded'
          );
          if (layerList) {
            layerList.classList.remove('leaflet-control-layers-expanded');
            document
              .querySelector('.leaflet-control-layers-toggle')
              ?.setAttribute('style', 'top:0px !important');
          }
        });
      });
    }, 10);
  }

  removeHighlight() {
    let homeBtn: any = document.querySelector('#homeButton');
    if (homeBtn) {
      homeBtn.classList.remove('highlight-border');
    }
    let layerBtn: any = document.querySelector(
      '.leaflet-control-layers-toggle'
    );
    if (layerBtn) {
      layerBtn.classList.remove('highlight-border');
    }
  }

  onDrawStart = (event: any) => {
    this.removeHighlight();
    this.isDrawControlClicked = true;
    this.callCounter = 0;
    this.isFirstVertexPlaced = false;
    this.isDrawStarted = false;
    this.selectedDrawControl = event.layerType;
    if (!this.drawTooltip) {
      this.drawTooltip = L.tooltip({
        permanent: true,
        className: 'custom-tooltip',
      }).setLatLng([0, 0]);
    }
    if (event.layerType === 'polygon' || event.layerType === 'polyline') {
      this.map.on('click', this.setTooltip);
    }
    if (event.layerType === 'rectangle' || event.layerType === 'circle') {
      this.map.on('mousedown touchstart', this.handleMouseDown);
    }
  };

  onDrawVertex = (event: any) => {
    if (!this.isFirstVertexPlaced) {
      this.isFirstVertexPlaced = true;
      this.map.on('mousemove', this.updateTooltipPosition);
    }
  };

  onDrawCreated = (event: any) => {
    this.removeHighlight();
    const toolbarButtons = document.querySelectorAll('.leaflet-draw-toolbar a');
    toolbarButtons.forEach((btn) => btn.classList.remove('highlight-border'));
    this.position = event.layer;
    this.layerData = event;
    const layerCount = this.drawnItems.getLayers().length;

    this.drawnItems.addLayer(this.position);

    this.isResetClicked = false;
    this.target.multiTarget = this.pointArray;
    // this.isDrawControlClicked = false;
    let poiWkt = '';
    let isInside: any;
    if (event.layerType != 'marker' && event.layerType != 'polyline') {
      this.eventLayers = [];
    }
    if (event.layerType == 'rectangle' || event.layerType == 'polygon') {
      this.eventLayers.push(this.position.getLatLngs());
    } else if (event.layerType == 'circle') {
      let cordinates = this.circleToBoxCordinates(this.position);
      this.eventLayers.push(cordinates);
    } else if (event.layerType == 'marker') {
      this.getCountryAndPlace(
        this.position.getLatLng().lat,
        this.position.getLatLng().lng,
        'search'
      );
      this.clearSatllite();
      this.clearRFCircleLayers();
      this.pointArray = [];
      this.target.multiTarget = [];
      this.eventLayers.push(this.position);
      if (
        this.taskStrategy === 'TLE Based Tasking' &&
        this.eventLayers?.length > 1
      ) {
        this.eventLayers.pop();
        const msg =
          'For TLE Based Tasking, only one POI is allowed. Click the existing pin to remove it, then place a new one.';
        this.popupService.openPopup(WarningPopup, msg, '', '50%');
        if (this.map.hasLayer(this.position)) {
          this.map.removeLayer(this.position);
        }

        return;
      } else if (this.pointEntities.length >= 3) {
        const msg = 'The maximum number of points for multiple points of interest (POIs) tasking is three.';
        this.popupService.openPopup(CollectionPopupComponent, msg, '', '50%');
        return; 
      } 
      for (let markerLayer of this.eventLayers) {
        this.pointArray.push(
          `POINT (${markerLayer.getLatLng().lng} ${
            markerLayer.getLatLng().lat
          })`
        );
      }
      if (this.currentUser?.isTaskableAoi) {
        isInside =  this.currentUser.taskableAoi.some((aoi) =>this.utilsService.pointInPolygon(
          geoParse(this.pointArray[this.pointArray.length - 1]).coordinates,
          aoi.taskableAoi.coordinates[0]
        ));
        if (!isInside) {
          this.eventLayers.pop();
          this.pointArray.pop();
          const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
          this.removeLastPin(event);
          this.disableEnableDrawControls(true, '');
        } else {
          this.disableEnableDrawControls(false, event.layerType);
        }
      }
      this.target.area = 0;
      if (this.pointArray?.length === 1) {
        this.target.geoJSON = this.pointArray[0];
        this.target.multiTarget = [];
      } else {
        this.target.multiTarget = this.pointArray;
        this.target.geoJSON = this.pointArray.join(', ');
        const geoPoints = this.geoParsePoint(this.target.geoJSON);
        this.target.geotargets = JSON.stringify(geoPoints);
      }
      this.target.fileName = '';
    }
    this.map.off('mousemove', this.updateTooltipPosition);
    this.map.off('click', this.setTooltip);
    this.map.off('touchstart', this.handleMouseDown);
    this.map.off('mousedown', this.handleMouseDown);
    this.map.off('touchmove', this.updateTooltipPosition);
    if (event.layerType == 'marker') {
      const existingMarkers = Object.values(
        (this.drawnItems as any)._layers
      ).filter((l: any) => l instanceof L.Marker);
      if (
        existingMarkers.length > 3 &&
        !this.currentUser.pointsEligible &&
        !this.budget
      ) {
        const msg =
          'The maximum number of points for multiple points of interest (POIs) tasking is three.';
        this.popupService.openPopup(CollectionPopupComponent, msg, '', '50%');

        if (this.map.hasLayer(event.layer)) {
          this.map.removeLayer(event.layer);
        }
        const layerValue = this.drawnItems.getLayer(event.layer._leaflet_id);
        if (layerValue) {
          this.drawnItems.removeLayer(layerValue);
          this.eventLayers = this.eventLayers.filter((layer1: any) => {
            return layer1._leaflet_id != (layerValue as any)._leaflet_id;
          });
        }
        return;
      }
      this.generateMarkerNumber();
      this.position.on(
        'click',
        this.markerClickListener.bind(this, this.position)
      );
      this.position.on(
        'mouseover',
        this.markerMouseOverListener.bind(this, this.position)
      );
    } else if (event.layerType == 'polyline') {
      let totalDistance = this.calculatePolylineDistace(this.position);
      this.onPopupOpen(event, totalDistance / 1000);
    } else if (event.layerType == 'rectangle') {
      let totalDistance = this.calculateRectanglePerimater(
        this.position._bounds._northEast,
        this.position._bounds._southWest
      );
      this.onPopupOpen(event, totalDistance / 1000);
      this.createCZML('rectangle', this.position);
    } else if (event.layerType == 'polygon') {
      let totalDistance = this.calculatePolygonPerimeter(this.position);
      this.onPopupOpen(event, totalDistance / 1000);
      this.createCZML('polygon', this.position);
    } else if (event.layerType == 'circle') {
      let totalDistance = this.calculateCircleCircumference(this.position);
      this.onPopupOpen(event, totalDistance / 1000);
      this.createCZML('circle', this.position);
    }
    if (this.drawTooltip) {
      this.map.removeLayer(this.drawTooltip);
      this.drawTooltip = null;
    }
    if (event.layerType != 'polyline') {
      if (!this.currentUser?.isTaskableAoi) {
        this.disableEnableDrawControls(false, event.layerType);
      }
    }
    if (event.layerType != 'polyline') {
      this.updateTarget(this.target, '1');
    }
    this.selectedDrawControl = '';
  };

  removeLastPin(event) {
    if (this.map.hasLayer(event.layer)) {
      this.map.removeLayer(event.layer);
    }
    const layerValue = this.drawnItems.getLayer(event.layer._leaflet_id);
    if (layerValue) {
      this.drawnItems.removeLayer(layerValue);
      this.eventLayers = this.eventLayers.filter((layer1: any) => {
        return layer1._leaflet_id != (layerValue as any)._leaflet_id;
      });
    }
  }
  private ensureNumberPane() {
    if (this.numberPaneCreated || !this.map) return;
    this.map.createPane('poi-number-pane');
    const pane = this.map.getPane('poi-number-pane')!;
    pane.style.zIndex = '650';
    pane.style.pointerEvents = 'none';
    this.numberPaneCreated = true;
  }

  private clearNumberBadges() {
    if (!this.map) return;
    this.numberBadgeMarkers.forEach((lb) => this.map.removeLayer(lb));
    this.numberBadgeMarkers = [];
  }

  private generateMarkerNumber(): void {
    this.ensureNumberPane();
    const markers: L.Marker[] = (this.eventLayers || []).filter(
      (l: any) => typeof (l as L.Marker)?.getLatLng === 'function'
    );

    this.clearNumberBadges();

    if (markers.length < 2) return;

    markers.forEach((m, i) => {
      const n = i + 1;

      const html = `
      <span
        style="
          position: relative;
          display: inline-block;
          font-weight: 500;
          font-size: 18px;
          line-height: 1;
          color: #fff;                 
          transform: translate(-50%, -100%);
          left: 50%;
          white-space: nowrap;
          pointer-events: none;
        "
      >${n}</span>
    `;

      const label = L.marker(m.getLatLng(), {
        interactive: false,
        pane: 'poi-number-pane',
        zIndexOffset: 1000,
        icon: L.divIcon({
          className: 'poi-number-divicon',
          html,
          iconSize: [1, 1],
          iconAnchor: [0, 45],
        }),
      });

      label.addTo(this.map);
      this.numberBadgeMarkers.push(label);
    });
  }

  createCZML(mode, layer) {
    let target: any = {};
    const accuracy = 15;
    let polyPts: any = [],
      aoi;
    let aoiWkt: any = 'POLYGON ((';
    let lng0 = 0,
      lat0 = 0;
    if (mode == 'polygon') {
      target.polygon = true;
      this.target.polygon = true;
      lng0 = layer.getLatLngs()[0].lng;
      lat0 = layer.getLatLngs()[0].lat;
      for (let i = 0; i < layer.getLatLngs()[0].length; i++) {
        aoiWkt =
          aoiWkt +
          `${layer.getLatLngs()[0][i].lng.toFixed(accuracy)} ${layer
            .getLatLngs()[0]
            [i].lat.toFixed(accuracy)}, `;
      }
      aoiWkt =
        aoiWkt +
        `${layer.getLatLngs()[0][0].lng.toFixed(accuracy)} ${layer
          .getLatLngs()[0][0]
          .lat.toFixed(accuracy)}`;
      aoi = layer.toGeoJSON();
    } else if (mode == 'MultiPolygon') {
      for (let i = 0; i < layer.getLatLngs()[0][0].length; i++) {
        aoiWkt =
          aoiWkt +
          `${layer.getLatLngs()[0][0][i].lng.toFixed(accuracy)} ${layer
            .getLatLngs()[0][0]
            [i].lat.toFixed(accuracy)}, `;
      }
      aoiWkt =
        aoiWkt +
        `${layer.getLatLngs()[0][0][0].lng.toFixed(accuracy)} ${layer
          .getLatLngs()[0][0][0]
          .lat.toFixed(accuracy)}`;
      aoi = layer.toGeoJSON();
    } else if (mode == 'rectangle') {
      let lng0 = layer.getBounds()._northEast.lng;
      let lat0 = layer.getBounds()._northEast.lat;
      let lng2 = layer.getBounds()._southWest.lng;
      let lat2 = layer.getBounds()._southWest.lat;
      aoi = layer.toGeoJSON();
     aoiWkt = aoiWkt + `${lng2.toFixed(accuracy)} ${lat0.toFixed(accuracy)}, `; 
     aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}, `;
     aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat2.toFixed(accuracy)}, `;
     aoiWkt = aoiWkt + `${lng2.toFixed(accuracy)} ${lat2.toFixed(accuracy)}, `;
     aoiWkt = aoiWkt + `${lng2.toFixed(accuracy)} ${lat0.toFixed(accuracy)}`;      
    } else if (mode === 'circle') {
      let radius = layer.getRadius() / 1000;
      const circle = turf.circle(
        [layer.getLatLng().lng, layer.getLatLng().lat],
        radius,
        { steps: 64 }
      );
      aoi = turf.bboxPolygon(turf.bbox(circle));
      let lng0 = aoi.bbox[0];
      let lat0 = aoi.bbox[1];
      let lng2 = aoi.bbox[2];
      let lat2 = aoi.bbox[3];
      aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}, `;
      aoiWkt = aoiWkt + `${lng2.toFixed(accuracy)} ${lat0.toFixed(accuracy)}, `;
      aoiWkt = aoiWkt + `${lng2.toFixed(accuracy)} ${lat2.toFixed(accuracy)}, `;
      aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat2.toFixed(accuracy)}, `;
      aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}`;
    }
    aoiWkt = aoiWkt + `))`;

    if (!aoi) return;
    const areaVal = turf.area(aoi) / 1000000;
    let areaMsg = '';
    var aoiArea = areaVal.toFixed(2);
    this.target.geoJSON = aoiWkt;
    this.target.area = aoiArea;
    this.target.fileName = this.fileName;
    this.getCountryAndPlace(lat0, lng0, geoParse(this.target.geoJSON));

    if (this.currentUser?.isTaskableAoi) {
      let isInside =  this.currentUser.taskableAoi.some((aoi) =>this.utilsService.comparePolygons(
        geoParse(this.target.geoJSON).coordinates[0],
        aoi.taskableAoi.coordinates[0]
      ));
      if (!isInside) {
        const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        this.resetMap();
        this.disableEnableDrawControls(true, '');
      } else {
        // this.updateTarget(target, '1');
        this.disableEnableDrawControls(false, '');
      }
    } else {
      this.updateTarget(this.target, '1');
    }
  }

  onDrawCancel = (e: any) => {
    if (this.drawTooltip) {
      this.map.removeLayer(this.drawTooltip);
      this.drawTooltip = null;
      this.map.off('mousemove', this.updateTooltipPosition);
      this.map.off('touchmove', this.updateTooltipPosition);
      this.map.off('click', this.setTooltip);
      this.map.off('touchstart', this.handleMouseDown);
      this.map.off('mousedown', this.handleMouseDown);

      this.selectedDrawControl = '';
      this.resetForm();
    }
  };

  viewHome(event: any) {
    this.removeHighlight();

    /** reset search */
    this.resetSearchInput();

    let layerList: any = document.querySelector(
      '.leaflet-control-layers-expanded'
    );
    if (layerList) {
      layerList.classList.remove('leaflet-control-layers-expanded');
    }

    document
      .querySelector('.leaflet-control-layers-toggle')
      ?.setAttribute('style', 'top:0px !important');

    let homeBtn: any = document.querySelector('#homeButton');
    homeBtn.classList.add('highlight-border');

    if (this.route.snapshot.url.join('/').includes('retask')) {
      const data = localStorage.getItem('rowData');
      if (data != null) {
        this.selectedTasks = JSON.parse(data);
        const points = JSON.parse(this.selectedTasks.target);
        if (points && points['type'] == 'Polygon') {
          var latLngsArray = points['coordinates'][0].map(function (latlng) {
            return L.latLng(latlng[1], latlng[0]);
          });
          var bounds = L.latLngBounds(latLngsArray);
          this.map.fitBounds(bounds);
          this.map.setZoom(this.zoomLevel);
        } else if (points && points['type'] == 'Point') {
          this.map.setView(
            [points['coordinates'][1], points['coordinates'][0]],
            this.zoomLevel
          );
        }
      }
    } else if (this.layerData) {
      if (this.layerData?.layerType == 'marker') {
        this.map.setView(
          [this.position.getLatLng().lat, this.position.getLatLng().lng],
          5
        );
      } else if (this.position?.getBounds()) {
        this.map.fitBounds(this.position?.getBounds());
      } else if (
        this.position &&
        typeof this.position.getLatLng === 'function'
      ) {
        this.map.setView(
          [this.position.getLatLng().lat, this.position.getLatLng().lng],
          this.zoomLevel
        );
      } else if (
        this.position &&
        typeof this.position.getLatLngs() === 'object'
      ) {
        this.map.setView(
          [
            this.position.getLatLngs()[0][0].lat,
            this.position.getLatLngs()[0][0].lng,
          ],
          this.zoomLevel
        );
      }
    } else {
      if (this.marker) {
        this.map.setView(
          [this.eventLayers[1], this.eventLayers[0]],
          this.zoomLevel
        );
      } else {
        this.zoomLevel = 3;
        this.setMapView(this.lattitude, this.longitude);
      }
    }
    this.calculateZoomLevel();
    event.stopPropagation();
  }

  handleGeoLocation = (result: any) => {
    this.selectedDrawControl = '';
    const coordinates: any = result.location;
    this.eventLayers = [];
    this.eventLayers.push(coordinates.x, coordinates.y);
    if (this.searchMarker) {
      this.map.removeLayer(this.searchMarker);
    }
    this.searchMarker = result.marker;
    this.map.addLayer(this.searchMarker);
    this.map.setView([coordinates.y, coordinates.x], this.zoomLevel);
  };

  handleMouseDown = (e: any) => {
    const toolbarButtons = document.querySelectorAll('.leaflet-draw-toolbar a');
    toolbarButtons.forEach((btn) => btn.classList.remove('highlight-border'));
    this.setTooltip(e);
    this.map.on('mousemove touchmove', this.updateTooltipPosition);
  };

  handleMouseMove = (e: any) => {
    this.latLngDMS = this.decimalToDMS(e.latlng.lat, e.latlng.lng);
    let isInside = false;
    if (this.currentUser?.taskableAoi?.length > 0) {
      isInside = this.currentUser.taskableAoi.some((aoi) =>this.utilsService.pointInPolygon(
        [e.latlng.lng, e.latlng.lat],
        aoi?.taskableAoi?.coordinates[0]
      ));
    }

    if (this.currentUser?.taskableAoi) {
      if (!this.drawTooltip) {
        this.drawTooltip = L.tooltip({
          permanent: true,
          className: 'custom-tooltip',
        }).setLatLng([0, 0]);
        this.map.addLayer(this.drawTooltip);
      }
      if (isInside && this.isDrawControlClicked == false) {
        this.drawTooltip.setLatLng(e.latlng);
        this.drawTooltip.setOpacity(0);
      } else if (!isInside && this.isDrawControlClicked == false) {
        this.map.removeLayer(this.drawTooltip);
        this.drawTooltip = null;
      }
    }
  };

  handleMapMove = (e: any) => {
    const toolbarButtons = document.querySelectorAll('.leaflet-draw-toolbar a');
    toolbarButtons.forEach((btn) => btn.classList.remove('highlight-border'));
    this.eventLayers.forEach((layer) => {
      this.updateDivPosition();
    });
  };

  customDiv: any;
  updateDivPosition = () => {
    this.markersAndDivs.forEach((item, index) => {
      if (item.layer && item.layer.getLatLng()) {
        var point = this.map.latLngToContainerPoint(item.layer.getLatLng());
        this.markersAndDivs[index].div.style.left = point.x - 5 + 'px';
        this.markersAndDivs[index].div.style.top = point.y - 65 + 'px';
      }
    });
  };

  updateTooltipPosition = (mouseEvent: any) => {
    if (!this.drawTooltip) {
      this.drawTooltip = L.tooltip({
        permanent: true,
        className: 'custom-tooltip',
      });
      this.map.addLayer(this.drawTooltip);
    }

    const toolbarButtons = document.querySelectorAll('.leaflet-draw-toolbar a');
    toolbarButtons.forEach((btn) => btn.classList.remove('highlight-border'));
    let distance = 0;
    if (this.drawTooltip) {
      if (this.selectedDrawControl == 'rectangle') {
        const endPoint = mouseEvent.latlng;
        distance = this.calculateRectanglePerimater(this.startPoint, endPoint);
      } else {
        distance = this.startPoint?.distanceTo(mouseEvent.latlng);
      }
      this.drawTooltip.setContent((distance / 1000).toFixed(2) + ' km');
      this.drawTooltip.setLatLng(mouseEvent.latlng);
    }
  };

  setTooltip = (mouseEvent: any) => {
    const toolbarButtons = document.querySelectorAll('.leaflet-draw-toolbar a');
    toolbarButtons.forEach((btn) => btn.classList.remove('highlight-border'));
    this.isDrawStarted = true;
    if (!this.drawTooltip) {
      this.drawTooltip = L.tooltip({
        permanent: true,
        className: 'custom-tooltip',
      }).setLatLng([0, 0]);
    }
    if (this.drawTooltip) {
      this.map.addLayer(this.drawTooltip);
      this.startPoint = mouseEvent.latlng;
      this.drawTooltip.setLatLng(mouseEvent.latlng);
      this.drawTooltip.setContent('Drawing...');
      this.drawTooltip.openTooltip();
    }
  };

  markerMouseOverListener = (layer: any) => {
    layer.bindTooltip('Click to remove').openTooltip();
  };

  markerClickListener = (layer: any) => {
    this.clearRFCircleLayers();
    const layerValue = this.drawnItems.getLayer(layer._leaflet_id);
    if (layerValue) {
      this.drawnItems.removeLayer(layerValue);
    }
    const toolbarButtons = document.querySelectorAll('.leaflet-draw-toolbar a');
    toolbarButtons.forEach((btn) => btn.classList.remove('highlight-border'));
    this.pointArray = [];
    let poiWkt = '';
    this.map.removeLayer(layer);
    this.eventLayers = this.eventLayers.filter((layer1: any) => {
      return layer1._leaflet_id != layer._leaflet_id;
    });
    for (let markerLayer of this.eventLayers) {
      this.pointArray.push(
        `POINT (${markerLayer.getLatLng().lng} ${markerLayer.getLatLng().lat})`
      );
    }
    if (this.pointArray?.length === 1) {
      this.target.geoJSON = this.pointArray[0];
      this.target.multiTarget = [];
    } else {
      this.target.multiTarget = this.pointArray;
    }
    this.target.geoJSON = this.pointArray.join(',');
    const geoPoints = this.geoParsePoint(this.target.geoJSON);
    this.target.geotargets = JSON.stringify(geoPoints);
    this.generateMarkerNumber();
    this.updateTarget(this.target, '1');
    if (this.pointArray.length === 0) {
      this.disableEnableDrawControls(true, '');
    }
  };

  HandleZoomEnd = () => {
    this.calculateZoomLevel();
  };

  calculateZoomLevel = () => {
    this.zoomLevel = this.map.getZoom();
    const bounds = this.map.getBounds();
    const distance = bounds.getSouthWest().distanceTo(bounds.getNorthEast());
    this.mapDistance = distance / 1000;
  };

  calculatePolylineDistace = (layer: any) => {
    let distance = 0;
    layer.getLatLngs().forEach((latLng: any, index: any, array: any[]) => {
      if (index < array.length - 1) {
        distance += latLng.distanceTo(array[index + 1]);
      }
    });
    return distance;
  };

  calculateRectangleDistace = (layer: any) => {
    const bounds = layer.getBounds();
    const northEast = bounds.getNorthEast();
    const southWest = bounds.getSouthWest();
    const northWest = L.latLng(northEast.lat, southWest.lng);
    const southEast = L.latLng(southWest.lat, northEast.lng);
    const north = northWest.distanceTo(northEast);
    const east = northEast.distanceTo(southEast);
    const south = southEast.distanceTo(southWest);
    const west = southWest.distanceTo(northWest);
    const perimeter = north + east + south + west;
    return perimeter;
  };

  calculateRectanglePerimater = (startPoint: any, endPoint: any) => {
    const northEast = L.latLng(startPoint.lat, endPoint.lng);
    const southWest = L.latLng(endPoint.lat, startPoint.lng);
    const width = startPoint.distanceTo(northEast);
    const height = startPoint.distanceTo(southWest);
    return 2 * (width + height);
  };

  calculatePolygonPerimeter(polygon: any) {
    const vertices = polygon.getLatLngs();
    let perimeter = 0;
    if (Array.isArray(vertices[0])) {
      vertices[0].forEach((point, index, arr) => {
        if (index < arr.length - 1) {
          perimeter += point.distanceTo(arr[index + 1]);
        }
      });
      perimeter += vertices[0][vertices[0].length - 1].distanceTo(
        vertices[0][0]
      );
    }
    return perimeter;
  }

  calculateCircleCircumference(circle: any) {
    const radius = circle.getRadius();
    const circumference = 2 * Math.PI * radius;
    return circumference;
  }

  disableEnableDrawControls(isEnable: boolean, layerType: any, strategy?: any) {
    const toolbar: any = document.querySelector('.leaflet-draw-toolbar');
    const links: any[] = toolbar.querySelectorAll('a');
    if (isEnable == true) {
      links.forEach((link: any, index: any) => {
        link.classList.remove('disable-button');
        if (layerType == 'fileupload') {
          if (index == 0) {
            link.classList.add('disable-button');
          }
        }
      });
    } else {
      links.forEach((link: any, index: any) => {
        if (
          index != 5 &&
          index != 6 &&
          !(index == 0 && layerType == 'marker') &&
          !(index == 0 && strategy === 'TLE')
        ) {
          link.classList.add('disable-button');
        }
      });
    }
  }

  circleToBoxCordinates(circle: any): any {
    const center = circle.getLatLng();
    const radius = circle.getRadius() / 1000;
    const circleTurf = turf.circle([center.lng, center.lat], radius, {
      steps: 64,
    });
    // const circleGeoJSON = turf.feature(circleTurf);
    let circleAOI: any = turf.bboxPolygon(turf.bbox(circleTurf));
    let circleLng0 = circleAOI.bbox[0];
    let circleLat0 = circleAOI.bbox[1];
    let circleLng1 = circleAOI.bbox[2];
    let circleLat1 = circleAOI.bbox[3];
    let circleBoxCordinates = '';
    let accuracy = 15;
    circleBoxCordinates =
      circleBoxCordinates +
      `${circleLng0.toFixed(accuracy)} ${circleLat0.toFixed(accuracy)}, `;
    circleBoxCordinates =
      circleBoxCordinates +
      `${circleLng1.toFixed(accuracy)} ${circleLat0.toFixed(accuracy)}, `;
    circleBoxCordinates =
      circleBoxCordinates +
      `${circleLng1.toFixed(accuracy)} ${circleLat1.toFixed(accuracy)}, `;
    circleBoxCordinates =
      circleBoxCordinates +
      `${circleLng0.toFixed(accuracy)} ${circleLat1.toFixed(accuracy)}, `;
    circleBoxCordinates =
      circleBoxCordinates +
      `${circleLng0.toFixed(accuracy)} ${circleLat0.toFixed(accuracy)}`;
    return circleBoxCordinates;
  }

  private onPopupOpen(event: any, totalDistance: any): void {
    const popupContent = `<div>Total Distance : ${Number(totalDistance).toFixed(
      2
    )} km ${
      event.layerType == 'polyline'
        ? '<button class="closeButton">Close</button>'
        : ''
    }</div>`;
    let specificLatLng = L.latLng(51.505, -0.09);
    if (event.layerType == 'polyline') {
      specificLatLng = event.layer._latlngs[event.layer._latlngs.length - 1];
    }
    if (event.layerType == 'rectangle' || event.layerType == 'polygon') {
      specificLatLng = event.layer._latlngs[0][event.layer._latlngs.length - 1];
    }
    if (event.layerType == 'circle') {
      specificLatLng = event.layer._latlng;
    }
    event.layer
      .bindPopup(popupContent, {
        autoClose: false,
        closeOnClick: false,
        direction: 'auto',
        closeButton: false,
      })
      .addTo(this.map);
    event.layer.off('click');
    event.layer.openPopup(specificLatLng);
  }

  handlePopupOpen = (event: any) => {
    const closeButton = event.popup._container.querySelector('.closeButton');
    if (closeButton) {
      closeButton.onclick = () => {
        const layer = event.popup._source;
        this.map.removeLayer(layer);
      };
    }
  };

  decimalToDMS(lat: number, lng: number): string {
    const convert = (decimal: number) => {
      const absolute = Math.abs(decimal);
      const degrees = Math.floor(absolute);
      const minutesNotTruncated = (absolute - degrees) * 60;
      const minutes = Math.floor(minutesNotTruncated);
      const seconds = Math.floor((minutesNotTruncated - minutes) * 60);
      return `${degrees}° ${minutes}' ${seconds}"`;
    };
    const latitude = convert(lat) + (lat >= 0 ? ' N' : ' S');
    const longitude = convert(lng) + (lng >= 0 ? ' E' : ' W');
    return `Lng:${longitude}, Lat:${latitude}`;
  }

  clearSearchResults() {
    if (this.searchMarker) {
      this.map.removeLayer(this.searchMarker);
      this.searchMarker = null;
    }
    const input: any = document.querySelector('.glass ');
    if (input) {
      input.value = '';
    }
  }

  async selectRecord(rowData: any) {
    try {
      const res: any = await this.apiService
        .getObservations(rowData?.openWater)
        .toPromise();
      this.observationOptions = res?.observations;
      this.rulesOptions = res?.ruleBased;
      this.feedList = res?.feeds;
      this.formGroup
        .get('tipAndCueBasedOn')
        .setValue(rowData?.tipAndCueBasedOn);
      const ruleFilter = this.rulesOptions.filter(
        (el) => el.rule === rowData?.rule
      );
      this.formGroup.get('rule').setValue(ruleFilter[0]?.rule_key);

      if (rowData?.feeds)
        this.formGroup.get('feeds').setValue(rowData?.feeds[0]?.name);
      if (rowData?.observation)
        this.formGroup
          .get('observation')
          .setValue(rowData?.observation[0]?.name);
    } catch (error) {}

    this.formGroup.get('project').setValue(rowData?.project);
    const modifiedName = rowData?.taskname.replace('_retask', '');
    let taskName = modifiedName + '_retask';
    this.formGroup.get('taskname').setValue(taskName);
    this.formGroup.controls.projectId.setValue(rowData?.projectid);
    this.formGroup.get('purpose').setValue(rowData?.purpose);
    const purposeFilter = this.purposeOption.filter(
      (el) => el.purpose === rowData.purpose
    );
    if (purposeFilter?.length > 0) {
      this.onPurposeChange(purposeFilter[0]);
    } else {
      let option = [
        {
          code: '8',
          purpose: rowData.purpose,
        },
      ];
      this.target.purposeOption = option[0];
    }

    const frequencyFilter = this.frequencyOption.filter(
      (el) => el.id === rowData.frequency
    );
    this.formGroup.get('frequency').setValue(frequencyFilter[0]?.name);
    this.onOptionChange(frequencyFilter[0]?.name);
    if (rowData.taskStrategy) {
      const strategyFilter = this.strategyOptions.filter(
        (el) =>
          el.value === rowData.taskStrategy ||
          (rowData.taskStrategy === 'Tip-and-Cue-Outcome' &&
            el.value === 'Tip-and-Cue')
      );
      this.formGroup.get('strategyRadio').setValue(strategyFilter[0]?.name);
      this.taskStrategy = strategyFilter[0]?.value;
    }
    if (this.taskStrategy === 'TLE Based Tasking') {
      const today = new Date();
      const day = today.getDate();
      const month = today.getMonth() + 1;
      const year = today.getFullYear();
      this.minDate = new Date(year, month - 1, day);
      this.maxDate = new Date(year, month - 1, day + 3);
      this.date = new FormControl(new Date(year, month - 1, day + 1));
      this.range = new FormGroup({
        start: new FormControl(new Date(year, month - 1, day)),
        end: new FormControl(new Date(year, month - 1, day + 3)),
      });
      this.tleSensorForm.patchValue({
        sensorType: rowData.request[0]?.sensortype,
        resolution: rowData.request[0]?.resolution,
        sensor: this.currentUser?.obfuscated
          ? rowData.request[0]?.obfuscateName
          : rowData.request[0]?.name,
      });
      this.selectedSensorObfuscatedName = {
        sensorName: rowData.request[0]?.name,
        obfuscateName: rowData.request[0]?.obfuscateName,
      };
    }

    if (rowData?.intent?.intent_key) {
      const intentFilter = this.intentOption.filter(
        (el) => el.intent_key === rowData?.intent.intent_key
      );
      this.formGroup.get('intent').setValue(intentFilter[0]?.name);
    } else if (rowData?.intent?.key) {
      let intentFilter: any;
      const match = this.intentOption.find(
        (el) => el.intent_key === rowData?.intent.key
      );
      if (match) {
        intentFilter = this.intentOption.filter(
          (el) => el.intent_key === rowData?.intent.key
        );
        this.updatedIntentOption = match;
      } else {
        const internalUseItem = this.intentOption.find(
          (item: any) => item.intent_key === 'internalUse'
        );
        if (internalUseItem) {
          intentFilter = [internalUseItem];
          this.updatedIntentOption = internalUseItem;
        } else {
          intentFilter = [this.intentOption[0]];
          this.updatedIntentOption = this.intentOption[0];
        }
      }
      this.formGroup.get('intent').setValue(intentFilter[0]?.name);
    } else this.formGroup.get('intent').setValue(rowData?.intent);

    if (rowData?.useCase) {
      this.formGroup.get('useCase').setValue(rowData.useCase);
    }

    if (rowData?.useCaseDescription) {
      this.formGroup
        .get('useCaseDescription')
        .setValue(rowData.useCaseDescription);
    }
    this.selectedOption = rowData.frequency;
    this.clickFrequency = true;
    this.subDaily = false;
    if (rowData.frequency === 1) {
      this.target.freqOption = rowData?.repeatFrequency;
      if (this.target.freqOption === 'Sub-daily') {
        this.subDaily = true;
        this.target.subDailyCount = rowData?.subDailyCount;
      }
    }
    let targetData = JSON.parse(rowData.target);
    let type: any, coordinates: any;

    let targetPoints = rowData?.targetPoints
      ? JSON.parse(rowData.targetPoints)
      : null;

    const isLBandIncluded = rowData.request.some(
      (item) => item.operatorKey === OPERATORS.LBAND
    );
    if (targetData?.length > 1) {
      type = targetData[0]?.type.toUpperCase();
      this.createGeoJSONFile(targetData);
    } else {
      type = targetData?.type.toUpperCase();
      coordinates = JSON.parse(rowData.target).coordinates;
      if (type === 'POINT') {
        this.drawPoint(coordinates);
        if (isLBandIncluded) {
          this.drawRFCircle(coordinates, RF_RADIUS * 1000);
        }
      } else if (type === 'POLYGON') {
        this.drawpolygon(coordinates, rowData.area);
        if (isLBandIncluded && targetPoints) {
          let points = targetPoints[0]
            .replace('POINT (', '')
            .replace(')', '')
            .split(' ');
          let coordinates = [parseFloat(points[0]), parseFloat(points[1])];

          //  this.drawPoi(coordinates);
        }
      }
    }
    if (rowData?.taskSubStrategy) {
      const subStartegyFilter = this.subStrategyOptions.filter(
        (el) => el.value === rowData?.taskSubStrategy
      );

      this.formGroup
        .get('subStrategyRadio')
        .setValue(subStartegyFilter[0]?.name);
    }
    this.projName = rowData?.project;
    this.taskName = taskName;
    this.target.projectId = rowData?.projectid;
    this.target.selectedOption = this.selectedOption;
    this.target.fileName = rowData?.fileName;
    this.target.intent =
      this.updatedIntentOption == false
        ? rowData?.intent
        : this.updatedIntentOption;
    this.target.taskStrategy = rowData?.taskStrategy;
    this.taskStrategy = rowData?.taskStrategy;
    this.tipAndCueBasedOn = rowData?.tipAndCueBasedOn;
    this.target.tipAndCueBasedOn = rowData?.tipAndCueBasedOn;
    this.rule = rowData?.rule;
    this.target.rule = rowData?.rule;
    this.observation = rowData?.observation;
    this.target.observation = rowData?.observation;
    this.observationData = rowData?.observationData;
    this.target.observationData = rowData?.observationData;
    if (rowData?.observation) this.target.observation = rowData?.observation[0];
    this.target.useCase = rowData?.useCase;
    this.target.useCaseDescription = rowData?.useCaseDescription;
    this.updateTarget(this.target, '0');
  }

  drawPoint(positionArray) {
    var longitude = parseFloat(positionArray[0]);
    var latitude = parseFloat(positionArray[1]);
    const accuracy = 15;
    let poiWkt = `POINT (${longitude.toFixed(accuracy)} ${latitude.toFixed(
      accuracy
    )})`;
    this.pointEntities.push({ poiWkt: poiWkt });
    this.target.geoJSON = poiWkt;
    this.formGroup.get('target').setValue(poiWkt);
    let marker = L.marker([latitude, longitude]).addTo(this.map);
    this.setMapView(latitude, longitude);
    this.getCountryAndPlace(latitude, longitude, 'search');
  }

  async setMapView(lat, lng) {
    if (this.retask == false) {
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${this.currentUser.country}`;
      const response = await fetch(url);
      const data = await response.json();
      if (data && data.length > 0) {
        const lat = data[0].lat;
        const lon = data[0].lon;
        this.map.setView([lat, lon], 10);
      }
    } else {
      const data = localStorage.getItem('rowData');
      if (data != null) {
        this.selectedTasks = JSON.parse(data);
        const points = JSON.parse(this.selectedTasks.target);
        if (points && points['type'] == 'Polygon') {
          var latLngsArray = points['coordinates'][0].map(function (latlng) {
            return L.latLng(latlng[1], latlng[0]);
          });
          var bounds = L.latLngBounds(latLngsArray);
          this.map.fitBounds(bounds);
          this.map.setZoom(this.zoomLevel);
        } else if (points && points['type'] == 'Point') {
          this.map.setView(
            [points['coordinates'][1], points['coordinates'][0]],
            this.zoomLevel
          );
        }
      }
    }
  }

  drawpolygon(positionArray, area) {
    this.polygons.push(positionArray[0]);
    let aoiWkt: any = 'POLYGON ((';
    const accuracy = 15;
    let polyPts: any = [],
      aoi: any,
      lng0 = 0,
      lat0 = 0;

    let modifiedArray = positionArray[0].map((sub) => {
      return [sub[1], sub[0]];
    });

    var polygon = L.polygon(modifiedArray, { color: 'red' });

    if (polygon && this.map) {
      polygon.addTo(this.map);
      this.map.fitBounds(polygon.getBounds());
      this.rfCircleLayer.push(polygon);
    }

    for (let i = 0; i < positionArray[0]?.length - 1; i++) {
      let lng = positionArray[0][i][0];
      let lat = positionArray[0][i][1];
      if (i === 0) {
        lng0 = lng;
        lat0 = lat;
      }
      polyPts.push([lng, lat]);
      aoiWkt = aoiWkt + `${lng.toFixed(accuracy)} ${lat.toFixed(accuracy)}, `;
    }
    polyPts.push([lng0, lat0]);
    aoi = turf.polygon([polyPts]);
    aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}`;
    aoiWkt = aoiWkt + `))`;
    this.target.geoJSON = aoiWkt;
    this.target.area = area;
    this.formGroup.get('target').setValue(aoiWkt);
    this.getCountryAndPlace(lat0, lng0, geoParse(this.target.geoJSON));
  }

  async createGeoJSONFile(features: any[]) {
    this.pointArray = [];
    const geoJSON: any = {
      type: 'FeatureCollection',
      features: features.map((feature) => ({
        type: 'Feature',
        geometry: {
          type: feature.type,
          coordinates: feature.coordinates,
        },
      })),
    };
    const fpPos = features[0].coordinates;
    const lng = fpPos[0],
      lat = fpPos[1];
    this.map.setView([lat, lng]);
    L.geoJSON(geoJSON).addTo(this.map);

    for (let latlng of features) {
      this.pointArray.push(
        `POINT (${latlng.coordinates[1]} ${latlng.coordinates[0]})`
      );
    }
    this.target.multiTarget = this.pointArray;
    this.target.geoJSON = this.pointArray.join(', ');
    const geoPoints = this.geoParsePoint(this.target.geoJSON);
    this.target.geotargets = JSON.stringify(geoPoints);
  }

  usecasedescChng(event: any) {
    this.target.useCaseDescription = event.target.value;
    this.updateTarget(this.target, '0');
  }

  descChng(event: any) {
    let option = [
      {
        code: '8',
        name: event.target.value,
      },
    ];
    this.target.purposeOption = option[0];
    this.updateTarget(this.target, '0');
  }

  Space(event: any) {
    if (event.target.selectionStart === 0 && event.code === 'Space') {
      event.preventDefault();
    }
  }

  get budgetFields() {
    return this.budgetForm.controls;
  }

  get outcomeFields() {
    return this.outComeForm.controls;
  }

  get fields() {
    return this.formGroup.controls;
  }
  get tleSensorFields() {
    return this.tleSensorForm.controls;
  }

  getTooltip(name: string) {
    if (name === 'Period') return 'Tasked once within the period specified';
    else if (name === 'Specific Date')
      return 'Tasked once on the date specified';
    else if (name === 'Recurrent')
      return 'Tasked repeatedly, either sub-daily, daily, weekly or monthly, within the period specified';
    else return 'Description for ' + name.toLowerCase() + ' frequency';
  }

  private getLayerCount(layer: any): number {
  if (!layer) return 0;
  if (typeof layer.getLayers === 'function') return layer.getLayers().length; // Group/GeoJSON
  return 1; // Polygon/Polyline = single layer
}

    updateTarget(target, idx) {
      const layerCount = this.getLayerCount(this.geoJsonLayer);
       if (idx !== 0 && target?.geoJSON && !target.geoJSON.includes('POINT')) {
        this.callCounter++;
      }
      this.target = { ...target, project: this.projName?.trim(), taskname: this.taskName?.trim() };
       if (
          idx !== 0 &&
          this.callCounter === 1 &&
          (!this.geoJsonLayer || layerCount === 1)
        ) {
          this.isAreaOk(target.area);
        }
      this.resetOutcome();
      this.apiService.updateTaskParams(this.target);
      this.weatherData = [];
      this.formGroup.controls.target.setValue(target?.geoJSON);
      this.closePanels();
    }

  onOptionChange(chosenOption: any) {
    this.resetDateDefault();
    this.dateFlag = false;
    this.subDaily = false;
    this.target.subDailyCount = '';
    const id = this.frequencyOption.findIndex(
      (option) => option.name === chosenOption
    );
    this.selectedFrequencyID = id;
    this.selectedOption = id;
    this.clickFrequency = true;
    this.target.selectedOption = id;
    this.formGroup.get('startTime').setValue(null);
    this.formGroup.get('endTime').setValue(null);
    this.budgetForm.get('startTime').setValue(null);
    this.budgetForm.get('endTime').setValue(null);
    this.budgetForm.patchValue({
      resolution: '',
      sensorType: '',
      updateFrequency: '',
      taskingTier: '',
      cloudCover: '',
      holdBack: '',
    });
    this.range.value.start = null;
    this.range.value.end = null;
    if (id === 1) {
      this.target.freqOption = 'Daily';
    }
    if (id === 1 || id === 2) {
      this.range.value.start = this.date.value;
      const day = this.todayDate.getDate();
      const month = this.todayDate.getMonth() + 1;
      const year = this.todayDate.getFullYear();
      this.range.value.end = new Date(
        year,
        month - 1,
        day + this.defaultWindow
      );
    } else {
      this.range.value.start = this.date.value;
      this.range.value.end = this.date.value;
    }
  }

  handleDateChange(event: any, datePicker: any) {
    this.formGroup.get('startTime').setValue(null);
    this.formGroup.get('endTime').setValue(null);
    this.budgetForm.get('startTime').setValue(null);
    this.budgetForm.get('endTime').setValue(null);
    this.resetControlsBelow('date');
    if (datePicker === 1) {
      this.range.value.start = event.value;
      const day = event.value.getDate();
      const month = event.value.getMonth() + 1;
      const year = event.value.getFullYear();
      this.range.value.end = event.value;
    } else if (datePicker === 2) {
      if (this.taskStrategy === 'TLE Based Tasking') {
        this.clearTLEOnly();
        this.showtleDisabled = false;
        this.showtleClick = false;
      }
      this.range.value.start = event.value;
    } else if (datePicker === 3) {
      if (this.taskStrategy === 'TLE Based Tasking') {
        this.showtleDisabled = false;
        this.showtleClick = false;
        this.clearTLEOnly();
      }
      this.range.value.end = event.value;
    }
    this.showtleClick = false;

    if (this.range.value.start !== null && this.range.value.end !== null) {
      const condition =
        this.taskStrategy === 'TLE Based Tasking'
          ? this.range.value.start <= this.range.value.end
          : this.range.value.start < this.range.value.end;
      if (condition) {
        this.dateFlag = false;
      } else {
        this.dateFlag = true;
      }
      if (this.taskStrategy === 'TLE Based Tasking') {
        const startDate = new Date(this.range.value.start);
        const endDate = new Date(this.range.value.end);
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);
        const now = new Date();
        const maxAllowedStart = new Date();
        maxAllowedStart.setHours(now.getHours() + 72);

        if (startDate.getTime() > maxAllowedStart.getTime()) {
          this.tleStartRangeError = true;
        } else {
          this.tleStartRangeError = false;
        }

        const timeDifferenceMs = endDate.getTime() - startDate.getTime();
        const timeDifferenceDays = timeDifferenceMs / (1000 * 60 * 60 * 24);

        if (timeDifferenceDays > 3) {
          this.tleRangeError = true;
        } else {
          this.tleRangeError = false;
        }
      }
      if (this.selectedOption === 1 && this.subDaily) {
        this.dateFlag = false;
      }
    } else {
      this.dateFlag = false;
    }
    this.target['openWindow'] = this.range.value.start;
    this.target['closeWindow'] = this.range.value.end;
    this.updateTarget(this.target, '0');
  }

  freqChange(chosenOption: any) {
    this.subDaily = false;
    this.target.subDailyCount = '';
    this.target.freqOption = chosenOption.name;
    this.target.repeatOption = chosenOption.value;
    if (this.target.repeatOption === 4) {
      this.subDaily = true;
      this.target.subDailyCount = 1;
    }
    this.updateTarget(this.target, '0');
  }

  recurrentCountChange(chosenOption: any) {
    this.target.subDailyCount = chosenOption.label;
    this.updateTarget(this.target, '0');
  }

  onPurposeChange(option: any) {
    this.useCaseOption = null;
    this.target.useCase = null;
    if (option.purpose === 'Others') {
      this.others = true;
    } else {
      this.others = false;
      this.target.purposeOption = option;
    }
    if (this.taskStrategy === 'Help Select Sensor(s)') {
      this.userService.getUseCases(option._id).subscribe((res: any) => {
        this.useCaseOption = res.data.sort((a, b) => {
          return a.useCase.toLowerCase().localeCompare(b.useCase.toLowerCase());
        });
      });
    } else this.updateTarget(this.target, '0');
  }

  intentChange(option: any) {
    this.target.intent = option;
    this.showtleClick = false;
    if (this.taskStrategy === 'TLE Based Tasking') {
      this.tleSensorForm.reset();
      this.tleSensor = {
        resolution: [],
        sensor: [],
      };
      this.tleSensorTypes(this.userid, option._id);
      this.clearTLEOnly();
    }
    this.updateTarget(this.target, '0');
    if (this.budget) {
      this.budgetForm.patchValue({
        resolution: '',
        cloudCover: '',
        taskingTier: '',
        holdBack: '',
        sensorType: '',
      });
      this.budgetInputs.resolutionArr = [];
      this.budgetInputs.tierArr = [];
      this.budgetInputs.cloudCoverKeys = [];
      this.budgetInputs.holdbackArr = [];
      this.budgetSensorType = [];
      let data = {
        intent: option,
        selectedCategory: this.selectedCategory,
        multiPoi : this.target.multiTarget && this.target.multiTarget.length > 0 ? true : false
      };
      of(data)
        .pipe(
          switchMap((payload) => this.apiService.getBudgetSensorType(payload)),
          takeUntil(this.destroy$)
        )
        .subscribe((res: any) => {
          if (res?.msg == 'Success') {
            this.budgetSensorType = res.response;
          } else {
            const message = WARNING_MESSAGES.NO_SENSORS_FOR_INTENT;
            const dialogRef = this.popupService.openPopup(
              WarningPopup,
              message,
              '',
              '50%'
            );
            dialogRef.afterClosed().subscribe((result) => {
              this.budgetForm.patchValue({ intent: '' });
            });
          }
        });
    }
  }

  outcomeIntentChange(option: any) {
    this.target.intent = option;
  }

  useCaseChange(option: any) {
    this.target.useCase = option;
    this.updateTarget(this.target, '0');
  }

  nameChng(e: any, i: number) {
    if (i === 1) {
      this.target.projectId = null;
      if (e.target.value.length > 3) {
        this.projName = e.target.value;
      } else {
        this.projName = undefined;
      }
    } else {
      if (e.target.value.length > 4) {
        this.taskName = e.target.value;
      } else {
        this.taskName = undefined;
      }
    }
    this.updateTarget(this.target, '0');
  }

  inValid() {
    if (!this.taskTarget) return true;
    if (
      this.taskName &&
      this.projName &&
      this.taskTarget.includes('P') &&
      this.selectedSensorTypes.length > 2
    ) {
      this.showSensors = true;
      return false;
    } else {
      this.showSensors = false;
      return true;
    }
  }

  isAreaOk(area) {
    this.target.area = area;
    if (this.target)
      if (
        (this.target.area > 2000 || this.target.area < 10) &&
        this.target.geoJSON?.includes('POLY')
      ) {        
        const dialogRef = this.dialog.open(OpenconfirmwarningComponent, {
          width: '60%',
          backdropClass: 'blurr',
          data: this.target
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.proceed = true;
            this.buttonDisable = true;
            this.target.buttonDisable = true;
          } else {
            this.proceed = false;
            this.resetMap();
            this.disableEnableDrawControls(true, '');
          }
        });
        return this.proceed;
      }
    return;
  }

  getFileData() {
    this.drawingMode = 'fileUpload';
    const entities = this.viewer.entities.values;
    for (const entity of entities) {
      if (
        (entity.id == undefined || entity.id == null) &&
        entity?.name !== 'allowedArea'
      ) {
        this.viewer.entities.remove(entity);
      }
    }

    const doc = document.getElementById('filedatas');
    if (doc) {
      doc.click();
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(CollectionPopupComponent, {
      width: '50%',
      backdropClass: 'blurred',
      disableClose: true,
      data: {
        message:
          'Multi-polygon AOI is not supported at this time. Please submit a single contiguous polygon with any internal boundaries dissolved.',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.resetMap();
    });
  }

  resetMe(parentVal: any) {
    if (parentVal === 'Reset') {
      this.formGroup.controls['taskname'].setValue('');
      this.target['taskname'] = '';
      this.target.polygon = false;
      this.apiService.updateTaskParams(this.target);
      this.formGroup = new FormGroup({
        project: new FormControl(),
        taskname: new FormControl(),
        target: new FormControl(),
      });
    }
  }
  resetMap(task?: string) {
    if (this.drawnItems) {
      this.drawnItems.clearLayers();
    }
    this.markersAndDivs.forEach((customDivs) => {
      customDivs.div.remove();
    });
    if (this.eventLayers.length > 0) {
      this.eventLayers.pop();
    }
    if (this.numberBadgeMarkers && this.numberBadgeMarkers.length > 0) {
      this.numberBadgeMarkers.forEach((badge) => {
        if (this.map && badge) {
          this.map.removeLayer(badge);
        }
      });
      this.numberBadgeMarkers = [];
    }
    if (this.marker) {
      this.map.removeLayer(this.marker);
      this.marker = null;
    }

    this.position = null;
    this.layerData = null;
    this.clearSatllite();
    this.eventLayers = [];
    this.pointArray = [];
    this.pointEntities = [];
    this.target.multiTarget = [];
    this.buttonDisable = false;
    this.target.buttonDisable = false;
    this.target.area = null;
    this.target.geoJSON = null;
    this.target.geotargets = null;
    this.callCounter = 0;
    this.shapeSelected = false;
    this.markersAndDivs = [];
    if (this.geoJsonLayer) {
      this.map.removeLayer(this.geoJsonLayer);
      this.geoJsonLayer = null;
    }
    this.clearSearchResults();

    if (task === 'tle') {
      this.clearTLEOnly();
    }

    this.updateTarget(this.target, '0');
    if (this.selectedCategory === this.nonImagingSensor){
    this.range?.reset({
    start: null,
    end: null
  });
  }
  }

  polylines: any[] = [];

  receivedMessageHandler(result: any) {
    this.clearSatllite();
    let isUnchecked = false;
    let removeIndex = -1;
    this.satellites = result;
    for (let i = 0; i < this.satellites.length; i++) {
      let satelliteData = this.satellites[i];
      let modifiedArray = satelliteData.position.map((sub) => {
        return [sub[1], sub[0]];
      });
      modifiedArray = modifiedArray.slice(-70);
      const satelliteIcon = L.icon({
        iconUrl: 'assets/images/satellite.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32],
      });
      let image = L.marker(modifiedArray[0], { icon: satelliteIcon }).addTo(
        this.map
      );
      let segments = this.splitPolylineAtMeridian(modifiedArray);
      let lineColor = this.getRandomHexColor();
      const textIcon = L.divIcon({
        className: 'text-marker',
        html: `<div style="color: ${lineColor}; font-weight: bold;">${satelliteData.name}</div>
         <div style="color: ${lineColor}; font-weight: bold;">${satelliteData.time}</div>
          `,
        iconSize: [130, 40],
        iconAnchor: [50, 20],
      });
      const textmarker = L.marker(modifiedArray[0], { icon: textIcon }).addTo(
        this.map
      );
      segments.forEach((segment) => {
        let polyline = L.polyline(segment, { color: lineColor }).addTo(
          this.map
        );
        polyline.arrowheads({
          size: '15px',
          frequency: 'endonly',
          yawn: 60,
        });
        this.polylines.push({
          image: image,
          polyline: polyline,
          text: textmarker,
        });
      });
    }
    this.mapLoading = false;
  }
  handleClearSensorCost(event: boolean) {
    this.sensorPanel.close();
    this.panelOpenState = false;
  }

  receiveHandler(data: any) {
    if (data?.length > 0) {
      const operatorExists = data.some((item) => item.key === OPERATORS.LBAND);
      if (operatorExists) {
        this.displayRFCircle();
      }
    }
  }

  displayRFCircle() {
    if (this.rfCircleLayer.length == 0) {
      let cordinates: any[] = [];
      if (this.pointArray.length <= 3) {
        if (this.pointArray.length == 1) {
          this.target.targetPoints = this.pointArray;
          const coords = this.utilsService.extractCoordinates(
            this.pointArray[0]
          );
          this.drawRFCircle(coords, RF_RADIUS * 1000);
          this.dataService.setOverlapValue(0, 0);
        } else {
          this.target.targetPoints = null;
          this.pointArray.forEach((item, i) => {
            const coords = this.utilsService.extractCoordinates(item);
            cordinates.push(coords);
            this.drawRFCircle(coords, RF_RADIUS * 1000);
          });
          let overlapPercentage = this.findRFCircleOverlap(cordinates);
          let overlapCount = this.findOverlapCircleCount(cordinates);

          this.dataService.setOverlapValue(
            overlapPercentage.toFixed(2),
            overlapCount
          );
        }
        this.dataService.updateTarget(this.target);
      }
    }
  }

  findRFCircleOverlap(coords: any[]) {
    const circleTurf1 = turf.circle([coords[0].lng, coords[0].lat], RF_RADIUS, {
      steps: 64,
      units: 'kilometers',
    });
    const circleTurf2 = turf.circle([coords[1].lng, coords[1].lat], RF_RADIUS, {
      steps: 64,
      units: 'kilometers',
    });
    const intersection = turf.intersect(circleTurf1, circleTurf2);
    if (intersection) {
      const overlapArea = turf.area(intersection);
      const area1 = turf.area(circleTurf1);
      const overlapPercentage1 = (overlapArea / area1) * 100;
      return overlapPercentage1;
    } else {
      return 0;
    }
  }

  findOverlapCircleCount(coords: any[]) {
    const turfCircleA = turf.circle([coords[0].lng, coords[0].lat], RF_RADIUS, {
      steps: 64,
      units: 'kilometers',
    });
    const turfCircleB = turf.circle([coords[1].lng, coords[1].lat], RF_RADIUS, {
      steps: 64,
      units: 'kilometers',
    });
    let overlapCount = 0;
    if (turf.intersect(turfCircleA, turfCircleB)) {
      overlapCount++;
    }
    if (coords.length == 3) {
      const turfCircleC = turf.circle(
        [coords[2].lng, coords[2].lat],
        RF_RADIUS,
        { steps: 64, units: 'kilometers' }
      );
      if (turf.intersect(turfCircleA, turfCircleC)) {
        overlapCount++;
      }
      if (turf.intersect(turfCircleB, turfCircleC)) {
        overlapCount++;
      }
      overlapCount = overlapCount >= 3 ? 2 : overlapCount;
    }
    return overlapCount;
  }

  drawRFCircle(coords, radius) {
    const circle = L.circle(coords, {
      color: 'blue',
      fillColor: '#add8e6',
      fillOpacity: 0.5,
      radius: radius,
    }).addTo(this.map);
    this.map.fitBounds(circle.getBounds());
    if (this.pointArray.length == 1) {
      let aoiWkt: any = 'POLYGON ((';
      const accuracy = 15;
      let polyPts: any = [],
        aoi: any,
        lng0 = 0,
        lat0 = 0;
      const circleTurf = turf.circle([coords.lng, coords.lat], RF_RADIUS, {
        steps: 64,
      });
      for (let i = 0; i < circleTurf.geometry.coordinates[0]?.length - 1; i++) {
        let lng = circleTurf.geometry.coordinates[0][i][0];
        let lat = circleTurf.geometry.coordinates[0][i][1];
        if (i === 0) {
          lng0 = lng;
          lat0 = lat;
        }
        polyPts.push([lng, lat]);
        aoiWkt = aoiWkt + `${lng.toFixed(accuracy)} ${lat.toFixed(accuracy)}, `;
      }
      polyPts.push([lng0, lat0]);
      aoi = turf.polygon([polyPts]);
      aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}`;
      aoiWkt = aoiWkt + `))`;
      this.target.geoJSON = aoiWkt;
      this.target.area = (Math.PI * Math.pow(RF_RADIUS, 2)).toFixed(2);
      this.formGroup.get('target').setValue(aoiWkt);
    }
    this.rfCircleLayer.push(circle);
  }

  removeCircles() {}

  splitPolylineAtMeridian(coords) {
    const segments: any[] = [];
    let currentSegment: any[] = [];
    for (let i = 0; i < coords.length - 1; i++) {
      const [lat1, lng1] = coords[i];
      const [lat2, lng2] = coords[i + 1];
      currentSegment.push([lat1, lng1]);
      if (Math.abs(lng1 - lng2) > 180) {
        const lngMeridian = lng1 > 0 ? 180 : -180;
        const latMeridian =
          lat1 + ((lat2 - lat1) * (lngMeridian - lng1)) / (lng2 - lng1);
        currentSegment.push([latMeridian, lngMeridian]);
        segments.push(currentSegment);
        currentSegment = [[latMeridian, lngMeridian > 0 ? -180 : 180]];
      }
    }
    currentSegment.push(coords[coords.length - 1]);
    segments.push(currentSegment);
    return segments;
  }

  getRandomHexColor() {
    const randomColor = Math.floor(Math.random() * 16777215).toString(16);
    return `#${randomColor.padStart(6, '0')}`;
  }

  clearSatllite() {
    this.polylines.map((polyline) => {
      if (polyline?.image) {
        this.map.removeLayer(polyline?.image);
      }
      if (polyline?.polyline) {
        this.map.removeLayer(polyline?.polyline);
      }
      if (polyline?.text) {
        this.map.removeLayer(polyline?.text);
      }
    });
    this.polylines = [];
  }

  clearRFCircleLayers() {
    this.rfCircleLayer.forEach((circleLayer) => {
      this.map.removeLayer(circleLayer);
    });
    this.rfCircleLayer = [];
  }

  categoryChange(event) {
    this.selectedCategory = event.value;
    this.updateFrequencyOption = false;
    this.budgetSensorType = [];
    const sensorCategoryControl = this.budgetForm.get('sensorCategory');
    this.budgetForm.patchValue({
      resolution: '',
      cloudCover: '',
      taskingTier: '',
      holdBack: '',
      updateFrequency: '',
    });
    this.resetForm();
    this.disableEnableDrawControls(true, 'reset');
    sensorCategoryControl?.setValue(this.selectedCategory);
    this.showResolution =
      this.selectedCategory !== STRINGCONSTANTS.NON_IMAGING_SENSOR;
  }

  getCountryAndPlace(
    latitudes: number,
    longitudes: number,
    target: any,
    status: any = false
  ) {
    let longitude: any, latitude: any;
    if (target?.type === 'Point') {
      longitude = target?.coordinates[0];
      latitude = target?.coordinates[1];
    } else if (target === 'search') {
      longitude = longitudes;
      latitude = latitudes;
    } else {
      let totalLat = 0;
      let totalLng = 0;
      for (let i = 0; i < target?.coordinates[0].length; i++) {
        totalLat += target?.coordinates[0][i][1];
        totalLng += target?.coordinates[0][i][0];
      }
      const centroidLat = totalLat / target?.coordinates[0].length;
      const centroidLng = totalLng / target?.coordinates[0].length;
      longitude = centroidLng;
      latitude = centroidLat;
    }
     if (this.budget && this.target.intent) {
      this.budgetForm.patchValue({
        resolution: '',
        cloudCover: '',
        taskingTier:'',
        holdBack: '',
        sensorType: ''
      });

      this.budgetInputs.resolutionArr = [];
      this.budgetInputs.tierArr = [];
      this.budgetInputs.cloudCoverKeys = [];
      this.budgetInputs.holdbackArr = [];
      this.budgetSensorType = [];

      let data = {
        intent : this.target.intent,
        selectedCategory :  this.selectedCategory,
        multiPoi : this.target.multiTarget && this.target.multiTarget.length > 0 ? true : false
      }
      this.apiService.getBudgetSensorType(data).subscribe((res: any) => {
        if(res?.msg == 'Success') {
          this.budgetSensorType=res.response
        }
         else {
          const message = `There are no sensors for the selected intent. Please change to continue for budget generation.`;
          const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');
          dialogRef.afterClosed().subscribe(result => {
            this.budgetForm.patchValue({intent: ''});
          });
        }
        });
    }

    const apiKey = environment.openCageApiKey;
    const url = `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${apiKey}`;
    let place: any, country: any, countryCode: any;
    let location = {
      longitude: longitude,
      latitude: latitude,
    };

    this.apiService.checkIsWater(location).subscribe((res: any) => {
      if (status) {
        this.target.openWaterCue = res?.water;
      } else {
        this.target.openWater = res?.water;
        if (
          this.taskStrategy == 'Tip-and-Cue' &&
          this.subStrategy == 'Tip-and-Cue'
        )
          this.getObservationList(this.target.openWater);
      }
      this.http.get(url).subscribe((response: any) => {
        if (response.results.length > 0) {
          const firstResult = response.results[0];

          if (firstResult.components?.body_of_water) {
            country = firstResult.components.body_of_water;
            place = firstResult.components.body_of_water;
            countryCode = firstResult.components.body_of_water;
            if (status) this.target.overOpenWaterCue = true;
            else this.target.overOpenWater = true;
          } else {
            country = firstResult.components.country;
            place =
              firstResult.components.city ||
              firstResult.components.state ||
              firstResult.components.county;
            countryCode = firstResult.components['ISO_3166-1_alpha-3'];
            if (status) this.target.overOpenWaterCue = true;
            else this.target.overOpenWater = true;
          }
          if (status) {
            this.target.placeCue = place;
            this.target.countryCue = country;
            this.target.countryCodeCue = countryCode;
          } else {
            this.target.place = place;
            this.target.country = country;
            this.target.countryCode = countryCode;
          }
          this.updateTarget(this.target, '0');
        }
      });
    });
  }

  isLatitudeInRange(geoJSON: any, minValue: number, maxValue: number): boolean {
    if (this.target?.multiTarget?.length > 0) {
      for (const targets of this.target.multiTarget) {
        const geoJson = geoParse(targets);
        const latitude = geoJson.coordinates[1];
        if (latitude >= minValue && latitude <= maxValue) {
          return true; // If any latitude is within the range, return true
        }
      }
    } else if (geoJSON.type === 'Point') {
      const latitude = geoJSON.coordinates[1];
      return latitude >= minValue && latitude <= maxValue;
    } else if (geoJSON.type === 'Polygon') {
      const coordinates = geoJSON.coordinates[0];
      for (const coordinate of coordinates) {
        const latitude = coordinate[1];
        if (latitude >= minValue && latitude <= maxValue) {
          return true; // If any latitude is within the range, return true
        }
      }
    }
    return false;
  }

  strategyChange(data: any) {
    if (this.satLayer) {
      this.satLayer.clearLayers();
      this.map.removeLayer(this.satLayer);
      this.satLayer = null;
    }
    if(this.taskStrategy != null){
      this.mapLoading = false;
    }
    this.satTrackingClicked = false;
    this.useCaseOption = null;
    this.formGroup.reset();
    this.eventLayers = [];
    this.drawnItems.clearLayers();
    this.resetMap();
    this.disableEnableDrawControls(true, 'reset');
    this.onOptionChange('');
    this.formGroup.get('strategyRadio').setValue(data.value);
    this.formGroup.get('tipAndCueBasedOn').setValue('Rules');
    this.subStrategy = null;
    this.taskStrategy = data.value;
    this.position = null;
    this.selectedSensorTypes = '';
    if (this.taskStrategy != 'Tip-and-Cue') {
      this.rule = null;
      this.target.rule = null;
      this.observation = null;
      this.target.observation = null;
      this.feeds = null;
      this.target.feeds = null;
    }
    if (this.taskStrategy === 'Outcome By Platform') {
      this.outcomeSensorTypes(this.userid);
    }
    if (this.taskStrategy === 'TLE Based Tasking') {
      const today = new Date();
      const day = today.getDate();
      const month = today.getMonth() + 1;
      const year = today.getFullYear();
      this.minDate = new Date(year, month - 1, day);
      this.maxDate = new Date(year, month - 1, day + 3);
      this.date = new FormControl(new Date(year, month - 1, day + 1));
      this.range = new FormGroup({
        start: new FormControl(new Date(year, month - 1, day)),
        end: new FormControl(new Date(year, month - 1, day + 3)),
      });
      this.disableEnableDrawControls(false, '', 'TLE');
    } else {
      this.minDate = null;
      this.maxDate = null;
    }
    this.tipAndCueBasedOn = 'Rules';
    this.target.tipAndCueBasedOn = 'Rules';
    this.target.taskStrategy = data.value;
    this.updateTarget(this.target, '0');
  }

  tipAndCueTypeChange(data: MatRadioChange) {
    this.tipAndCueBasedOn = data.value;
    this.target.tipAndCueBasedOn = data.value;
    this.observation = null;
    this.target.observation = null;
    this.rule = null;
    this.target.rule = null;
    this.feeds = null;
    this.target.feeds = null;
    this.updateTarget(this.target, '0');
  }

  onFeedsChange(option: any) {
    this.feeds = option;
    this.target.feeds = option;
    this.rule = null;
    this.target.rule = null;
    this.observation = null;
    this.target.observation = null;
    this.updateTarget(this.target, '0');
  }

  onObservationChange(option: any) {
    let previousvalue: any;
    let previousoperator: any;
    if (this.target.observation?.name === option.name) {
      previousvalue = this.target.observationData.value;
      previousoperator = this.target.observationData.action;
    }
    this.observation = option;
    this.target.observation = option;
    this.rule = null;
    this.target.rule = null;
    this.feeds = null;
    this.target.feeds = null;
    this.updateTarget(this.target, '0');
    const dialogRef = this.dialog.open(FilterPopupComponent, {
      width: '35%',
      backdropClass: 'blurr',
      data: {
        type: 'observation',
        name: this.target.observation.name,
        dataType: this.target.observation.data_type,
        value: previousvalue,
        operator: previousoperator,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.target.observationData = result;
        this.formGroup.get('observationData').setValue(result);
        if (result.value.split(',').map((s) => s.trim()).length > 1) {
          if (this.calculateObservation(result.value)) {
            this.getCountryAndPlace(
              0,
              0,
              geoParse(this.target?.geoJSONCue),
              'cueing'
            );
          } else {
            const msg = ' The observation coordinates are outside the AOI.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              msg,
              '',
              '30%'
            );
            this.formGroup.get('observationData').setValue(null);
            this.formGroup.get('observation').setValue(null);
            this.observation = null;
            this.target.observation = null;
            return;
          }
        }
      } else {
        this.formGroup.get('observationData').setValue(null);
        this.formGroup.get('observation').setValue(null);
        this.observation = null;
        this.target.observation = null;
      }
    });
  }

  onRulesChange(option: any) {
    let previousvalue: any;
    if (this.target.rule === option && this.target.rule === 'rule-3') {
      previousvalue = this.target.cloudCover;
    }
    if (option === 'rule-3') {
      const dialogRef = this.dialog.open(OpenconfirmwarningComponent, {
        width: '60%',
        backdropClass: 'blurr',
        data: 'rule',
      });
      if (this.target.rule === option && this.target.rule === 'rule-3') {
        dialogRef.componentInstance.previousValue = this.target.cloudCover;
      }
      dialogRef.afterClosed().subscribe((result) => {
        if (result && !isNaN(result) && Number(result) >= 0) {
          this.formGroup.get('rule').setValue(option);
          this.rule = option;
          this.target.rule = option;
          this.observation = null;
          this.target.observation = null;
          this.feeds = null;
          this.target.feeds = null;
          this.target.cloudCover = result;
          this.updateTarget(this.target, '0');
        } else {
          this.formGroup.get('rule').setValue(null);
          this.target.cloudCover = '';
        }
      });
    } else {
      this.formGroup.get('rule').setValue(option);
      this.rule = option;
      this.target.rule = option;
      this.observation = null;
      this.target.observation = null;
      this.feeds = null;
      this.target.feeds = null;
      this.updateTarget(this.target, '0');
    }
  }

  drawPinOnMap() {}

  geoParsePoint(wkt: string) {
    const regex = /POINT \(([^)]+)\)/g;
    const points: { type: string; coordinates: [number, number] }[] = [];
    let match;

    while ((match = regex.exec(wkt)) !== null) {
      const coordinates = match[1].split(' ').map(parseFloat);
      points.push({
        type: 'Point',
        coordinates: [coordinates[0], coordinates[1]],
      });
    }

    return points;
  }

  sensorChange(event: any) {
    let target: any;
    this.outComeForm.patchValue({
      resolution: '',
      cloudCover: '',
      updateFrequency: '',
      latency: '',
      budget: '',
      intent: '',
    });

    if (this.target.area > 0) {
      target = 'AOI';
    } else target = 'POI';
    let sensorObj = {
      sensorType: event.value,
      target: target,
    };

    let intent = this.target?.intent?.key
      ? this.target?.intent.key
      : this.target?.intent;

    if (event.value !== 'AIS') {
      this.apiService.getSensorDetails(sensorObj).subscribe((res: any) => {
        this.outComesensor = res;
        const cloudC: any = [];
        if (res.cloudCover) {
          for (var key in res.cloudCover) {
            cloudC.push({ key, value: res.cloudCover[key] });
          }
          this.outComesensor.cloudCover = cloudC;

          if (this.outComesensor?.cloudCover?.length === 0) {
            this.outComeForm.get('cloudCover').disable();
          } else {
            this.outComeForm.get('cloudCover').enable();
          }
        }
      });
    }
  }
  sensorTypeChangeTle(event: any) {
    this.tleSensorForm.patchValue({
      sensorType: event,
      resolution: '',
      sensor: '',
    });
    this.showtleClick = false;
    this.showtleDisabled = false;
    this.apiService
      .getBudgetResolutionDetails(
        event,
        this.target.intent,
        this.currentUser.id,
        'TLE Based Tasking',
        this.target.area
      )
      .subscribe((res: any) => {
        if (res?.msg === 'Success') {
          let resolutions = res.response;
          this.tleSensor.resolution = resolutions;
        }
      });
    this.clearTLEOnly();
  }
  resolutionChangeTle(event: any) {
    this.tleSensorForm.patchValue({
      resolution: event,
      sensor: '',
    });
    this.showtleClick = false;
    this.showtleDisabled = false;
    const sensorObj = {
      intent: this.target?.intent?._id,
      userid: this.userid,
      sensorType: this.tleSensorForm.value?.sensorType,
      resolution: event,
    };
    this.apiService.getSensorDetailsTle(sensorObj).subscribe((res: any) => {
      let sensors = res?.filteredSensors;
      if (sensors?.length > 0) {
        this.tleSensor.sensor = sensors;
      } else {
        const message =
          'No sensors are meeting the selected resolution. Please change the resolution and try again.';
        const dialogRef = this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        dialogRef.afterClosed().subscribe((result) => {
          this.tleSensorForm.get('resolution')?.setValue('');
          this.tleSensorForm.get('resolution')?.markAsPristine();
          this.tleSensorForm.get('resolution')?.markAsUntouched();
          this.tleSensor.sensor = [];
        });
      }
    });
    this.clearTLEOnly();
  }

  sensorWarning(event) {
    if (this.budgetForm?.value?.sensorType.sensor === 'HSI'){
      if (event.value.key === '5.3m') {
        const message =`
        <ol>
          <li>Each line in the area of interest (AOI) must be at least 5km and no more than 25km long.</li>
          <li>The total area of the polygon cannot exceed 400 sqkm. You can find the size of your area at the top of the map after you draw or upload the polygon.</li>
          <li>The start of the time of interest (TOI) must be at least three days after the submission date, and the end date must be at least 30 days after the start date of the TOI. Please change your TOI or choose an alternative provider.</li>
          <li>The area of interest (AOI) requested should at least be 100 sqkm for the standard tasking and 50 sqkm for the priority tasking.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      } else if (event.value.key === '10m'){
        const message = `
        <ol>
          <li> The sensor does not have cloud cover and holdback selection options.</li>
          <li> The end date must be within 14 days from the submission date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'GHG') {
      const message =`
      <ol>
        <li>Recurrence selection is limited to monthly at this time.</li>
        <li>The Time of Interest (TOI) must be at least 30 days.</li>
        <li>Specific date tasking is not supported at this time.</li>
      </ol>`;
      this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
      return;
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'SAR') {
      if (event.value.key === '0.25m' || event.value.key === '0.5m' || event.value.key === '1.2m') {
        const message =`
        <ol>
          <li>Standard tasking requires a minimum seven day Time of Interest (TOI).</li>
          <li>Priority tasking requires a minimum three day TOI.</li>
          <li>Rush tasking requires a minimum one day TOI.</li>
          <li>The start date must be within 90 days from today.</li>
          <li>The Time of Interest (TOI) cannot exceed 30 days.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key === '0.35m') {
        const message =`
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      let resolutionArr = ['3m', '12m', '20m', '6m', '20m - 30m', '30m'];
      if (resolutionArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      let KomsatArr = ['0.85m', '2.5m', '20m/4 look', 'Pan-sharpened:0.8m', 'Bundle:0.8m PAN/3.2m MSI', 'Pan-sharpened:1m', 'Bundle:1m PAN/4m MSI'];
      if (KomsatArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Tasking of certain government operators is not permitted over their respective countries. You may not see them included in the budgeting response.</li>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'MSI') {
      if (event.value.key === '0.5-0.7m') {
        const message =`
        <ol>
          <li>Only 2 sub-daily collections are allowed at this time.</li>
          <li>Only POI (Point of Interest) tasks over open waters are supported. AOI (Area of Interest) tasks are not allowed.</li>
          <li>For areas smaller than 50 sqkm, please task with a single POI.</li>
          <li>Rush tasking tier is not supported for AOI tasks.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key === 'Super Resolution (SR):0.5m' || event.value.key === 'Ground Sample Distance (GSD):0.7m') {
        const message =`
        <ol>
          <li>Tasking over open waters is not supported.</li>
          <li>Only 2 sub-daily collections are allowed at this time.</li>
          <li>For areas smaller than 50 sqkm, please task with a single POI.</li>
          <li>Rush tasking tier is not supported for AOI tasks.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key === '2.5m TCI' || event.value.key === '5m MS') {
        const message =`
        <ol>
          <li>Specific date and recurrent frequency are not supported at this time.</li>
          <li>Only AOI (Area of Interest) orders are supported.</li>
          <li>The start date must be at least one day from the current date, and the Time of Interest (TOI) must be 14 days or less from the current date.</li>
          <li>The minimum task area is 100 sqkm.</li>
          <li>If the AOI is greater than 900 sqkm, each AOI must be within 30 km in both length and width.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key === '0.5m TCI') {
        const message =`
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key === 'Pan-sharpened:0.52m' || event.value.key === 'Bundle:0.52m PAN+2.08m MS') {
        const message =`
        <ol>
          <li>Recurrency is not supported at this time.</li>
          <li>Only POI (Point of Interest) orders are supported.</li>
          <li>The start date must be at least 24 hours or 48 hours from the current date.</li>
          <li>Up to 2 sub-daily collections are allowed.</li>
          <li>Tasking is limited to the latitude range of -13 to 13.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key === '2.5m' || event.value.key === '0.4m' || event.value.key === '0.92m') {
        const message =`
        <ol>
          <li>Recurrency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      let komsatArr = ['0.85m', '1m', '20m/4 look', 'Pan-sharpened:0.8m', 'Bundle:0.8m PAN/3.2m MSI', 'Pan-sharpened:1m', 'Bundle:1m PAN/4m MSI'];
       if (komsatArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Tasking of certain government operators is not permitted over their respective countries. You may not see them included in the budgeting response.</li>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'MSI' || this.budgetForm?.value?.sensorType.sensor === 'Stereo') {
      if (event.value.key === '0.83-0.94m') {
        const message =`
        <ol>
          <li>Only POI (Point of Interest) orders are supported.</li>
          <li>Up to 4 sub-daily collections are allowed, and sub-daily tasking is only available for a minimum of seven days.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key === 'Pan-sharpened:0.5m' || event.value.key === "Bundle:0.5m PAN/2m MS") {
        const message =`
        <ol>
          <li>Tasking of certain government operators is not permitted over their respective countries. You may not see them included in the budgeting response.</li>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>Each line in the Area of Interest (AOI) must be at least 5 km long.</li>
        <ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      let resolutionArr = ['Pan-sharpened:0.59m', 'Bundle:0.59m PAN/2.36m MS', '0.25m', 'Pan-sharpened:0.3m', 'Bundle:0.3m PAN/1.2m MS','0.15m',
         'High Definition (HD):0.15m', 'High Definition (HD):0.25m', ];
      if (resolutionArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Only period-based collection orders are supported at this time. Recurrent and specific date orders are not available.</li>
          <li>Each side of the Area of Interest (AOI) must be at least 5 km.</li>
        <ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      let msiArr = ['Pan-sharpened:0.4m', 'Bundle:0.4m PAN/1.6m MSI'];
      if (msiArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
          <li>Tasking is only allowed within the latitude range of -42 to 42.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'PAN') {
      if (event.value.key === '4.6m') {
        const message =`
        <ol>
          <li>Only open water tasking is supported, and it must be limited to a single Point of Interest (POI).</li>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The sensor can only be tasked within the next ten days.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'InSAR' || this.budgetForm?.value?.sensorType.sensor === 'Stereo') {
      let komsatArr = ['0.85m', '1m', '2.5m', '20m/4 look', 'Pan-sharpened:0.8m', 'Bundle:0.8m PAN/3.2m MSI', 'Pan-sharpened:1m', 'Bundle:1m PAN/4m MSI'];
      if (komsatArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Tasking of certain government operators is not permitted over their respective countries. You may not see them included in the budgeting response.</li>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'TIR') {
      let resolutionArr = ['30m', '69m'];
      if (resolutionArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Recurrence selection is limited to weekly and monthly at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key=== "3.5m") {
        const message =`
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'PAN' || this.budgetForm?.value?.sensorType.sensor === 'Stereo') {
      let resolutionArr = ['0.5m', '0.4m', 'Pan-sharpened:0.4m', 'Bundle:0.4m PAN/1.6m MSI','0.69m'];
      if (resolutionArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
          <li>Tasking is only allowed within the latitude range of -42 to 42.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'InSAR') {
      let resolutionArr = ['3m', '12m', '20m', '6m', '20m - 30m', '30m'];
      if (resolutionArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
  }

  sensorChangeTle(event: any) {
    const matchedSensor = this.tleSensor.sensor?.find((s) => {
      return this.currentUser?.obfuscated
        ? s.obfuscateName === event
        : s.sensorName === event;
    });
    if (matchedSensor) {
      this.selectedSensorObfuscatedName = matchedSensor;
    }
    this.clearTLEOnly();
    this.showtleClick = false;
    this.showtleDisabled = false;
  }
  OpenSatTracking() {
    this.satTrackingClicked = true
    this.mapLoading = true;
    this.showtleClick = true;
    this.showtleDisabled = true;
    this.spinnerService.show();
    this.getSatelliteData();
  }
  getSatelliteData() {
    let sensor = this.selectedSensorObfuscatedName;
    let sensorName, sensorInfo;

    sensorName = [sensor?.sensorName];
    sensorInfo = [
      { key: sensor?.sensorName, obfuscateName: sensor?.obfuscateName },
    ];

    let sensorData = {};
    sensorData['sensorName'] = sensorName;
    sensorData['sensors'] = sensorInfo;
    sensorData['action'] = 'projectedData';
    let target = this.target;

    sensorData['openWindow'] = moment(target.openWindow)
      .utcOffset(0, true)
      .format();
    sensorData['closeWindow'] = moment(target.closeWindow)
      .utcOffset(0, true)
      .format();
    sensorData['target'] = JSON.stringify(geoParse(target.geoJSON));

    const sensorObj = { sensorData: sensorData };
    if (this.satelliteDataSubscription) {
      this.satelliteDataSubscription.unsubscribe();
    }
    this.satelliteDataSubscription = this.apiService
      .getSatelliteData(sensorObj)
      .subscribe((res: any) => {
        if (res?.msg === 'Failed') {
          this.mapLoading = false;
          this.showtleClick = false;
          this.showtleDisabled = false;
          this.spinnerService.hide();
          const message =
            'There are no active satellites for the chosen provider at this time. Please select another.';
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
        } else if(this.taskStrategy === 'TLE Based Tasking' && res?.msg != 'Failed' && this.satTrackingClicked== true) {
          this.plotSatellitePath(res);
        }
      });
  }

  private ensureSatellitePane() {
    if (!this.map.getPane('satellitePane')) {
      const pane = this.map.createPane('satellitePane');
      pane.style.zIndex = '650';
    }
    if (!this.satRenderer) {
      this.satRenderer = L.svg({ pane: 'satellitePane' });
      this.satRenderer.addTo(this.map);
    }
  }

  plotSatellitePath(result: any) {
    if (!this.map) return;

    // clear previous layer
    if (this.satLayer) {
      this.satLayer.clearLayers();
      this.map.removeLayer(this.satLayer);
    }

    this.ensureSatellitePane();
    this.satLayer = L.layerGroup([]);

    const bounds = L.latLngBounds([]);

    if (Array.isArray(result) && result.length > 0) {
      for (let i = 0; i < result.length; i++) {
        const satellite = result[i];
        const posArr: number[][] = Array.isArray(satellite.position)
          ? satellite.position
          : [];
        const [endLon, endLat] =
          posArr.length > 0
            ? [posArr[posArr.length - 1][0], posArr[posArr.length - 1][1]]
            : [satellite.longitude, satellite.latitude];

        const icon = L.icon({
          iconUrl: 'assets/images/satellite.png',
          iconSize: [25, 20],
          iconAnchor: [12.5, 20],
        });
        const name =
          this.currentUser?.obfuscated && satellite.obfuscateName
            ? satellite.obfuscateName
            : satellite.name;
        const time = satellite.time ?? '';
        const labelText = `<div class="satellite-label-line">${name}</div>
                         <div class="satellite-label-line">${time}</div>`;

        const marker = L.marker([satellite.latitude, satellite.longitude], {
          icon,
          pane: 'satellitePane',
          interactive: false,
          zIndexOffset: 1000,
        })
          .bindTooltip(labelText, {
            permanent: true,
            direction: 'bottom',
            offset: L.point(0, -10),
            className: 'satellite-label',
          })
          .addTo(this.satLayer);

        bounds.extend(marker.getLatLng());

        const color = this.getOperatorColor(
          this.selectedSensorObfuscatedName?.sensorName
        );

        const line = L.polyline(
          [
            [satellite.latitude, satellite.longitude],
            [endLat, endLon],
          ],
          {
            color,
            weight: 2,
            pane: 'satellitePane',
            interactive: false,
            renderer: this.satRenderer,
          }
        ).addTo(this.satLayer);

        if ((L as any).polylineDecorator && (L as any).Symbol?.arrowHead) {
          const decorator = (L as any).polylineDecorator(line, {
            patterns: [
              {
                offset: '100%',
                repeat: 0,
                symbol: (L as any).Symbol.arrowHead({
                  pixelSize: 8,
                  polygon: true,
                  pathOptions: {
                    pane: 'satellitePane',
                    renderer: this.satRenderer,
                    color,
                    weight: 2,
                    fill: true,
                    fillOpacity: 1,
                    opacity: 1,
                  },
                }),
              },
            ],
          });
          decorator.addTo(this.satLayer);
        }

        bounds.extend([endLat, endLon]);
      }

      this.satLayer.addTo(this.map);

      if (bounds.isValid()) {
        this.map.fitBounds(bounds.pad(0.1));
        this.map.setZoom(2, { animate: false });
      }

      this.mapLoading = false;
      this.spinnerService?.hide?.();
    }
  }

  updateRfSignalsControl(event: any) {
    if (this.selectedCategory === this.nonImagingSensor && event?.value?.sensor === this.rfType) {
      if (!this.budgetForm.contains('rfSignals')) {
      this.budgetForm.addControl('rfSignals', new FormControl());
      }
    } else {
    if (this.budgetForm.contains('rfSignals')) {
      this.budgetForm.removeControl('rfSignals');
    }
   }
  }

  private getOperatorColor(key: string): string {
    switch (key) {
      case OPERATORS.CAPELLA:
        return 'yellow';
      case OPERATORS.SATELLOGIC:
        return 'yellowgreen';
      case OPERATORS.UMBRA:
        return 'blue';
      case OPERATORS.HEAD:
        return 'greenyellow';
      case OPERATORS.STE:
        return 'blueviolet';
      case OPERATORS.AT21:
        return 'green';
      case OPERATORS.KOMPSAT:
        return 'cyan';
      case OPERATORS.USL:
        return 'indigo';
      case OPERATORS.ISI:
        return 'turquoise';
      case OPERATORS.AXELSPACE:
        return 'gold';
      case OPERATORS.GHG:
        return '#25aae0';
      case OPERATORS.ORORATECH:
        return '#008B8B';
      case OPERATORS.WYVERN:
        return 'brown';
      case OPERATORS.SPIRE:
        return 'plum';
      case OPERATORS.CLYDE:
        return '#BC8F8F';
      case OPERATORS.SYNSPECTIVE:
        return 'green';
      case OPERATORS.GOKTURK:
        return '#9ce49c';
      case OPERATORS.LBAND:
        return 'violet';
      case OPERATORS.ECURS:
      case OPERATORS.ECURS_L:
        return 'aqua';
      case OPERATORS.ESPER:
        return 'deeppink';
      default:
        return 'royalblue';
    }
  }

  budgetSensorChange(event: any) {
    if ( event?.value?.sensor === 'GHG' && this.target?.multiTarget?.length > 1) { 
      const message = `GHG is only available for a point of interest (POI).`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      this.outComeSubmit = false;
      this.budgetForm.get('sensorType')?.reset();
      return;
    }
    this.closePanels();
    let target: any;
    this.budgetForm.patchValue({
      resolution: '',
      cloudCover: '',
      taskingTier: '',
      holdBack: '',
      updateFrequency: '',
    });
    this.resetRfSignals();
    this.updateRfSignalsControl(event)
    if (this.target.area > 0) {
      target = 'AOI';
    } else target = 'POI';
     if (event?.value?.sensor === this.aisType) {
      this.updateFrequencyOption = true;
    }
    if (event?.value?.sensor === this.rfType) {
      this.signalOfInterest = true;
    }
    let intent = this.target?.intent;

    if (
      this.budgetForm.value.sensorCategory === STRINGCONSTANTS.IMAGING_SENSOR
    ) {
      of(event)
        .pipe(
          switchMap((ev) =>
            this.apiService.getBudgetResolutionDetails(
              ev.value,
              intent,
              this.userid,
              false,
              this.target.area,
              this.target.multiTarget
            )
          ),
          takeUntil(this.destroy$)
        )
        .subscribe((res: any) => {
          if (res?.msg === 'Success') {
            let resolutions = res.response;
            this.budgetInputs.resolutionArr = resolutions.sort((a, b) =>
              this.sortResolutions(a, b)
            );
            this.budgetInputs.resolutionArr =
              this.budgetInputs.resolutionArr.filter(
                (item) => item.key !== 'Both'
              );
          }
        });
    } else {
      if (event?.value?.sensor === this.rfType) {
        if ( this.target?.geoJSON == null || this.target?.geoJSON == '') {
          const message = `Please select a target location to proceed with RF Signals selection.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
          return;
        }
        let targetType = this.target?.geoJSON?.includes('POINT') ? 'POI' : 'AOI';
        const sensorObj = {
          target: targetType,
        }
        this.apiService.getRFSignals(sensorObj).subscribe((res: any) => {
          if (res?.msg === 'Success') {
            this.budgetInputs.rfSignals = res.response;
            this.updateOptions()
          }
        });
      }
      let targetType = this.target?.geoJSON?.includes('POINT') ? 'POI' : 'AOI';
      of(event)
        .pipe(
          switchMap((ev) =>
            this.apiService.getBudgetTierDetails(
              this.budgetForm?.value?.sensorType,
              null,
              this.selectedCategory,
              this.target.selectedOption,
              this.target.multiTarget,
              targetType
            )
          ),
          takeUntil(this.destroy$)
        )
        .subscribe((res: any) => {
          if (res?.msg === 'Success') {
            let seen = new Map();
            res.response.forEach((item) => {
              let lowerItem = item?.name.toLowerCase();
              if (!seen.has(lowerItem)) {
                seen.set(lowerItem, item);
              }
            });
            let uniqueTierArr = Array.from(seen.values());
            this.budgetInputs.tierArr = uniqueTierArr;
            this.updateOptions();
          }
        });
    }
  }

  sortResolutions(a, b) {
    const aIsNumeric = /^[0-9.]+m$/.test(a.key);
    const bIsNumeric = /^[0-9.]+m$/.test(b.key);
    if (aIsNumeric && bIsNumeric) {
      return this.extractNumericValue(a.key) - this.extractNumericValue(b.key);
    } else if (aIsNumeric) {
      return -1;
    } else if (bIsNumeric) {
      return 1;
    } else {
      return this.extractNumericValue(a.key) - this.extractNumericValue(b.key);
    }
  }

  extractNumericValue(text: string): number {
    const match = text.match(/(\d+(\.\d+)?)/);
    return match ? parseFloat(match[0]) : Number.MAX_VALUE;
  }

  budgetResolutionChange(event: any) {
    this.closePanels();
    this.budgetForm.patchValue({
      cloudCover: '',
      taskingTier: '',
      holdBack: '',
    });

    let targetType = this.target?.geoJSON?.includes('POINT') ? 'POI' : 'AOI';
    this.apiService.getBudgetTierDetails(this.budgetForm?.value?.sensorType,event?.value?.key,this.selectedCategory, this.target.selectedOption, this.target.multiTarget, targetType)
      .pipe(
        takeUntil(this.destroy$),
        map((res: any) => {
          if (res?.msg !== 'Success') return [];

          return Array.from(
            new Map(
              res.response.map((item: any) => [item.name.toLowerCase(), item])
            ).values()
          );
        })
      )
      .subscribe((uniqueTierArr) => {
        this.budgetInputs.tierArr = uniqueTierArr;
        this.updateOptions();
      });
  }

  budgetTierChange(event: any) {
    this.closePanels();
    this.budgetForm.patchValue({
      cloudCover: '',
      holdBack: '',
    });

    of(event)
      .pipe(
        switchMap(() =>
          this.apiService.getBudgetCcandHoldbackDetails(
            this.budgetForm?.value?.sensorType,
            this.budgetForm?.value?.resolution,
            event.value.key,
            this.selectedCategory,
            this.target.multiTarget
          )
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((res: any) => {
        if (res?.msg === 'Success') {
          res.response.cloudCoverKeys = res.response.cloudCoverKeys.sort(
            (a, b) => parseInt(a) - parseInt(b)
          );
          this.budgetInputs.cloudCoverKeys = res.response.cloudCoverKeys.sort(
            (a, b) => parseInt(a) - parseInt(b)
          );
          this.budgetInputs.holdbackArr = this.sortArray([
            ...res.response.holdbackArr,
          ]);
          this.updateOptions();
        }
      });
  }

  isAnyFieldEmpty(): boolean {
    const requiredFields =
      this.target.taskStrategy === 'Outcome By Platform' &&
      this.outComeForm?.value?.sensorType?.name === 'AIS'
        ? ['sensorType', 'updateFrequency', 'budget', 'latency']
        : this.target.taskStrategy === 'Outcome By Platform' &&
          this.outComeForm?.value?.sensorType?.name !== 'AIS'
        ? ['sensorType', 'resolution', 'budget', 'latency', 'intent']
        : Object.keys(this.outComeForm.controls).filter(
            (key) => key !== 'cloudCover'
          );

    for (const key of requiredFields) {
      if (key != 'cloudCover') {
        const controlValue = this.outComeForm.get(key).value;
        if (
          controlValue === null ||
          controlValue === undefined ||
          controlValue === ''
        ) {
          return true;
        }
      }
    }
    return false;
  }

  submit() {
    let newTaskParams = {};
    let no_of_repeats = 1;
    let noOfMonths = 1;
    let no_of_weeks = 1;
    let startdate = moment(this.target.openWindow).utcOffset(0, true).format();
    let enddate = moment(this.target.closeWindow).utcOffset(0, true).format();
    let time_difference =
      new Date(enddate).getTime() - new Date(startdate).getTime();
    let days_difference = Math.ceil(time_difference / (1000 * 60 * 60 * 24));
    noOfMonths = Math.ceil(days_difference / 30);
    const currentDate: any = new Date();
    this.outComeSubmit = true;
    let userTimezone = this.utilsService.getTimezoneFromCountry(
      this.currentUser.country
    );

    if (this.target.selectedOption === 1) {
      if (this.target.freqOption === 'Weekly') {
        no_of_repeats = Math.ceil(days_difference / 7);
        this.expectedAge = '7 days, 00:00:00';
      } else if (this.target.freqOption === 'Monthly') {
        no_of_repeats = Math.ceil(days_difference / 30);
        this.expectedAge = '30 days, 00:00:00';
      } else if (this.target.freqOption === 'Daily') {
        no_of_repeats = days_difference;
        this.expectedAge = '1 day, 00:00:00';
      } else if (this.target.subDailyCount) {
        no_of_weeks = Math.ceil(days_difference / 7);
        no_of_repeats = days_difference * this.target.subDailyCount;
        this.expectedAge = '0 day, 04:00:00';
      }
      if (no_of_repeats === 0) {
        no_of_repeats = 1;
      }
    } else {
      no_of_repeats = 1;
    }
    newTaskParams['customerid'] = this.currentUser.id;
    newTaskParams['taskname'] = this.target.taskname;
    newTaskParams['purpose'] = this.target?.purposeOption;
    newTaskParams['area'] = this.target.area;
    newTaskParams['project'] = this.target.project;
    newTaskParams['fileName'] = this.target?.fileName;
    if (
      this.target.geotargets != null &&
      this.target.geotargets !== '[]' &&
      this.target.geotargets.trim() !== ''
    ) {
      newTaskParams['target'] = this.target.geotargets[0];
    } else {
      newTaskParams['target'] = JSON.stringify(geoParse(this.target.geoJSON));
    }
    if (this.taskStrategy !== 'TLE Based Tasking') {
      newTaskParams['geometryCentroid'] = this.target?.geometryCentroid;
    }
    newTaskParams['aoiCountry'] = this.target.country;
    newTaskParams['aoiPlace'] = this.target.place;
    newTaskParams['countryCode'] = this.target.countryCode;
    newTaskParams['frequency'] =
      this.taskStrategy === 'TLE Based Tasking'
        ? 2
        : this.target.selectedOption;
    if (this.target.selectedOption === 1) {
      newTaskParams['repeatFrequency'] = this.target.freqOption;
      newTaskParams['noOfRepeats'] = no_of_repeats;
      newTaskParams['subDailyCount'] = this.target.subDailyCount;
    } else {
      newTaskParams['repeatFrequency'] = '';
      newTaskParams['noOfRepeats'] = no_of_repeats;
      newTaskParams['subDailyCount'] = '';
    }
    if (this.taskStrategy !== 'TLE Based Tasking') {
      newTaskParams['mode'] = this.target.mode;
      newTaskParams['expected_age'] = this.expectedAge;
      newTaskParams['circleCordinates'] = this.target.circleCordinates;
    }

    newTaskParams['openWindow'] = moment(this.target.openWindow)
      .utcOffset(0, true)
      .format();
    newTaskParams['closeWindow'] = moment(this.target.closeWindow)
      .utcOffset(0, true)
      .format();
    newTaskParams['country_starttime'] = moment(newTaskParams['openWindow'])
      .tz(userTimezone)
      .format();

    newTaskParams['country_closetime'] = moment(newTaskParams['closeWindow'])
      .tz(userTimezone)
      .format();
    newTaskParams['projectid'] = this.target?.projectId;
    newTaskParams['taskStrategy'] = this.target?.taskStrategy;
    newTaskParams['tipAndCueBasedOn'] = this.target?.tipAndCueBasedOn;
    newTaskParams['observation'] =
      this.target?.observation?.length > 0 ? this.target?.observation[0] : null;
    newTaskParams['rule'] = this.target?.rule;
    newTaskParams['intent'] = this.target?.intent;
    if (this.taskStrategy !== 'TLE Based Tasking') {
      newTaskParams['cloudCover'] = this.target?.cloudCover;
      newTaskParams['taskSubStrategy'] = this.target?.taskSubStrategy;
    }
    newTaskParams['openWater'] = this.target?.openWater;

    newTaskParams['feeds'] = this.target?.feeds;
    newTaskParams['observationData'] = this.target?.observationData;
    if (this.taskStrategy === 'TLE Based Tasking') {
      newTaskParams['sensorId'] = this.retask
        ? this.selectedTasks?.request[0]?.sensorId
        : this.selectedSensorObfuscatedName?.sensorId;
    }
    if (this.target?.taskStrategy == 'Help Select Sensor(s)') {
      newTaskParams['useCase'] = this.target?.useCase;
      newTaskParams['useCaseDescription'] = this.target?.useCaseDescription;
    }
    if (this.retask && this.taskStrategy !== 'TLE Based Tasking') {
      let totalAmount = 0;
      for (const item of this.selectedTasks.request) {
        item.feasibilityId = null;
        item.firstCapture = null;
        item.isQueuedTime = null;
        item.lastCapture = null;
        item.orderStatus = null;
        item.queuedTime = null;
        item.uuid = null;
        item.status = null;
        item.statusHistory = null;
        item.taskid = null;
        (item.resolution = {
          value:
            item?.name === 'GRUS' ? item?.originalResolution : item?.resolution,
          mode_value: item?.resolutionTooltip,
          resolution_value:
            item?.name === 'GRUS' ? item?.originalResolution : item?.resolution,
          originalResolution: item?.originalResolution,
          ...(item?.originalResolution === 'Both'
            ? { combinedResolution: item?.resolution }
            : {}),
        }),
          (item.retaskingTooltip = []);
        item.feedData = [];
        item.pay = false;
        item.refund = false;
        item.orderNumber = null;

        [
          'approverDetails',
          'ordererDetails',
          'cancelerDetails',
          'rejecterDetails',
          'approved_by',
          'ordered_by',
          'canceled_by',
          'approval_rejected_details',
        ].forEach((key) => {
          if (item.hasOwnProperty(key)) {
            delete item[key];
          }
        });

        if (item.sensortype === 'GHG') {
          let annualCost = 0;
          let targetLength = 1;
          if (this.target?.geotargets) {
            targetLength =
              JSON.parse(this.target?.geotargets)?.length > 0
                ? this.target.multiTarget.length
                : 1;
          }

          const keyToMatch = item.latency.key; // Extract the key
          let ghgCost = null;

          // Find the matching cost
          for (const items of item.collectionMode[0].cost) {
            if (items[keyToMatch] !== undefined) {
              ghgCost = items[keyToMatch];
              break;
            }
          }

          if (ghgCost) {
            if (item.collectionMode[0].captureMode.includes('annual')) {
              let monthlyCost = ghgCost / 12;
              if (noOfMonths > 12) {
                if (noOfMonths % 12 === 0) {
                  annualCost = (noOfMonths / 12) * ghgCost;
                } else {
                  annualCost = ghgCost + (noOfMonths - 12) * monthlyCost;
                }
              } else {
                annualCost = ghgCost;
              }
              item.cost = parseFloat(annualCost.toFixed(2));
            } else {
              annualCost = ghgCost * noOfMonths;
              item.cost = parseFloat(annualCost.toFixed(2));
            }
            if (!item.collectionMode[0].captureMode.includes('Complex')) {
              annualCost = annualCost * targetLength;
              item.cost = parseFloat(annualCost.toFixed(2));
            }
          }
        } else if (this.target.selectedOption === 1 && item.multiplierCost) {
          item.cost = parseFloat(
            (item.multiplierCost * no_of_repeats).toFixed(2)
          );
        }
      }

      this.selectedTasks.request = this.selectedTasks.request.map((sensor) => {
        let tNumber = 0;
        if (this.currentUser?.allocated) {
          if (sensor.isPoint === true) {
            tNumber = 1 * no_of_repeats;
            this.totalTaskNumber += tNumber;
          } else {
            if (
              sensor.unit === 'sqkm' ||
              sensor.unit === 'scene' ||
              sensor.unit === 'week' ||
              sensor.unit === 'day'
            ) {
              tNumber =
                Math.ceil(sensor.areacalc / sensor.minimumArea) * no_of_repeats;
              this.totalTaskNumber += tNumber;
            }
          }
        }
        const p = this.currentUser.pointsEligible
          ? this.convertCostToPoints(sensor.cost, false)
          : 0;
        return {
          ...sensor,
          point: p,
          taskNumber: tNumber,
        };
      });

      totalAmount = this.selectedTasks.request.reduce(
        (a, { cost }) => a + cost,
        0
      );
      this.taskPoint = this.currentUser.pointsEligible
        ? this.selectedTasks.request.reduce((total, sensor) => {
            return total + this.convertCostToPoints(sensor.cost, false);
          }, 0)
        : 0;
      newTaskParams['taskcost'] = totalAmount.toFixed(2);
      newTaskParams['sensors'] = JSON.stringify(this.selectedTasks.request);
      newTaskParams['feasibilityTask'] = this.selectedTasks?.feasibilityTask;
      newTaskParams['collectionStart'] = this.selectedTasks?.collectionStart;
      newTaskParams['collectionEnd'] = this.selectedTasks?.collectionEnd;
      newTaskParams['taskPoints'] = this.taskPoint;
      newTaskParams['totalTaskNumber'] = this.totalTaskNumber;

      if (this.target?.taskStrategy === 'Outcome By Platform') {
        newTaskParams['outComeBudgetPoint'] = this.currentUser.pointsEligible
          ? this.selectedTasks?.outComeBudget
          : 0;
        newTaskParams['outComeBudget'] = this.currentUser.pointsEligible
          ? this.convertToCost(this.selectedTasks?.outComeBudget)
          : this.selectedTasks?.outComeBudget;
        // newTaskParams['outComeBudget'] = this.selectedTasks?.outComeBudget;
        newTaskParams['outComeCloudCover'] =
          this.selectedTasks?.outComeCloudCover;
        newTaskParams['outComeLatency'] = this.selectedTasks?.outComeLatency;
        newTaskParams['outComeResolution'] =
          this.selectedTasks?.outComeResolution;
        newTaskParams['outComesensorType'] =
          this.selectedTasks?.outComesensorType;
        newTaskParams['outcomeUpdateFrequency'] =
          this.outComeForm?.value?.updateFrequency;
        newTaskParams['outcomeIntent'] = this.target?.intent;

        //Popup details
        newTaskParams['noOfRefreshes'] = this.outcomePopUpData?.noOfRefreshes;
        newTaskParams['isHistorical'] = this.outcomePopUpData?.isHistorical;
        newTaskParams['historicalCost'] = this.outcomePopUpData?.historicalCost;
        newTaskParams['noOfHistoricalData'] =
          this.outcomePopUpData?.noOfHistoricalData;
      }

      this.apiService.newTaskSubmit(newTaskParams).subscribe(
        (res: any) => {
          if (res?.msg === 'Success') {
            let data = JSON.parse(res?.response);
            let taskid;
            let sensorList = this.matchUUIDs(newTaskParams['sensors'], data);
            newTaskParams['sensors'] = JSON.stringify(sensorList);
            if (data && data.length > 0) {
              taskid = res?.taskid;
              newTaskParams['taskId'] = taskid;
              this.apiService
                .genCollection(
                  this.currentUser.id,
                  this.currentUser.email,
                  newTaskParams
                )
                .subscribe((res: any) => {
                  const taskid = res?.id;
                });
            }
            const dialogRef = this.dialog.open(ConfirmDialog, {
              backdropClass: 'blurr',
              disableClose: true,
              data: {
                taskid: taskid,
                taskname: this.target.taskname,
                response: res,
                type: 'normal',
                from: 'task',
              },
            });
          }
        },
        (error: any) => {
          const dialogRef = this.dialog.open(CountrycheckComponent, {
            width: '50%',
            backdropClass: 'blurred',
            disableClose: true,
            data: { message: 'fail', url: '/task' },
          });
        }
      );
    } else {
      if (this.target?.multiTarget?.length > 1) {
        const message = `Multiple points of interest (POIs) tasking is only available for user initiated tasking strategy at this time.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        this.outComeSubmit = false;
        return;
      }

      this.outComeForm.value.budget = parseFloat(
        this.outComeForm?.value?.budget
      );
      this.outComeForm.value.sensorType =
        this.outComeForm?.value?.sensorType.name;

      newTaskParams['outComeBudgetPoint'] = this.currentUser.pointsEligible
        ? parseFloat(this.outComeForm.value.budget.toFixed(2))
        : 0;
      newTaskParams['outComeBudget'] = this.currentUser.pointsEligible
        ? this.convertToCost(
            parseFloat(this.outComeForm.value.budget.toFixed(2))
          )
        : parseFloat(this.outComeForm.value.budget.toFixed(2));
      // newTaskParams['outComeBudget'] = parseFloat(this.outComeForm.value.budget.toFixed(2));
      if (this.taskStrategy !== 'TLE Based Tasking') {
        newTaskParams['outComeCloudCover'] =
          this.outComeForm?.value?.cloudCover;
      }
      newTaskParams['outComeLatency'] =
        this.taskStrategy !== 'TLE Based Tasking'
          ? this.outComeForm?.value?.latency
          : this.getWindowDiffInHours(
              this.target.openWindow,
              this.target.closeWindow
            );
      newTaskParams['outComeResolution'] =
        this.taskStrategy === 'TLE Based Tasking'
          ? this.parseResolutionValues()
          : this.outComeForm?.value?.resolution;
      newTaskParams['outComesensorType'] =
        this.taskStrategy === 'TLE Based Tasking'
          ? this.tleSensorForm?.value?.sensorType
          : this.outComeForm?.value?.sensorType;
      if (
        this.taskStrategy === 'Tip-and-Cue' &&
        this.subStrategy === 'Tip-and-Cue-Outcome'
      ) {
        newTaskParams['outComesensorType'] = [
          {
            sensor: this.outComeForm?.value?.cueingSensorType?.name,
            sensorType: 'Cueing',
          },
          {
            sensor: this.outComeForm?.value?.tippingSensorType?.name,
            sensorType: 'Tipping',
          },
        ];
        newTaskParams['tippingSensorResolution'] =
          this.outComeForm?.value?.tippingSensorResolution;
        newTaskParams['cueingSensorResolution'] =
          this.outComeForm?.value?.cueingSensorResolution;
        newTaskParams['tippingSensorCloudCover'] =
          this.outComeForm?.value?.tippingCloudCover;
        newTaskParams['cueingSensorCloudCover'] =
          this.outComeForm?.value?.cueingCloudCover;
      }
      if (this.taskStrategy !== 'TLE Based Tasking') {
        newTaskParams['taskStrategy'] = this.subStrategy
          ? this.subStrategy
          : this.target?.taskStrategy;
      }
      newTaskParams['outcomeUpdateFrequency'] =
        this.outComeForm?.value?.updateFrequency;
      newTaskParams['outcomeIntent'] = this.target?.intent;
      if (this.target.taskStrategy !== 'TLE Based Tasking') {
        //Popup details
        newTaskParams['noOfRefreshes'] = this.outcomePopUpData?.noOfRefreshes;
        newTaskParams['isHistorical'] = this.outcomePopUpData?.isHistorical;
        newTaskParams['historicalCost'] = this.outcomePopUpData?.historicalCost;
        newTaskParams['noOfHistoricalData'] =
          this.outcomePopUpData?.noOfHistoricalData;
      }
      this.apiService.outcomeTaskSubmit(newTaskParams).subscribe(
        (res: any) => {
          if (res?.msg === 'Success') {
            let taskid;
            taskid = res?.taskid;
            newTaskParams['taskId'] = taskid;

            const dialogRef = this.dialog.open(ConfirmDialog, {
              backdropClass: 'blurr',
              disableClose: true,
              width: '40%',
              data: {
                taskid: taskid,
                taskname: this.target.taskname,
                response: res,
                type: 'outcome',
                from: 'outcome',
              },
            });
          } else if (res?.msg === 'Failed' && res?.message) {
            const dialogRef = this.dialog.open(CountrycheckComponent, {
              width: '40%',
              backdropClass: 'blurred',
              disableClose: true,
              data: {
                message: 'outcomeFail',
                response: res?.message,
                url: '/task',
              },
            });
            if (this.target?.taskStrategy === 'Outcome By Platform') {
              this.resetOutcomeDefined();
            } else {
              this.resetOutcome();
            }
          } else {
            const dialogRef = this.dialog.open(CountrycheckComponent, {
              width: '40%',
              backdropClass: 'blurred',
              disableClose: true,
              data: { message: 'fail', url: '/task' },
            });
          }
          if (this.target?.taskStrategy === 'Outcome By Platform') {
            this.resetOutcomeDefined();
          } else {
            this.resetOutcome();
          }
        },
        (error: any) => {
          const dialogRef = this.dialog.open(CountrycheckComponent, {
            width: '40%',
            backdropClass: 'blurred',
            disableClose: true,
            data: { message: 'fail', url: '/task' },
          });
          this.resetOutcome();
        }
      );
    }
  }
  getWindowDiffInHours(
    openWindow: string | Date,
    closeWindow: string | Date
  ): number {
    const openWindowMoment = moment(openWindow).utcOffset(0, true);
    const closeWindowMoment = moment(closeWindow).utcOffset(0, true);
    return closeWindowMoment.diff(openWindowMoment, 'hours', true);
  }
  parseResolutionValues() {
    const resolution = this.tleSensorForm?.value?.resolution;

    if (!resolution) {
      return {
        key: resolution,
        minValue: resolution,
        maxValue: resolution,
      };
    }
    if (resolution.includes('-')) {
      const rangeMatch = resolution.match(/(\d+\.?\d*)-(\d+\.?\d*)/);

      if (rangeMatch) {
        const minVal = parseFloat(rangeMatch[1]);
        const maxVal = parseFloat(rangeMatch[2]);

        return {
          key: resolution,
          minValue: minVal,
          maxValue: maxVal,
        };
      }
    }

    return {
      key: resolution,
      minValue: resolution,
      maxValue: resolution,
    };
  }

  convertCostToPoints(cost: number, includeLabel: boolean = true) {
    const parts = this.currentUser.sensorConversionFactor.split(':');
    const conversionFactor = parseFloat(parts[1]) / parseFloat(parts[0]);
    const points = Math.round(cost * conversionFactor);
    return includeLabel == true ? points + ' Points' : points;
  }

  getCloudData(panelOpenState, index) {
    let type;
    if (this.target.geoJSON && panelOpenState) {
      let sensorData = {};
      if (index === 0) {
        this.isChecked = false;
      }
      const currentDate: any = new Date();
      sensorData['target'] = JSON.stringify(geoParse(this.target.geoJSON));
      sensorData['openWindow'] = moment(this.target.openWindow)
        .utcOffset(0, true)
        .format();
      sensorData['closeWindow'] = moment(this.target.closeWindow)
        .utcOffset(0, true)
        .format();

      sensorData['type'] = 'days';

      const sensorObj = { sensorData: sensorData };
      this.cloudclicked = false;

      if (
        sensorObj?.sensorData['openWindow'] !== 'Invalid date' &&
        sensorObj?.sensorData['closeWindow'] !== 'Invalid date' &&
        sensorObj?.sensorData['target'] != 'null'
      ) {
        this.apiService.getCloudCoverData(sensorObj).subscribe((res: any) => {
          this.weatherData = res?.result;
          this.hourly = true;
          this.cloudclicked = true;
        });
      }
    }
  }

  getHourlyCloudData(panelOpenState, item) {
    if (this.target.geoJSON && panelOpenState) {
      let sensorData = {};
      sensorData['target'] = JSON.stringify(geoParse(this.target.geoJSON));
      sensorData['openWindow'] = item?.date;
      sensorData['closeWindow'] = item?.date;
      sensorData['type'] = 'hours';

      const sensorObj = { sensorData: sensorData };
      this.cloudclicked = false;

      if (
        sensorObj?.sensorData['openWindow'] !== 'Invalid date' &&
        sensorObj?.sensorData['closeWindow'] !== 'Invalid date' &&
        sensorObj?.sensorData['target'] != 'null'
      ) {
        this.apiService.getCloudCoverData(sensorObj).subscribe((res: any) => {
          this.weatherData = res?.result;
          this.hourly = false;
          this.cloudclicked = true;
        });
      }
    }
  }

  openFromIcon(timepicker: NgxMaterialTimepickerComponent) {
    if (!this.formGroup.get('startTime')?.value) {
      this.updateCurrentLocalTime();
      timepicker.defaultTime = this.currentLocalTime;
    } else {
      timepicker.defaultTime = this.currentLocalTime;
    }
    timepicker.open();
  }

  openDate(timepicker: NgxMaterialTimepickerComponent) {
    if (!this.formGroup.get('endTime')?.value) {
      this.updateCurrentLocalTime();
      timepicker.defaultTime = this.currentLocalTime;
    } else {
      timepicker.defaultTime = this.currentLocalTime;
    }
    timepicker.open();
  }

  onTimeSet(event: any) {
    let ustDateTime = this.onStartTimeChange(event, this.range.value.start);
    this.date = new FormControl(ustDateTime.utcStartDate);
    this.range.patchValue({
      start: ustDateTime.utcStartDate,
      end: this.range.value.end,
    });

    this.range.value.start = ustDateTime.utcStartDate;
    this.target['openWindow'] = this.range.value.start;
    const selectedTimeStr = ustDateTime.utcTime;
    const selectedTime = new Date('2000-01-01 ' + selectedTimeStr);

    const startHours = selectedTime.getHours();
    const startMinutes = selectedTime.getMinutes();
    const startSeconds = selectedTime.getSeconds();

    const openWindow = moment(this.target['openWindow']);
    const combinedDateTime = openWindow
      .set({ hour: startHours, minute: startMinutes, second: startSeconds })
      .toDate();

    this.target['openWindow'] = combinedDateTime;
    this.isPast = this.isPastDateTime(combinedDateTime);
    this.getHoursDifference();
    if (this.taskStrategy === 'TLE Based Tasking') {
      this.clearTLEOnly();
      this.showtleClick = false;
      this.showtleDisabled = false;
    }
    this.apiService.updateTaskParams(this.target);

    setTimeout(() => {
      this.formGroup.patchValue({
        startTime: ustDateTime.utcTime,
      });

      this.budgetForm.patchValue({
        startTime: ustDateTime.utcTime,
      });
    }, 0);
    this.updateTarget(this.target, '0');
  }

  onEndTimeSet(event: any) {
    let ustDateTime = this.onEndTimeChange(event, this.range.value.end);
    this.range.patchValue({
      end: ustDateTime.utcEndDate,
    });
    this.range.value.end = ustDateTime.utcEndDate;
    if (this.selectedOption === 0) {
      this.range.value.end = this.range.value.start;
    }
    this.target['closeWindow'] = this.range.value.end;
    const selectedTimeStr = ustDateTime.utcTime;
    const selectedTime = new Date('2000-01-01 ' + selectedTimeStr);

    const startHours = selectedTime.getHours();
    const startMinutes = selectedTime.getMinutes();
    const startSeconds = selectedTime.getSeconds();

    const closeWindow = moment(this.target['closeWindow']);
    const combinedDateTime = closeWindow
      .set({ hour: startHours, minute: startMinutes, second: startSeconds })
      .toDate();

    this.target['closeWindow'] = combinedDateTime;
    this.isEndPast = this.isEarlierThan(
      this.target['closeWindow'],
      this.target['openWindow']
    );

    this.getHoursDifference();
    if (this.taskStrategy === 'TLE Based Tasking') {
      this.clearTLEOnly();
      this.showtleClick = false;
      this.showtleDisabled = false;
      if (this.getHoursDifference() > 72) {
        this.tleToiError = true;
      } else {
        this.tleToiError = false;
      }
    }
    this.apiService.updateTaskParams(this.target);

    setTimeout(() => {
      this.formGroup.patchValue({
        endTime: ustDateTime.utcTime,
      });

      this.budgetForm.patchValue({
        endTime: ustDateTime.utcTime,
      });
    }, 0);
    this.updateTarget(this.target, '0');
  }

  getHoursDifference(): number {
    const millisecondsPerHour = 1000 * 60 * 60;
    const differenceInMilliseconds =
      this.target['closeWindow']?.getTime() -
      this.target['openWindow']?.getTime();
    if (this.taskStrategy !== 'TLE Based Tasking') {
      this.timeError = differenceInMilliseconds / millisecondsPerHour;
    }
    return differenceInMilliseconds / millisecondsPerHour;
  }

  isPastDateTime(dateTime: Date): boolean {
    const givenDate = new Date(dateTime);

    // Get the current date and time in UTC
    const nowUtc = new Date();

    // Convert the current date and time to UTC
    const currentUtcDate = new Date(
      nowUtc.getUTCFullYear(),
      nowUtc.getUTCMonth(),
      nowUtc.getUTCDate(),
      nowUtc.getUTCHours(),
      nowUtc.getUTCMinutes(),
      nowUtc.getUTCSeconds()
    );

    const hasPassed = givenDate.getTime() < currentUtcDate.getTime();
    return hasPassed;
  }

  // Method to check if one date-time is earlier than another
  isEarlierThan(end: Date, start: Date): boolean {
    const date1 = new Date(end);
    const date2 = new Date(start);

    return date1.getTime() < date2.getTime();
  }

  drawTaskableAOI(positionArray: any) {
    const modifiedArray = positionArray[0].map((sub: any) => [
      sub[1],
      sub[0]
    ]);
    const polygon = L.polygon(modifiedArray, {
      color: 'yellow',
      fill: false,
      weight: 2
    });
    this.taskableGroup.addLayer(polygon);

    /* ---------- LABEL LOGIC ---------- */
    const polygonPoints = positionArray[0]; // [lon, lat]

    const bottomLonLat = polygonPoints.reduce(
      (lowest, current) => current[1] < lowest[1] ? current : lowest,
      polygonPoints[0]
    );

    const latitudes = polygonPoints.map(p => p[1]);
    const maxLat = Math.max(...latitudes);
    const minLat = Math.min(...latitudes);
    const latRange = maxLat - minLat;
    const shiftDegrees = latRange * 0.05;
    const labelLat = bottomLonLat[1] - shiftDegrees;
    const labelLon = bottomLonLat[0];
    const labelLatLng = L.latLng(labelLat, labelLon);

    const textMarker = L.marker(labelLatLng, {
      icon: L.divIcon({
        className: 'polygon-text',
        html: 'This is your allowed tasking area',
        iconSize: [220, 30],
        iconAnchor: [110, 0] // center horizontally, top aligned
      }),
      interactive: false
    });
    this.taskableGroup.addLayer(textMarker);
  }

  removeEntity() {
    const entities = this.viewer.entities.values;
    for (let i = entities.length - 1; i >= 0; i--) {
      if (entities[i]?.name !== 'allowedArea') {
        this.viewer.entities.remove(entities[i]);
      }
    }
  }
  removeEntityTle() {
    const entities = this.viewer.entities.values;
    for (let i = entities.length - 1; i >= 0; i--) {
      if (entities[i]?.name !== 'allowedArea') {
        this.viewer.entities.remove(entities[i]);
      }
    }
  }

  checkPointInsidePolygon(mousePoint) {
    this.shapeSelected = true;

    let isInside = this.currentUser.taskableAoi.some((aoi) =>
      this.utilsService.pointInPolygon(
        mousePoint,
        aoi.taskableAoi.coordinates[0]
      )
    );
    if (!isInside) {
      const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
      const dialogRef = this.popupService.openPopup(
        WarningPopup,
        message,
        '',
        '50%'
      );

      dialogRef.afterClosed().subscribe(() => {
        this.resetMap();
      });
    }
  }

  loadTaskCostDetails() {
    let tipAndCueObservation = true;
    let tipAndCueRule = true;
    let tipAndCueFeed = true;
    const validDate =
      (this.dateFlag && this.selectedOption != 0) ||
      this.range.value.end === null ||
      this.isPast ||
      this.isEndPast;
    if (this.taskStrategy === 'Tip-and-Cue') {
      if (this.subStrategy === 'Tip-and-Cue') {
        tipAndCueObservation =
          this.target.observation && this.tipAndCueBasedOn === 'Observation';
        tipAndCueRule = this.target.rule && this.tipAndCueBasedOn === 'Rules';
        tipAndCueFeed = this.target.feeds && this.tipAndCueBasedOn === 'Feeds';
      }
    }
    const toiRange =
      (this.timeError < 4 && this.selectedOption === 0) ||
      (this.timeError < 24 && this.selectedOption != 0);
    const noUsecase =
      this.taskStrategy === 'Help Select Sensor(s)' && !this.target.useCase;

    return (
      this.formGroup.valid &&
      this.target.geoJSON?.length > 10 &&
      !validDate &&
      (tipAndCueObservation ||
        tipAndCueRule ||
        tipAndCueFeed ||
        this.taskStrategy != 'Tip-and-Cue') &&
      !toiRange &&
      !noUsecase
    );
  }

  matchUUIDs(selectedSensors, taskResponse) {
    let sensorList = JSON.parse(selectedSensors);

    const minLength = Math.min(sensorList.length, taskResponse.length);
    for (let i = 0; i < minLength; i++) {
      sensorList[i].uuid = taskResponse[i].uuid;
    }

    return sensorList;
  }

  budgetEnable() {
    const validDate =
      (this.dateFlag && this.selectedOption != 0) ||
      this.range.value.end === null ||
      this.isPast;
    const toiRange =
      (this.timeError < 4 && this.selectedOption === 0) ||
      (this.timeError < 24 && this.selectedOption != 0);
    const frequencyUpdate = (this.budget && this.displayUpdateFrequency() && !this.budgetForm.value.updateFrequency.value);
    return validDate || toiRange || frequencyUpdate;
  }

  displayUpdateFrequency() {
    return this.updateFrequencyOption && this.budgetForm?.get('sensorType')?.value?.sensor == 'AIS';
  }

  resetForm() {
    this.budgetForm.reset();
    this.range.reset();
    this.resetMap();
    this.target.geoJSON = null;
    this.selectedOption = 0;
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    this.date = new FormControl(new Date(year, month - 1, day + 1));
    this.range = new FormGroup({
      start: new FormControl(new Date(year, month - 1, day + 1)),
      end: new FormControl(new Date(year, month - 1, day + this.defaultWindow)),
    });
    this.clickFrequency = false;
    const sensorCategoryControl = this.budgetForm.get('sensorCategory');
    sensorCategoryControl?.setValue(STRINGCONSTANTS.IMAGING_SENSOR);
  }
  resetFormTle() {
    if (this.retask) {
      if (this.satelliteDataSubscription) {
        this.satelliteDataSubscription.unsubscribe();
        this.satelliteDataSubscription = null;
      }
      this.router.navigate(['/task']);
    } else {
      if (this.satelliteDataSubscription) {
        this.satelliteDataSubscription.unsubscribe();
        this.satelliteDataSubscription = null;
      }
      this.showtleClick = false;
      this.showtleDisabled = false;
      this.formGroup.reset();
      this.selectedOption = 2;
      this.range.reset();
      this.mapLoading = false;
      this.tleSensorForm.reset();
      this.tleSensor = {
        resolution: [],
        sensor: [],
      };
      this.selectedSensorObfuscatedName;
      this.resetMap('tle');
      this.target.geoJSON = null;
      this.selectedOption = 0;
      const today = new Date();
      const day = today.getDate();
      const month = today.getMonth() + 1;
      const year = today.getFullYear();
      this.date = new FormControl(new Date(year, month - 1, day + 1));
      this.range = new FormGroup({
        start: new FormControl(new Date(year, month - 1, day)),
        end: new FormControl(new Date(year, month - 1, day + 3)),
      });
      this.target = { geoJSON: '', area: 0 };
      this.taskStrategy = '';
      this.clickFrequency = false;
    }
    this.disableEnableDrawControls(true, '');
  }

  submitBudget() {
    let newTaskParams = {};
    let no_of_repeats = 1;
    let noOfMonths = 1;
    let no_of_weeks = 1;
    let startdate = moment(this.target.openWindow).utcOffset(0, true).format();
    let enddate = moment(this.target.closeWindow)
      .utcOffset(0, true)
      .add(86399, 'seconds')
      .format();
    let time_difference =
      new Date(enddate).getTime() - new Date(startdate).getTime();
    let days_difference = Math.ceil(time_difference / (1000 * 60 * 60 * 24));
    noOfMonths = Math.ceil(days_difference / 30);
    this.outComeSubmit = true;
    let userTimezone = this.utilsService.getTimezoneFromCountry(
      this.currentUser.country
    );

    // if (this.target?.multiTarget?.length > 1) {
    //   const message = `Budgeting is only available for a point of interest (POI) or an area of interest (AOI).`;
    //   this.popupService.openPopup(WarningPopup, message, '', '50%');
    //   this.outComeSubmit = false;
    //   return;
    // }

    if (this.target.selectedOption === 1) {
      if (this.target.freqOption === 'Weekly') {
        no_of_repeats = Math.ceil(days_difference / 7);
        this.expectedAge = '7 days, 00:00:00';
      } else if (this.target.freqOption === 'Monthly') {
        no_of_repeats = Math.ceil(days_difference / 30);
        this.expectedAge = '30 days, 00:00:00';
      } else if (this.target.freqOption === 'Daily') {
        no_of_repeats = days_difference;
        this.expectedAge = '1 day, 00:00:00';
      } else if (this.target.subDailyCount) {
        no_of_weeks = Math.ceil(days_difference / 7);
        no_of_repeats = days_difference * this.target.subDailyCount;
        this.expectedAge = '0 day, 04:00:00';
      }
      if (no_of_repeats === 0) {
        no_of_repeats = 1;
      }
    } else {
      no_of_repeats = 1;
    }

    newTaskParams['customerid'] = this.currentUser.id;
    newTaskParams['area'] = this.target.area;
    newTaskParams['project'] = this.target.project;
    newTaskParams['fileName'] = this.target?.fileName;
    if (
      this.target.geotargets &&
      this.target.geotargets.trim() !== '' &&
      this.target.geotargets.trim() !== '[]'
    ) {
      newTaskParams['target'] = this.target.geotargets;
    } else {
      newTaskParams['target'] = JSON.stringify(geoParse(this.target.geoJSON));
    }
    newTaskParams['aoiCountry'] = this.target.country;
    newTaskParams['aoiPlace'] = this.target.place;
    newTaskParams['countryCode'] = this.target.countryCode;
    newTaskParams['frequency'] = this.target.selectedOption;
    if (this.target.selectedOption === 1) {
      newTaskParams['repeatFrequency'] = this.target.freqOption;
      newTaskParams['noOfRepeats'] = no_of_repeats;
      newTaskParams['subDailyCount'] = this.target.subDailyCount;
    } else {
      newTaskParams['repeatFrequency'] = '';
      newTaskParams['noOfRepeats'] = no_of_repeats;
      newTaskParams['subDailyCount'] = '';
    }
    newTaskParams['mode'] = this.target.mode;
    newTaskParams['expected_age'] = this.expectedAge;
    newTaskParams['circleCordinates'] = this.target.circleCordinates;

    newTaskParams['openWindow'] = moment(this.target.openWindow)
      .utcOffset(0, true)
      .format();
    newTaskParams['closeWindow'] = moment(this.target.closeWindow)
      .utcOffset(0, true)
      .format();
    newTaskParams['country_starttime'] = moment(newTaskParams['openWindow'])
      .tz(userTimezone)
      .format();
    newTaskParams['country_closetime'] = moment(newTaskParams['closeWindow'])
      .tz(userTimezone)
      .format();
    newTaskParams['resolution'] = this.budgetForm.value.resolution;
    newTaskParams['taskingTier'] = this.budgetForm.value.taskingTier;
    newTaskParams['cloudCover'] = this.budgetForm.value.cloudCover;
    newTaskParams['holdBack'] = this.budgetForm.value.holdBack;
    newTaskParams['sensorType'] = this.budgetForm.value.sensorType;
    newTaskParams['numOfWeeks'] = no_of_weeks;
    newTaskParams['noOfMonths'] = noOfMonths;
    newTaskParams['intent'] = this.budgetForm.value?.intent;
    newTaskParams['sensorCategory'] = this.budgetForm.value?.sensorCategory;
    newTaskParams['openWater'] = this.target?.openWater;
    newTaskParams['updateFrequency'] = this.budgetForm.value.updateFrequency.value;
    if (this.budgetForm.value.sensorType.sensor === this.aisType) {
      newTaskParams['noOfRefreshes'] = this.outcomePopUpData?.noOfRefreshes;
      newTaskParams['isHistorical'] = this.outcomePopUpData?.isHistorical;
      newTaskParams['historicalCost'] = this.outcomePopUpData?.historicalCost;
      newTaskParams['noOfHistoricalData'] =
        this.outcomePopUpData?.noOfHistoricalData;
    }
    if (this.budgetForm.value.sensorType.sensor === this.rfType) {
      newTaskParams['rfSignals'] = this.budgetForm.value?.rfSignals;
      newTaskParams['rawIQData'] = this.budgetForm.value?.rawIQData;
    }
    this.apiService.createBudget(newTaskParams).subscribe(
      (res: any) => {
        newTaskParams['budgetRange'] = res?.response?.minMaxCost;
        newTaskParams['sensors'] = res?.response?.sensors;
        newTaskParams['budget'] = res?.response?.budget;
        newTaskParams['budgetPoints'] = res?.response?.budgetPoints;
        if (res?.msg === 'Success') {
        let targetInMap: any[] = [];

        if (this.target?.multiTarget.length > 0) {
          targetInMap = this.target?.multiTarget;
        } else {
          targetInMap.push(this.target.geoJSON);
        }
         newTaskParams['targetInMap'] =  targetInMap;
          const dialogRef = this.dialog.open(BudgetpopupComponent, {
            backdropClass: 'blurr',
            disableClose: true,
            width: '40%',
            data: {
              data: res.response,
              strategy: this.strategyOptions[0],
              intent: this.budgetForm.value?.intent,
              purpose: this.purposeOption[0],
              pointUser: this.currentUser.pointsEligible, currentUser: this.currentUser, isBroRF: this.isBroRF(), rfSignals: this.budgetForm.value.sensorType.sensor === this.rfType ? this.budgetForm.value?.rfSignals : null,
              targetInMap: targetInMap,frequency: this.target.selectedOption,repeatFrequency: this.target?.freqOption,
              differenceInDays: days_difference,numberOfRepeats: no_of_repeats, audioSelections: this.audioSelections
            },
          });

          dialogRef
            .afterClosed()
            .subscribe((result: { action: string; data?: any }) => {
            let pointCount = this.countPoints(this.target.geoJSON);
            this.selectedTasks
            if(pointCount === 1 && this.budgetForm.value.sensorType.sensor === this.rfType){
            const coords = this.utilsService.extractCoordinates(this.pointArray[0]);
            const radius = RF_RADIUS * 1000;
            let coordinates = this.utilsService.getCirclePolygon(coords,radius);
            newTaskParams['target'] = JSON.stringify(geoParse(coordinates));
            }
            
              if (result.action === 'save') {
                const budgetName = result.data;
                newTaskParams['budgetName'] = result?.data?.budgetName;
               if (this.budgetForm.value.sensorType.sensor === this.rfType && this.isBroRFSelected === false) {
                             const sensorsArray = newTaskParams['sensors'];
              const siteDataArray = result?.data?.rfSiteAndCollection?.siteData;
              if (Array.isArray(siteDataArray)) {
              sensorsArray.forEach((sensor: any) => {
              if (sensor.sensor === 'RF' || sensor.sensortype === 'RF') {
              sensor.siteData = siteDataArray;
             }
           });
          }
          newTaskParams['sensors'] = sensorsArray;
               }
                this.apiService
                  .saveBudget(newTaskParams)
                  .subscribe((res: any) => {
                    if (res?.msg === 'Success') {
                      this.router.navigate(['/budget']);
                    } else {
                      const dialogRef = this.dialog.open(
                        CountrycheckComponent,
                        {
                          width: '40%',
                          backdropClass: 'blurred',
                          disableClose: true,
                          data: {
                            message: 'budgetFail',
                            url: '/budget',
                            response: res?.response,
                          },
                        }
                      );
                    }
                  });
              } else if (result.action === 'save_task') {
                newTaskParams['project'] = result?.data?.project;
                newTaskParams['taskname'] = result?.data?.taskname;
                newTaskParams['taskStrategy'] =
                  result?.data?.taskStrategy?.value;
                newTaskParams['sensors'] = this.budgetForm.value.sensorType.sensor === 'RF'  ? this.updateCostsByCount(result?.data?.sensors, pointCount) : result?.data?.sensors;
                newTaskParams['intent'] = result?.data?.intent;
                newTaskParams['purpose'] = result?.data?.purpose;
                newTaskParams['projectid'] = null;
                newTaskParams['feasibilityTask'] = false;
                newTaskParams['observation'] = null;
                newTaskParams['tipAndCueBasedOn'] = '';
                newTaskParams['openWater'] = this.target?.openWater;
                if (this.budgetForm.value.sensorType.sensor === this.rfType && this.isBroRFSelected === false) {
                const sensorsArray = JSON.parse(newTaskParams['sensors'] || '[]');
                const siteDataArray = result?.data?.rfSiteAndCollection?.siteData;
                if (Array.isArray(siteDataArray)) {
                sensorsArray.forEach((sensor: any) => {
                if (sensor.sensor === 'RF' || sensor.sensortype === 'RF') {
               sensor.siteData = siteDataArray;
             }
           });
          }
          newTaskParams['sensors'] = JSON.stringify(sensorsArray);
              }

                delete newTaskParams['cloudCover'];
                const submitApi = this.target.multiTarget && this.target?.multiTarget.length > 0 ? this.apiService.multiPoiTaskSubmit(newTaskParams) : this.apiService.newTaskSubmit(newTaskParams);
                submitApi.subscribe((res: any) => {
                    if (res?.msg === 'Success') {
                      let data = JSON.parse(res?.response);
                      let taskid;
                      let sensorList = this.matchUUIDs(
                        newTaskParams['sensors'],
                        data
                      );
                      newTaskParams['sensors'] = JSON.stringify(sensorList);
                      if (data && data.length > 0) {
                        taskid = res?.taskid;
                        newTaskParams['taskId'] = taskid;
                        this.apiService
                          .genCollection(
                            this.currentUser.id,
                            this.currentUser.email,
                            newTaskParams
                          )
                          .subscribe((res: any) => {
                            const taskid = res?.id;
                          });
                      }
                      const dialogRef = this.dialog.open(ConfirmDialog, {
                        backdropClass: 'blurr',
                        disableClose: true,
                        data: {
                          taskid: taskid,
                          taskname: newTaskParams['taskname'],
                          response: res,
                          type: 'normal',
                          from: 'budget',
                        },
                      });
                    } else {
                      this.outComeSubmit = false;
                      const dialogRef = this.dialog.open(
                        CountrycheckComponent,
                        {
                          width: '40%',
                          backdropClass: 'blurred',
                          disableClose: true,
                          data: {
                            message: 'budgetFail',
                            url: '/budget',
                            response: res?.response,
                          },
                        }
                      );
                    }
                  });
              } else {
                this.outComeSubmit = false;
              }
            });
        } else {
          this.outComeSubmit = false;
          const dialogRef = this.dialog.open(CountrycheckComponent, {
            width: '40%',
            backdropClass: 'blurred',
            disableClose: true,
            data: {
              message: 'budgetFail',
              url: '/budget',
              response: res?.response,
            },
          });
        }
      },
      (error: any) => {
        this.outComeSubmit = false;
        const dialogRef = this.dialog.open(CountrycheckComponent, {
          width: '40%',
          backdropClass: 'blurred',
          disableClose: true,
          data: { message: 'budgetFail', url: '/budget', response: error },
        });
      }
    );
  }

  countPoints(wkt: string): number {
  if (!wkt) return 0;
  return (wkt.match(/POINT\s*\(/g) || []).length;
}

updateCostsByCount(jsonString: string, count: number): string {
  if (!jsonString || count <= 0) {
    return jsonString;
  }

  const data = JSON.parse(jsonString);

  const updatedData = data.map((item: any) => {
    const hasSOI = Array.isArray(item?.signalOfInterest);

    return {
      ...item,
      cost: item.cost / count,
      unitCost: item.unitCost / count,
      multiplierCost: item.multiplierCost / count,
      minimumArea: typeof item.minimumArea === 'string'
      ? item.minimumArea.replace(/,/g, '')
      : item.minimumArea,
      isPoint: count >= 1,
      noOfCollections: 1,
      targetPoints: count === 1 ? item.targetPoints : null,
      ...(hasSOI && {
        signalOfInterest: item.signalOfInterest.map((soi: any) => {
          const audioMatch = this.audioSelections?.find(
            (a: any) => a.value === soi.value
          );

          return {
            ...soi,
            collectionDuration: audioMatch?.audioChecked
              ? 60
              : soi.collection_duration?.[0]?.value ?? null,
            isAudio: audioMatch?.audioChecked ?? false
          };
        })
      })
    };
  });

  return JSON.stringify(updatedData);
}

  sortArray(array: string[]): string[] {
    return array.sort((a, b) => {
      return this.getPriority(a) - this.getPriority(b);
    });
  }
  sortResolution(
    a: { key: string; name: string },
    b: { key: string; name: string }
  ): number {
    const isNumeric = (value: string): boolean =>
      !isNaN(parseFloat(value.charAt(0)));

    const parseResolution = (res: string): { value: number; text: string } => {
      const match = res.match(/(\d+(\.\d+)?)(.*)/);
      const value = match ? parseFloat(match[1]) : NaN;
      const text = match ? match[3].trim() : res;
      return { value, text };
    };

    const resA = parseResolution(a.name);
    const resB = parseResolution(b.name);

    if (isNumeric(a.name) && isNumeric(b.name)) {
      if (resA.value !== resB.value) {
        return resA.value - resB.value;
      }
      return resA.text.localeCompare(resB.text);
    } else if (isNumeric(a.name)) {
      return -1;
    } else if (isNumeric(b.name)) {
      return 1;
    }
    return a.name.localeCompare(b.name);
  }

  getPriority(value: string): number {
    if (value.includes('days')) {
      return 1;
    } else if (value.includes('months')) {
      return 2;
    } else {
      return 3;
    }
  }
  setUTCTodayDate() {
    const now = new Date();
    const utcYear = now.getUTCFullYear();
    const utcMonth = now.getUTCMonth();
    const utcDate = now.getUTCDate();
    this.todayDate = new Date(Date.UTC(utcYear, utcMonth, utcDate));
  }

  convertToPoints(cost: number): number {
    const parts = this.currentUser.sensorConversionFactor.split(':');
    const conversionFactor = parseFloat(parts[1]) / parseFloat(parts[0]);
    return Math.round(cost * conversionFactor);
  }
  convertToCost(point: number): number {
    const parts = this.currentUser.sensorConversionFactor.split(':');
    const conversionFactor = parseFloat(parts[1]) / parseFloat(parts[0]);
    return Math.round(point / conversionFactor);
  }
  capitalizeFirstLetter(value: string): string {
    if (!value) {
      return '';
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
  updateOptions() {
    this.cloudCoverOptions = this.budgetInputs.cloudCoverKeys || [];
    this.resolutionOptions = this.budgetInputs.resolutionArr || [];
    this.taskingTierOptions = this.budgetInputs.tierArr || [];
    this.holdBackOptions = this.budgetInputs.holdbackArr || [];
    this.rfSignalOptions = this.budgetInputs.rfSignals || [];

    const isGreaterThan20 = this.cloudCoverOptions.some((option) => {
      const percentage = parseInt(option, 10);
      return percentage > 20;
    });

    this.updateFormControlValidators('cloudCover', this.cloudCoverOptions);

    this.updateFormControlValidators('resolution', this.resolutionOptions);
    this.updateFormControlValidators('taskingTier', this.taskingTierOptions);
    this.updateFormControlValidators('rfSignals', this.rfSignalOptions);
  }
  updateFormControlValidators(controlName: string, options: string[]) {
    const control = this.budgetForm.get(controlName);
    if (options.length > 0) {
      control.setValidators([Validators.required]);
    } else {
      control.clearValidators();
    }

    control.updateValueAndValidity();
  }

  resetDateDefault() {
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();

    this.date = new FormControl(new Date(year, month - 1, day + 1));

    this.range = new FormGroup({
      start: new FormControl(new Date(year, month - 1, day + 1)),
      end: new FormControl(new Date(year, month - 1, day + this.defaultWindow)),
    });
  }

  onStartTimeChange(event: any, date: any) {
    let utcEndDate;
    const localStartDate = moment(date);
    const localTime = `${localStartDate.format('YYYY-MM-DD')} ${event}`;
    const localMoment = moment.tz(
      localTime,
      'YYYY-MM-DD HH:mm A',
      this.userTimezone
    ); // Convert to the user’s timezone
    const utcMoment = localMoment.utc();
    const utcStartDate = new Date(utcMoment.format('YYYY-MM-DD'));
    const utcTime = utcMoment.format('hh:mm A');
    if (this.selectedFrequencyID !== 0) {
      utcEndDate = moment(utcStartDate).add(30, 'days').toDate();
    } else {
      utcEndDate = utcStartDate;
    }
    return { utcTime, utcStartDate, utcEndDate };
  }

  onEndTimeChange(event: any, date: any) {
    const localStartDate = moment(date);
    const localTime = `${localStartDate.format('YYYY-MM-DD')} ${event}`;
    const localMoment = moment.tz(
      localTime,
      'YYYY-MM-DD HH:mm A',
      this.userTimezone
    ); // Convert to the user’s timezone
    const utcMoment = localMoment.utc();
    const utcEndDate = new Date(utcMoment.format('YYYY-MM-DD'));
    const utcTime = utcMoment.format('hh:mm A');
    return { utcTime, utcEndDate };
  }
  updateCurrentLocalTime() {
    this.currentLocalTime = this.utilsService.getCurrentLocalTime(
      this.currentUser
    );
  }

  resetOutcome() {
    this.outComeForm.patchValue({
      sensorType: '',
      resolution: '',
      cloudCover: '',
      latency: '',
      budget: '',
      updateFrequency: '',
      intent: '',
    });
    this.outComesensor = [];
    this.outComeSubmit = false;
    this.showResolution =
      this.selectedCategory !== STRINGCONSTANTS.NON_IMAGING_SENSOR;
  }
  subStrategyChange(event: any) {
    this.subStrategy = event.value;
    this.formGroup.get('subStrategyRadio').setValue(event.value);
    this.target.taskSubStrategy = event.value;
    let openWater = this.target.openWater ? this.target.openWater : false;
    if (event.value === 'Tip-and-Cue') this.getObservationList(openWater);
  }
  tipAndCueTypeSelectChange(data: any) {
    this.tipAndCueBasedOn = data.value;

    this.target.tipAndCueBasedOn = data.value;

    this.observation = null;

    this.target.observation = null;

    this.rule = null;

    this.target.rule = null;

    this.updateTarget(this.target, '0');
  }
  tippingSensorChange(event: any) {
    let target: any;
    this.outComeForm.patchValue({
      tippingSensorResolution: '',
      tippingCloudCover: '',
    });

    this.tippingSensorResolution = [];
    this.tippingSensorCloudCover = [];

    if (this.target.area > 0) {
      target = 'AOI';
    } else target = 'POI';

    let intent = this.target?.intent?.key
      ? this.target?.intent.key
      : this.target?.intent;
    let sensorObj = {
      sensorType: event.value,
      target: target,
      intent: intent,
      type: 'tipping',
    };
    this.apiService
      .getTippingCueingSensorDetails(sensorObj)
      .subscribe((res: any) => {
        this.tippingSensorCloudCover.length = 0;
        this.outComesensor = res;
        this.tippingSensorResolution = res.tippingSensorResolution;
        const cloudC: any = [];
        if (res.tippingSensorCloudCover) {
          for (var key in res.tippingSensorCloudCover) {
            cloudC.push({ key, value: res.tippingSensorCloudCover[key] });
          }
          this.tippingSensorCloudCover = cloudC;

          if (this.tippingSensorCloudCover?.length === 0) {
            this.outComeForm.get('tippingCloudCover').disable();
          } else {
            this.outComeForm.get('tippingCloudCover').enable();
          }

          if (!this.tippingSensorResolution) {
            this.outComeForm.get('tippingSensorResolution').disable();
          } else {
            this.outComeForm.get('tippingSensorResolution').enable();
          }
        }
      });
  }
  cueingSensorChange(event: any) {
    let target: any;
    this.outComeForm.patchValue({
      cueingSensorResolution: '',
      cueingCloudCover: '',
    });

    this.cueingSensorResolution = [];
    this.cueingSensorCloudCover = [];

    if (this.target.area > 0) {
      target = 'AOI';
    } else target = 'POI';

    let intent = this.target?.intent?.key
      ? this.target?.intent.key
      : this.target?.intent;
    let sensorObj = {
      sensorType: event.value,
      target: target,
      intent: intent,
      type: 'cueing',
    };
    this.apiService
      .getTippingCueingSensorDetails(sensorObj)
      .subscribe((res: any) => {
        this.cueingSensorCloudCover.length = 0;
        this.outComesensor = res;
        this.cueingSensorResolution = res.cueingSensorResolution;
        const cloudC: any = [];
        if (res.cueingSensorCloudCover) {
          for (var key in res.cueingSensorCloudCover) {
            cloudC.push({ key, value: res.cueingSensorCloudCover[key] });
          }
          this.cueingSensorCloudCover = cloudC;

          if (this.cueingSensorCloudCover?.length === 0) {
            this.outComeForm.get('cueingCloudCover').disable();
          } else {
            this.outComeForm.get('cueingCloudCover').enable();
          }

          if (!this.cueingSensorResolution) {
            this.outComeForm.get('cueingSensorResolution').disable();
          } else {
            this.outComeForm.get('cueingSensorResolution').enable();
          }
        }
      });
  }

  resetOutcomeDefined() {
    this.outComeForm.patchValue({
      resolution: '',
      budget: '',
      intent: '',
    });
    this.outComeSubmit = false;
  }

  updateFrequencyChange(value: any): void {
    const startTime = moment(this.target.openWindow).utcOffset(0, true);
    const endTime = moment(this.target.closeWindow).utcOffset(0, true);
    const clydePeriodDuration = endTime.diff(startTime, 'days', true);
    if (value.operatorKey === 'ClydeSpace') {
      if (clydePeriodDuration < 90) {
        const message = `We are unable to accept this task as this sensor requires TOI should be minimum 3 months. Please change your time of interest or choose an alternative provider.`;
        this.showWarningPopup(message);
        this.outComeForm.patchValue({ updateFrequency: '' });
        this.budgetForm.patchValue({ updateFrequency: '' });
        return;
      }
    }
    this.outcomePopUpData = {};
    if (['ClydeSpace', 'Spire'].includes(value.operatorKey)) {
      this.openOperatorDialog(value.operatorKey);
    }
  }

  private showWarningPopup(message: string): void {
    this.popupService.openPopup(WarningPopup, message, '', '50%');
  }

  private openOperatorDialog(operatorKey: string): void {
    const dialog = this.dialog.open(OperatorPopupComponent, {
      minWidth: '50%',
      backdropClass: 'blurred',
      disableClose: true,
      data: {
        selectedRow: {},
        operatorKey,
        daysCount: '',
        subscriptionAmount: null,
        hideTooltip: true,
      },
    });
    dialog.afterClosed().subscribe((result) => {
      if (result != 'close') {
        const historicalCost = result.isHistorical ? 175 : 0;
        if (operatorKey === 'Spire') {
          this.outcomePopUpData.noOfRefreshes = result?.refreshCount;
          this.outcomePopUpData.isHistorical = result?.isHistorical;
          this.outcomePopUpData.historicalCost = historicalCost;
          this.outcomePopUpData.noOfHistoricalData = result?.fetchCount;
        } else if (operatorKey === 'ClydeSpace') {
          this.outcomePopUpData.isHistorical = result?.isHistorical;
          this.outcomePopUpData.noOfHistoricalData = result?.daysCount;
        }
      } else {
        this.outComeForm.patchValue({ updateFrequency: '' });
        this.budgetForm.patchValue({ updateFrequency: '' });
      }
    });
  }

  private handleSearchDisable(): void {
    const searchBtnParentEl = document.querySelector(
      '.leaflet-geosearch-button'
    ) as HTMLElement;
    /** Search disable when click on layer */
    const layerEl: any = document.querySelector(
      '.leaflet-control-layers-toggle'
    ) as HTMLElement;
    layerEl.addEventListener('click', (event: any) => {
      this.resetSearchInput();
    });

    /** Search disable when click on draw icons */
    const toolbarButtons = document.querySelectorAll('.leaflet-draw-toolbar a');
    toolbarButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.resetSearchInput();
      });
    });
  }

  openSensorPreview() {
    this.sharedDataService.setData({ fromNewTask: true });
    this.router.navigate(['/preview']);
  }
  isAnyFieldNull(): boolean {
    const requiredFields = [
      'tipAndCueBasedOn',
      'latency',
      'budget',
      'tippingSensorType',
      'cueingSensorType',
      'tippingSensorResolution',
      'cueingSensorResolution',
      'tippingCloudCover',
      'cueingCloudCover',
    ];

    for (const key of requiredFields) {
      const controlValue = this.outComeForm.get(key).value;
      if (key === 'cueingCloudCover') {
        if (
          this.cueingSensorCloudCover?.length > 0 &&
          (controlValue === null ||
            controlValue === undefined ||
            controlValue === '')
        )
          return true;
      } else if (key === 'tippingCloudCover') {
        if (
          this.tippingSensorCloudCover?.length > 0 &&
          (controlValue === null ||
            controlValue === undefined ||
            controlValue === '')
        )
          return true;
      } else if (key === 'cueingSensorResolution') {
        if (
          this.cueingSensorResolution?.length > 0 &&
          (controlValue === null ||
            controlValue === undefined ||
            controlValue === '')
        )
          return true;
      } else if (key === 'tippingSensorResolution') {
        if (
          this.tippingSensorResolution?.length > 0 &&
          (controlValue === null ||
            controlValue === undefined ||
            controlValue === '')
        )
          return true;
      } else if (
        controlValue === null ||
        controlValue === undefined ||
        controlValue === ''
      ) {
        return true;
      }
    }
    return false;
  }

  closePanels() {
    if (this.sensorPanel) this.sensorPanel.close();
    if (this.cloudPanel) this.cloudPanel.close();
  }

  onSensorPanelOpen() {
    this.openPanel();
    if (
      this.sensorList &&
      this.loadTaskCostDetails() &&
      this.taskStrategy != 'Tip-and-Cue'
    ) {
      this.sensorList.loadTaskingSensors(this.target);
    }
    if (
      this.sensorList &&
      this.loadTaskCostDetails() &&
      this.taskStrategy === 'Tip-and-Cue' &&
      this.subStrategy == 'Tip-and-Cue'
    ) {
      this.sensorList.loadTipAndCueingSensors(this.target);
    }
  }
  getObservationList(openWater?: any) {
    this.rule = null;
    this.target.rule = null;
    this.observation = null;
    this.target.observation = null;
    this.feeds = null;
    this.target.feeds = null;
    this.apiService.getObservations(openWater).subscribe((res: any) => {
      this.observationOptions = res?.observations;
      this.rulesOptions = res?.ruleBased;
      this.feedList = res?.feeds;
    });
  }

  openPanel() {
    this.formGroup.get('target')?.enable(); // Enable control
    this.formGroup.markAllAsTouched(); // This will make all controls show validation errors if any
    this.formGroup.updateValueAndValidity();
  }

  openCloudCover() {
    this.openPanel();
    if (this.budget) {
      this.budgetForm.markAllAsTouched();
    }
    this.cloudclicked = false;
    if (this.loadTaskCostDetails() || !this.budgetForm?.invalid) {
      this.getCloudData(true, 0);
    }
  }

  confirmLocation() {
    setTimeout(() => {
      const dialogRef = this.dialog.open(ConfirmPopupComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { message: 'location' },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'no') {
          this.resetMap();
        }
      });
    }, 2000); //2second
  }

  loadUserDetails(userId): void {
    if (userId) {
      this.userService.personalInfo(userId).subscribe({
        next: (res: any) => {
          this.currentUser = res;
          this.currentLocalTime = this.utilsService.getCurrentLocalTime(
            this.currentUser
          );
          this.userTimezone = this.utilsService.getTimezoneFromCountry(
            this.currentUser.country
          );
        },
        error: (error) => {},
      });
    }
  }
  outcomeSensorTypes(userId: string) {
    this.apiService.getOutcomeSensorTypes(userId).subscribe((res: any) => {
      if (res) {
        this.SensorsTypes = this.apiService.SENSORSTYPE.filter((sensor) =>
          res?.sensorTypes.includes(sensor.value)
        );
      }
      this.filteredSensorTypes = this.SensorsTypes.filter(
        (item) => item.feasibility === true
      );
    });
  }
  tleSensorTypes(userId: string, intentId?: string) {
    this.apiService
      .getOutcomeSensorTypes(userId, intentId)
      .subscribe((res: any) => {
        if (res?.sensorTypes?.length > 0) {
          this.SensorsTypes = this.apiService.SENSORSTYPE.filter((sensor) =>
            res?.sensorTypes.includes(sensor.value)
          );
          this.filteredSensorTypes = this.SensorsTypes.filter(
            (item) => item.feasibility === true
          );
        } else {
          const message =
            'No sensors are meeting the selected intent. Please change the intent and try again.';
          const dialogRef = this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
          dialogRef.afterClosed().subscribe((result) => {
            this.formGroup.get('intent')?.setValue(null);
            this.formGroup.get('intent')?.markAsPristine();
            this.formGroup.get('intent')?.markAsUntouched();
            this.target.intent = null;
          });
          this.filteredSensorTypes = [];
        }
      });
  }
  shouldEnableCancelButton(data: any, formData: FormGroup): boolean {
    const isValid = (value: any): boolean => {
      return value !== null && value !== undefined && value !== '';
    };

    const requiredDataFields = [
      data.geoJSON,
      data.project,
      data.taskname,
      data.taskStrategy,
      data.purposeOption,
      data.intent,
      data.openWindow,
      data.closeWindow,
    ];

    const dataFieldsValid = requiredDataFields.every((field) => isValid(field));

    // Check if tleSensorForm is valid and has values
    const formValid = formData && formData.valid;

    // Check if form controls have non-empty values
    const sensorTypeValid = isValid(formData?.get('sensorType')?.value);
    const resolutionValid = isValid(formData?.get('resolution')?.value);
    const sensorValid = isValid(formData?.get('sensor')?.value);

    const formFieldsValid = sensorTypeValid && resolutionValid && sensorValid;
    const additionalConditions =
      this.mapLoading === false && this.showtleClick === true;
    // All conditions must be true for cancel button to be enabled
    return (
      dataFieldsValid && formValid && formFieldsValid && additionalConditions
    );
  }
  get isTleTrackingEnabled(): boolean {
    const geoValid = !!this.target?.geoJSON;
    const sensorValid = !!this.tleSensorForm?.value?.sensor;
    const isValid = (value: any): boolean => {
      return value !== null && value !== undefined && value !== '';
    };

    const startTimeValid = isValid(this.formGroup?.get('startTime')?.value);
    const endTimeValid = isValid(this.formGroup?.get('endTime')?.value);
    return (
      geoValid &&
      sensorValid &&
      startTimeValid &&
      endTimeValid &&
      !this.showtleDisabled
    );
  }
  clearTLEOnly(): void {
    if (!this.map) return;
    if (this.satLayer) {
      this.satLayer.clearLayers();
      this.map.removeLayer(this.satLayer);
      this.satLayer = null;
    }
  }
  calculateObservation(data) {
    this.target.geoJSONCue = this.utilsService.getGeoJsonData(data);
    if (!this.checkObservationInsideMap()) {
      return false;
    }
    this.setObservationValues(data);
    return true;
  }

  setObservationValues(data) {
    let geoJsonType = this.target.geoJSONCue.includes('POINT')
      ? 'Point'
      : 'Polygon';
    this.target.observationTypeCue = geoJsonType;
    if (geoJsonType === 'Point') {
      this.target.areaCue = 0;
    } else {
      const points: [number, number][] = data
        .split(';')
        .map((item) => item.split(',').map(Number) as [number, number]);
      let areaCue = this.utilsService.calculateAreaUsingTurf(points);
      this.target.areaCue = (areaCue / 1e6).toFixed(2);
    }
  }

  checkObservationInsideMap(): boolean {
    let observationCoordinate = '';
    let mapCoordinate = '';
    if (this.target.geoJSON.includes('POINT'))
      mapCoordinate = geoParse(this.target.geoJSON).coordinates;
    else mapCoordinate = geoParse(this.target.geoJSON).coordinates[0];

    if (this.target.geoJSONCue.includes('POINT'))
      observationCoordinate = geoParse(this.target.geoJSONCue).coordinates;
    else
      observationCoordinate = geoParse(this.target.geoJSONCue).coordinates[0];

    if (this.target.geoJSONCue.includes('POINT')) {
      // observation in POI
      if (
        this.target.geoJSON.includes('POINT') &&
        this.utilsService.arePointsSame(observationCoordinate, mapCoordinate)
      )
        //map is POI
        return true;
      else if (
        this.utilsService.pointAllInPolygon(
          observationCoordinate,
          mapCoordinate
        )
      )
        // map is AOI
        return true;
    } else {
      //observation is AOI
      if (
        this.target.geoJSON.includes('POINT') &&
        this.utilsService.pointAllInPolygon(
          mapCoordinate,
          observationCoordinate
        )
      ) {
        //map is POI
        return true;
      } else if (
        this.utilsService.comparePolygons(observationCoordinate, mapCoordinate)
      ) {
        //map is AOI
        return true;
      }
    }
    return false;
  }

  resetControlsBelow(controlName: string) {
    if (this.selectedCategory === STRINGCONSTANTS.NON_IMAGING_SENSOR) {
      if (this.target.geoJSON?.includes('POINT') && this.target.geoJSON?.match(/POINT/g).length > 0)
        return;
      const startIndex = this.controlOrder.indexOf(controlName);
      if (startIndex === -1) return;

      for (let i = startIndex + 1; i < this.controlOrder.length; i++) {
        const ctrl = this.budgetForm.get(this.controlOrder[i]);
        if (ctrl) {
          ctrl.setValue(null, { emitEvent: false });
        }
      }
    }
  }

  
keepOpen(event: Event) {
  event.stopPropagation(); // Prevent select from closing
}

onSignalToggle(option: any, event: MatCheckboxChange) {
  if (event.checked) {
    // Add
    if (!this.selectedSignals.includes(option)) {
      this.selectedSignals.push(option);
    }

    if (!this.checkSelection()) {
      // Selection rule failed → revert
      this.selectedSignals = this.selectedSignals.filter(o => o !== option);
      event.source.checked = false;
      return;
    }
  } 
  else {
    // Remove
    this.selectedSignals = this.selectedSignals.filter(o => o !== option);
    this.audioSelections = this.audioSelections.filter(a => a !== option);
  }

  this.updateDisplay(event.checked);
}

  uncheckSignal(option: any, event: MatCheckboxChange) {
    event.source.checked = !event.source.checked;
    this.selectedSignals = this.selectedSignals.filter(o => o !== option);
    this.audioSelections = this.audioSelections.filter(a => a !== option);
  }

  onAudioToggle(option: any, event: any) {
    option.audioChecked = event.checked;
    if (event.checked) {
      this.audioSelections.push(option);
    } else {
      this.audioSelections = this.audioSelections.filter(a => a !== option);
    }
    this.updateDisplay(event.checked); // refresh trigger text
  }

  getSelectedDisplay(): string {
    const result = this.selectedSignals
      .map(opt => {
        const hasAudio = this.audioSelections.includes(opt);
        return hasAudio ? `${opt.value} (Audio)` : opt.value;
      })
      .join(', ');
    this.selectedDisplay = result;
    this.cdr.detectChanges();
    return result;
  }
  updateDisplay(isOpen: boolean) {
    this.selectedDisplay = this.getSelectedDisplay();const control = this.budgetForm.get('rfSignals');
    if (control) {
      control.setValue(this.selectedSignals, { emitEvent: false });
      control.markAsTouched();
    }
    this.budgetForm.get('rfSignals')?.setValue(this.selectedSignals);
    if (isOpen) {
      this.preventMatSelectClose();
    }
  }

  showRfSignals(): boolean {
    let showRF = this.selectedCategory === this.nonImagingSensor && this.budgetForm.get('sensorType')?.value?.sensor === this.rfType;
    if (showRF){
      this.generateRFCollections();
    }
    return showRF;
  }

  resetRfSignals() {
    this.selectedDisplay = '';
    this.selectedSignals = [];
    this.budgetForm.patchValue({
      rfSignals: '',
      rawIQData: false
    });
  }

  checkSelection(): boolean {
    let selectedSignals = this.selectedSignals.filter(sensor => {
      return Array.isArray(sensor.collection_duration) && sensor.collection_duration.length > 0;
    });

    // Define categories
    const gps = ['GPS L1', 'GPS L2', 'GPS L5'];
    const vhf = ['VHF'];
    const uhf = ['UHF'];
    const lBand = ['L-band (ADS-B)', 'L-band (GNSS)', 'L-band (SATCOM)'];
    const sBand = ['S-band'];
    // Separate signals into categories
    const selectedGPS = selectedSignals.filter(s => gps.includes(s.value));
    const selectedVHF = selectedSignals.filter(s => vhf.includes(s.value));
    const selectedUHF = selectedSignals.filter(s => uhf.includes(s.value));
    const selectedLBand = selectedSignals.filter(s => lBand.includes(s.value));
    const selectedsBand = selectedSignals.filter(s => sBand.includes(s.value));
    // Rule: Only one GPS signal can be selected at a time
    if (selectedGPS.length > 1) {
      const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
      //this.selectedSignals = this.selectedSignals.filter(o => o !== option);
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      return false;
    }
    if (selectedSignals.length > 1 &&  selectedsBand.length >0) {
      const message = `You can request a maximum of three signals when combining UHF, VHF, and
                  L-Band, charged individually, for the same price in a single task. You can
                  request all the other signals individually.`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      return false;
    }
    // Check for invalid combinations
    if (selectedGPS.length > 0) {
        if (selectedSignals.length > selectedGPS.length) {
          const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
         // this.selectedSignals = this.selectedSignals.filter(o => o !== option);
          return false;
        }
    } else {
        // Validate non-GPS selections
        if (selectedVHF.length + selectedUHF.length + selectedLBand.length > 3) {
          const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
          return false;
        }
        if (selectedVHF.length > 1 || selectedUHF.length > 1 || selectedLBand.length > 1) {
          const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
          return false;
        }
    }
    return true;
  }

  generateRFCollections() {
    this.RFCollections = Array.from(
    { length: this.maxRFCollection - this.minRFCollection + 1 },
    (_, i) => this.minRFCollection + i
    );
  }

  isBroRF() {
    this.isBroRFSelected =this.budgetInputs?.rfSignals && this.budgetInputs?.rfSignals?.some(item => item.value.includes('S-band, X-band'));
    return this.isBroRFSelected;
  }

  onOpenedChange(isOpen: boolean) {
    if (isOpen) {
      this.preventMatSelectClose();
    }
  }
  private preventMatSelectClose() {
    if (this.signalSelect && !this.originalClose) {
      // Save the original close method
      this.originalClose = this.signalSelect.close;

      // Override the close method
      this.signalSelect.close = () => {};
    }
  }
  close(mySelect: MatSelect, event: Event): void {
    this.restoreMatSelectClose();
    event.stopPropagation(); // Prevent propagation
    mySelect.close(); // Close the dropdown
  }
  private restoreMatSelectClose() {
    if (this.signalSelect && this.originalClose) {
      this.signalSelect.close = this.originalClose;
      this.originalClose = null;
    }
  }

  resetCategory() {
    this.selectedCategory = this.imagingSensor;
    this.updateFrequencyOption = false;
    this.budgetSensorType = [];
    const sensorCategoryControl = this.budgetForm.get('sensorCategory');
    this.resetForm();
    sensorCategoryControl?.setValue(this.selectedCategory);
    this.disableEnableDrawControls(true, 'reset');
    this.showResolution =
       this.selectedCategory !== STRINGCONSTANTS.NON_IMAGING_SENSOR;
  }

  displayBudgetPopup(event: any) {
    if (this.budgetForm?.value?.sensorType.sensor === 'HSI'){
      if (event.value.key === '5.3m') {
        const message =`
        <ol>
          <li>The task needs to be an area of interest (AOI). Please draw a polygon.</li>
          <li>Each side of the polygon must be at least 5 km.</li>
          <li>The total area of the polygon cannot exceed 400 sqkm. You can find the size of your area at the top of the map after you draw or upload the polygon.</li>
          <li>The start of the time of interest (TOI) must be at least three days after the submission date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
      } else if (event.value.key === '10m'  && this.budgetForm?.value?.sensorType.sensor === 'HSI'){
        const message = `
        <ol>
          <li> The sensor does not have cloud cover and holdback selection options.</li>
          <li> The start of the time of interest (TOI) must be at least three days after the submission date and the end date is within 14 days from the submission date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
      }
    }
  }

 hasFeature(key: string): boolean {
  return this.currentUser?.planDetails?.features?.some(feature => feature.key === key);
 }
}
